<template>
    <div id="v-Protestantism-wrap">
        <!-- 顶部栏 -->
        <div class="head">
            <dl>
                <dt>
                    <img class="logo" :src="$config.resource + 'dhl_logo.png'" alt="">
                </dt>
                <!-- 头像信息 -->
                <dd>
                    <div class="portrait">
                        <img class="pic" :src="user.head" alt="">
                    </div>
                    <p>{{user.company_name}}</p>
                    <div class="quit" @click="onQuit">
                        <img class="icon" :src="$config.resource + 'tc.png'" alt="">
                    </div>
                </dd>
            </dl>
        </div>
        <div class="main_wrap">
            <!-- 背景图 -->
            <img class="bj_pic" :src="$config.resource + 'bj_xin.png'" alt="">
            <!-- 顶部图片 -->
            <div class="top_wrap">
                <img class="pic" :src="$config.resource + 'pic.png'" alt="">
                <div class="name">play with lyric</div>
            </div>
            <!-- 合作申请流程 -->
            <figure v-if="isType==1">
                <h6>合作申请流程</h6>
                <div class="wire"></div>
            </figure>
            <!-- 背景图线型图 -->
            
            <canvas v-if="isType==1" class="bj_pic_two" id="J_dotLine" style="background-color: #F7F7F7;"></canvas>
            <!-- <img v-if="isType==1" class="bj_pic_two" :src="$config.resource + 'dt_xxt.gif'" alt=""> -->
            <!-- 流程状态 -->
            <div class="flow_box" v-if="isType==1">
                <div class="flow">
                    <!-- 流程1 -->
                    <div class="flow_alike">
                        <!-- 当前步骤显示 -->
                        <div class="Baymax" v-if="flow.write1==2">
                            <div class="icon_box">
                                <!-- 图标 -->
                                <img class="icon" :src="$config.resource + 'jctx_dq.png'">
                                <!-- 线图 -->
                                <img class="wire" :src="$config.resource + 'xt_curr.png'">
                            </div>
                            <div class="depict">基础信息填写</div>
                            <div class="btn" @click="onWrite_one">立即填写</div>
                        </div>
                        <!-- 已通过当前步骤显示 -->
                        <div class="via" v-if="flow.write1==1&&flow.status1!=1">
                            <div class="icon_box">
                                <!-- 图标 -->
                                <img class="icon" :src="$config.resource + 'jctx.png'">
                                <!-- 线图 -->
                                <img class="wire" :src="$config.resource + 'xt.png'">
                            </div>
                            <div class="depict">基础信息填写</div>
                            <div class="btn">已填写</div>
                        </div>
                        <!-- 重新填写 -->
                        <div class="anew" v-if="flow.status1==1">
                            <div class="icon_box">
                                <!-- 图标 -->
                                <img class="icon" :src="$config.resource + 'jctx_dq.png'">
                                <!-- 线图 -->
                                <img class="wire" :src="$config.resource + 'xt_curr.png'">
                            </div>
                            <div class="depict">基础信息填写</div>
                            <div class="btn" @click="onWrite_one">重新填写</div>
                        </div>
                    </div>
                    <div class="flex-1"></div>
                    <!-- 流程2 -->
                    <div class="flow_alike">
                        <!-- 当前步骤显示 -->
                        <div class="Baymax" v-if="flow.write1==1&&flow.write2==2">
                            <div class="icon_box">
                                <!-- 图标 -->
                                <img class="icon" v-if="flow.status1!=2" :src="$config.resource + 'sh_curr.png'">
                                 <!-- 通过图标 -->
                                <img class="icon" v-if="flow.status1==2" :src="$config.resource + 'ygsh.png'">
                                
                                <!-- 线图 -->
                                <img class="wire" :src="$config.resource + 'xt_curr.png'">
                            </div>
                            <div class="depict" v-if="flow.status1!=2">信息审核</div>
                            <div class="isverify" v-if="flow.status1==2">信息审核</div>
                            <div class="btn" v-if="flow.status1==3">等待审核</div>
                            <div class="btn" v-if="flow.status1==1">审核失败</div>
                            <div class="btn green" v-if="flow.status1==2">审核通过</div>
                        </div>
                        <!-- 未到当前步骤显示 -->
                        <div class="clear" v-if="flow.write1==2">
                            <div class="icon_box">
                                <!-- 图标 -->
                                <img class="icon" :src="$config.resource + 'sh.png'">
                                <!-- 线图 -->
                                <img class="wire" :src="$config.resource + 'xt.png'">
                            </div>
                            <div class="depict">信息审核</div>
                            <div class="btn">等待审核</div>
                        </div>
                        <!-- 已通过当前步骤显示 -->
                        <div class="via" v-if="flow.write2==1">
                            <div class="icon_box">
                                <!-- 图标 -->
                                <img class="icon" :src="$config.resource + 'ygsh.png'">
                                <!-- 线图 -->
                                <img class="wire" :src="$config.resource + 'xt.png'">
                            </div>
                            <div class="depict">信息审核</div>
                            <div class="btn">审核通过</div>
                        </div>
                    </div>
                    <div class="flex-1"></div>
                    <!-- 流程3 -->
                    <div class="flow_alike">
                        <!-- 当前步骤显示 -->
                        <div class="Baymax" v-if="flow.status1==2&&flow.write2==2">
                            <div class="icon_box">
                                <!-- 图标 -->
                                <img class="icon" :src="$config.resource + 'xxtx_curr.png'">
                                <!-- 线图 -->
                                <img class="wire" :src="$config.resource + 'xt_curr.png'">
                            </div>
                            <div class="depict">详细信息填写</div>
                            <div class="btn" @click="onWrite_two">立即填写</div>
                        </div>
                        <!-- 已通过当前步骤显示 -->
                        <div class="via" v-if="flow.write2==1&&flow.status2!=1">
                            <div class="icon_box">
                                <!-- 图标 -->
                                <img class="icon" :src="$config.resource + 'xxtx.png'">
                                <!-- 线图 -->
                                <img class="wire" :src="$config.resource + 'xt.png'">
                            </div>
                            <div class="depict">详细信息填写</div>
                            <div class="btn">已填写</div>
                        </div>
                        <!-- 未到当前步骤显示 -->
                        <div class="clear" v-if="flow.write2==2&&flow.status1!=2">
                            <div class="icon_box">
                                <!-- 图标 -->
                                <img class="icon" :src="$config.resource + 'xxtx.png'">
                                <!-- 线图 -->
                                <img class="wire" :src="$config.resource + 'xt.png'">
                            </div>
                            <div class="depict">详细信息填写</div>
                            <div class="btn">立即填写</div>
                        </div>
                        <!-- 重新填写 -->
                        <div class="anew" v-if="flow.write2==1&&flow.status2==1">
                            <div class="icon_box">
                                <!-- 图标 -->
                                <img class="icon" :src="$config.resource + 'xxtx_curr.png'">
                                <!-- 线图 -->
                                <img class="wire" :src="$config.resource + 'xt_curr.png'">
                            </div>
                            <div class="depict">详细信息填写</div>
                            <div class="btn" @click="onWrite_two">重新填写</div>
                        </div>
                    </div>
                    <div class="flex-1"></div>
                    <!-- 流程4 -->
                    <div class="flow_alike">
                        <!-- 当前步骤显示 -->
                        <div class="Baymax" v-if="flow.write2==1">
                            <div class="icon_box">
                                <!-- 图标 -->
                                <img class="icon" v-if="flow.status2!=2" :src="$config.resource + 'sh_curr.png'">
                                <!-- 通过图标 -->
                                <img class="icon" v-if="flow.status2==2" :src="$config.resource + 'ygsh.png'">
                            </div>
                            <div class="depict" v-if="flow.status2!=2">信息审核</div>
                            <div class="isverify" v-if="flow.status2==2">信息审核</div>
                            <div class="btn" v-if="flow.status2==3">等待审核</div>
                            <div class="btn" v-if="flow.status2==1">审核失败</div>
                            <div class="btn green" v-if="flow.status2==2">审核成功</div>
                        </div>
                        <!-- 未到当前步骤显示 -->
                        <div class="clear" v-if="flow.write2==2">
                            <div class="icon_box">
                                <!-- 图标 -->
                                <img class="icon" :src="$config.resource + 'sh.png'">
                            </div>
                            <div class="depict">信息审核</div>
                            <div class="btn">等待审核</div>
                        </div>
                    </div>

                    <!-- 流程1
                    <div class="alike_box">
                        当前步骤显示
                        <div class="Baymax" v-if="flow.write1==2">
                            <div class="circle_wire">
                                <div class="circle"></div>
                                <div class="wire"></div>
                            </div>
                            <div class="row">
                                <img class="db_bg" :src="$config.resource + 'dqbz.png'">
                                <div class="bag">
                                    <img class="icon" :src="$config.resource + 'nrtx.png'">
                                    <p>基础信息填写</p>
                                </div>
                            </div>
                            <div class="btn" @click="onWrite_one">立即填写</div>
                        </div>
                        已通过当前步骤显示
                        <div class="via" v-if="flow.write1==1&&flow.status1!=1">
                            <div class="circle_wire">
                                <div class="circle"></div>
                                <div class="wire"></div>
                            </div>
                            <div class="row">
                                <img class="db_bg" :src="$config.resource + 'bsdqbz.png'">
                                <div class="bag">
                                    <img class="icon" :src="$config.resource + 'nrtx.png'">
                                    <p>基础信息填写</p>
                                </div>
                            </div>
                            <div class="btn">已填写</div>
                        </div>
                        重新填写
                        <div class="anew" v-if="flow.status1==1">
                            <div class="circle_wire">
                                <div class="circle"></div>
                                <div class="wire"></div>
                            </div>
                            <div class="row">
                                <img class="db_bg" :src="$config.resource + 'dqbz.png'">
                                <div class="bag">
                                    <img class="icon" :src="$config.resource + 'nrtx.png'">
                                    <p>基础信息填写</p>
                                </div>
                            </div>
                            <div class="btn" @click="onWrite_one">重新填写</div>
                        </div>
                    </div> -->
                    <!-- 流程2
                    <div class="alike_box">
                        当前步骤显示
                        <div class="Baymax" v-if="flow.write1==1&&flow.write2==2">
                            <div class="circle_wire">
                                <div class="circle"></div>
                                <div class="wire"></div>
                            </div>
                            <div class="row">
                                <img class="db_bg" :src="$config.resource + 'dqbz.png'">
                                <div class="bag">
                                    审核中
                                    <img class="icon" v-if="flow.status1==3" :src="$config.resource + 'shz.png'">
                                    审核失败
                                    <img class="icon" v-if="flow.status1==1" :src="$config.resource + 'shsb.png'">
                                    审核成功
                                    <img class="icon" v-if="flow.status1==2" :src="$config.resource + 'shcg.png'">
                                    <p>信息审核</p>
                                </div>
                            </div>
                            <div class="btn" v-if="flow.status1==3">审核中</div>
                            <div class="btn" v-if="flow.status1==1">审核失败</div>
                            <div class="btn" v-if="flow.status1==2">审核成功</div>
                        </div>
                        未到当前步骤显示
                        <div class="clear" v-if="flow.write1==2">
                            <div class="circle_wire">
                                <div class="circle"></div>
                                <div class="wire"></div>
                            </div>
                            <div class="row">
                                <img class="db_bg" :src="$config.resource + 'bsdqbz.png'">
                                <div class="bag">
                                    <img class="icon" :src="$config.resource + 'shz.png'">
                                    <p>信息审核</p>
                                </div>
                            </div>
                            <div class="btn">等待审核</div>
                        </div>
                        已通过当前步骤显示
                        <div class="via" v-if="flow.write2==1">
                            <div class="circle_wire">
                                <div class="circle"></div>
                                <div class="wire"></div>
                            </div>
                            <div class="row">
                                <img class="db_bg" :src="$config.resource + 'bsdqbz.png'">
                                <div class="bag">
                                    <img class="icon" :src="$config.resource + 'shcg.png'">
                                    <p>信息审核</p>
                                </div>
                            </div>
                            <div class="btn">审核成功</div>
                        </div>
                    </div> -->
                    <!-- 流程3
                    <div class="alike_box">
                        当前步骤显示
                        <div class="Baymax" v-if="flow.status1==2&&flow.write2==2">
                            <div class="circle_wire">
                                <div class="circle"></div>
                                <div class="wire"></div>
                            </div>
                            <div class="row">
                                <img class="db_bg" :src="$config.resource + 'dqbz.png'">
                                <div class="bag">
                                    <img class="icon" :src="$config.resource + 'nrtx.png'">
                                    <p>详细信息填写</p>
                                </div>
                            </div>
                            <div class="btn" @click="onWrite_two">立即填写</div>
                        </div>
                        已通过当前步骤显示
                        <div class="via" v-if="flow.write2==1&&flow.status2!=1">
                            <div class="circle_wire">
                                <div class="circle"></div>
                                <div class="wire"></div>
                            </div>
                            <div class="row">
                                <img class="db_bg" :src="$config.resource + 'bsdqbz.png'">
                                <div class="bag">
                                    <img class="icon" :src="$config.resource + 'nrtx.png'">
                                    <p>详细信息填写</p>
                                </div>
                            </div>
                            <div class="btn">已填写</div>
                        </div>
                        未到当前步骤显示
                        <div class="via" v-if="flow.write2==2&&flow.status1!=2">
                            <div class="circle_wire">
                                <div class="circle"></div>
                                <div class="wire"></div>
                            </div>
                            <div class="row">
                                <img class="db_bg" :src="$config.resource + 'bsdqbz.png'">
                                <div class="bag">
                                    <img class="icon" :src="$config.resource + 'nrtx.png'">
                                    <p>详细信息填写</p>
                                </div>
                            </div>
                            <div class="btn">立即填写</div>
                        </div>
                        重新填写
                        <div class="anew" v-if="flow.write2==1&&flow.status2==1">
                            <div class="circle_wire">
                                <div class="circle"></div>
                                <div class="wire"></div>
                            </div>
                            <div class="row">
                                <img class="db_bg" :src="$config.resource + 'dqbz.png'">
                                <div class="bag">
                                    <img class="icon" :src="$config.resource + 'nrtx.png'">
                                    <p>详细信息填写</p>
                                </div>
                            </div>
                            <div class="btn" @click="onWrite_two">重新填写</div>
                        </div>
                    </div> -->
                    <!-- 流程4
                    <div class="alike_box">
                        当前步骤显示
                        <div class="Baymax" v-if="flow.write2==1">
                            <div class="circle_wire">
                                <div class="circle"></div>
                            </div>
                            <div class="row">
                                <img class="db_bg" :src="$config.resource + 'dqbz.png'">
                                <div class="bag">
                                    审核中
                                    <img class="icon" v-if="flow.status2==3" :src="$config.resource + 'shz.png'">
                                    审核失败
                                    <img class="icon" v-if="flow.status2==1" :src="$config.resource + 'shsb.png'">
                                    审核成功
                                    <img class="icon" v-if="flow.status2==2" :src="$config.resource + 'shcg.png'">
                                    <p>信息审核</p>
                                </div>
                            </div>
                            <div class="btn" v-if="flow.status2==3">审核中</div>
                            <div class="btn" v-if="flow.status2==1">审核失败</div>
                            <div class="btn" v-if="flow.status2==2">审核成功</div>
                        </div>
                        未到当前步骤显示
                        <div class="clear" v-if="flow.write2==2">
                            <div class="circle_wire">
                                <div class="circle"></div>
                            </div>
                            <div class="row">
                                <img class="db_bg" :src="$config.resource + 'bsdqbz.png'">
                                <div class="bag">
                                    <img class="icon" :src="$config.resource + 'shz.png'">
                                    <p>信息审核</p>
                                </div>
                            </div>
                            <div class="btn">等待审核</div>
                        </div>
                    </div> -->
                </div>
                <!-- 填写操作指导 -->
                <div class="guidance" v-if="flow.status2!=2" @click="onPreview">填写操作指导</div>
                <!-- 查看填写 -->
                <div class="btn_wrap" v-if="flow.status2==2" @click="onCheck">查看填写信息</div>
            </div>
            <!-- 基础信息填写 -->
            <div class="write_box" v-if="isBasics">
                <figure>
                    <h6>基础信息填写</h6>
                    <div class="wire"></div>
                </figure>
                <!-- 供应商类型 -->
                <div class="alike">
                    <ul class="supply_box">
                        <li>
                            <div class="name">
                                <p>*</p>
                                <div class="tt">供应商类型：</div>
                            </div>
                            <el-select class="elect" v-model="provision_name" @change="getProvision">
                                <el-option
                                v-for="item in provision"
                                :key="item.name"
                                :label="item.name"
                                :value="item">
                                </el-option>
                            </el-select>
                        </li>
                        <li>
                            <div class="name">
                                <p>*</p>
                                <div class="tt">具体类型：</div>
                            </div>
                            <el-select class="elect" v-model="definite_name" @change="getDefinite">
                                <el-option
                                v-for="item in definite"
                                :key="item.name"
                                :label="item.name"
                                :value="item">
                                </el-option>
                            </el-select>
                        </li>
                    </ul>
                </div>
                <!-- 基础信息 -->
                <div class="alike">
                    <div class="top_box">
                        <div class="pattern"></div>
                        <p>基础信息</p>
                    </div>
                    <ul>
                        <li>
                            <div class="name">
                                <p>*</p>
                                <div class="tt">企业名称（全称）：</div>
                            </div>
                            <div class="inp_unit">
                                <input class="inp" type="text" v-model="firm_name" placeholder="需与营业执照保持一致" />
                            </div>
                        </li>
                        <li>
                            <div class="name">
                                <p>*</p>
                                <div class="tt">统一社会信用代码：</div>
                            </div>
                            <div class="inp_unit">
                                <input class="inp" type="text" v-model="credit_code" placeholder="需与营业执照保持一致" />
                            </div>
                        </li>
                        <li>
                            <div class="name">
                                <p>*</p>
                                <div class="tt">成立年份：</div>
                            </div>
                            <el-date-picker
                                v-model="establish"
                                type="date"
                                value-format="yyyy-MM-dd"
                                placeholder="需与营业执照保持一致">
                            </el-date-picker>
                        </li>
                        <li>
                            <div class="name">
                                <p>*</p>
                                <div class="tt">法人代表：</div>
                            </div>
                            <div class="inp_unit">
                                <input class="inp" type="text" v-model="delegate" placeholder="需与营业执照保持一致" />
                            </div>
                        </li>
                        <li>
                            <div class="name">
                                <p>*</p>
                                <div class="tt">法人代表职务：</div>
                            </div>
                            <div class="inp_unit">
                                <input class="inp" type="text" v-model="post" />
                            </div>
                        </li>
                        <li>
                            <div class="name">
                                <p>*</p>
                                <div class="tt">法人联系电话：</div>
                            </div>
                            <div class="inp_unit">
                                <input class="inp" type="number" v-model="phone" />
                            </div>
                        </li>
                        <li>
                            <div class="name">
                                <p>*</p>
                                <div class="tt">对账人：</div>
                            </div>
                            <div class="inp_unit">
                                <input class="inp" type="text" v-model="checker_pos"  />
                            </div>
                        </li>
                        <li>
                            <div class="name">
                                <p>*</p>
                                <div class="tt">对账人电话：</div>
                            </div>
                            <div class="inp_unit">
                                <input class="inp" type="number" v-model="checker_phone" />
                            </div>
                        </li>
                        <li>
                            <div class="name">
                                <p>*</p>
                                <div class="tt">对账人邮箱：</div>
                            </div>
                            <div class="inp_unit">
                                <input class="inp" type="text" v-model="checker_email" />
                            </div>
                        </li>
                        <li>
                            <div class="name">
                                <p>*</p>
                                <div class="tt">业务对接人：</div>
                            </div>
                            <div class="inp_unit">
                                <input class="inp" type="text" v-model="abutment" />
                            </div>
                        </li>
                        <li>
                            <div class="name">
                                <p>*</p>
                                <div class="tt">业务对接人职务：</div>
                            </div>
                            <div class="inp_unit">
                                <input class="inp" type="text" v-model="job" />
                            </div>
                        </li>
                        <li>
                            <div class="name">
                                <p>*</p>
                                <div class="tt">业务对接人联系电话：</div>
                            </div>
                            <div class="inp_unit">
                                <input class="inp" type="number" v-model="telephone" />
                            </div>
                        </li>
                        <li>
                            <div class="name">
                                <p>*</p>
                                <div class="tt">业务对接人E-mail：</div>
                            </div>
                            <div class="inp_unit">
                                <input class="inp" type="text" v-model="gmail" />
                            </div>
                        </li>
                        <li>
                            <div class="name">
                                <p>*</p>
                                <div class="tt">经营范围：</div>
                            </div>
                            <div class="inp_unit">
                                <input class="inp" type="text" v-model="run" placeholder="需与营业执照保持一致" />
                            </div>
                        </li>
                        <li>
                            <div class="name">
                                <p>*</p>
                                <div class="tt">行业类别：</div>
                            </div>
                            <div class="inp_unit">
                                <input class="inp" type="text" v-model="trade" />
                            </div>
                        </li>
                        <li>
                            <div class="name">
                                <!-- <p></p> -->
                                <div class="tt interval">企业网址：</div>
                            </div>
                            <div class="inp_unit">
                                <input class="inp" type="text" v-model="url" />
                            </div>
                        </li>
                        <li>
                            <div class="name">
                                <p>*</p>
                                <div class="tt">注册地址：</div>
                            </div>
                            <div class="inp_unit">
                                <input class="inp" type="text" v-model="address" placeholder="需与营业执照保持一致" />
                            </div>
                        </li>
                        <li>
                            <div class="name">
                                <p>*</p>
                                <div class="tt">通信地址：</div>
                            </div>
                            <div class="inp_unit">
                                <input class="inp" type="text" v-model="site" />
                            </div>
                        </li>
                        <li>
                            <div class="name">
                                <p>*</p>
                                <div class="tt">注册资本：</div>
                            </div>
                            <div class="inp_unit">
                                <input class="inp" type="number" v-model="principal" placeholder="需与营业执照保持一致" />
                                <div class="unit">万元</div>
                            </div>
                        </li>
                        <li>
                            <div class="name">
                                <p>*</p>
                                <div class="tt">资产总值：</div>
                            </div>
                            <div class="inp_unit">
                                <input class="inp" type="number" v-model="company_money" />
                                <div class="unit">万元</div>
                            </div>
                        </li>
                        <li>
                            <div class="name">
                                <p>*</p>
                                <div class="tt">上年度销售额：</div>
                            </div>
                            <div class="inp_unit">
                                <input class="inp" type="number" v-model="saleroom" />
                                <div class="unit">万元</div>
                            </div>
                        </li>
                    </ul>
                    <dl class="basics_box">
                        <dt>
                            <p>*</p>
                            <div class="short">
                                <em>纳税人类别：</em>
                            </div>
                        </dt>
                        <dd>
                            <div class="unify" :class="{curr:ratepaying == 1}" @click="onRatepaying(1)">
                                <!-- 未选中 -->
                                <img class="icon" v-if="ratepaying!=1" :src="$config.resource + 'wxz.png'" alt="">
                                <!-- 已选中 -->
                                <img class="icon" v-if="ratepaying==1" :src="$config.resource + 'xz.png'" alt="">
                                <p>小规模纳税</p>
                            </div>
                            <div class="unify" :class="{curr:ratepaying == 2}" @click="onRatepaying(2)">
                                <!-- 未选中 -->
                                <img class="icon" v-if="ratepaying!=2" :src="$config.resource + 'wxz.png'" alt="">
                                <!-- 已选中 -->
                                <img class="icon" v-if="ratepaying==2" :src="$config.resource + 'xz.png'" alt="">
                                <p>一般纳税人</p>
                            </div>
                        </dd>
                    </dl>
                    <dl class="basics_box">
                        <dt>
                            <p>*</p>
                            <div class="short">
                                <em>税</em>
                                <div class="flex-1"></div>
                                <em>率：</em>
                            </div> 
                        </dt>
                        <dd>
                            <div class="unify" :class="{curr:taxRate == 1}" @click="onTaxRate(1)">
                                <!-- 未选中 -->
                                <img class="icon" v-if="taxRate!=1" :src="$config.resource + 'wxz.png'" alt="">
                                <!-- 已选中 -->
                                <img class="icon" v-if="taxRate==1" :src="$config.resource + 'xz.png'" alt="">
                                <p>13%</p>
                            </div>
                            <div class="unify" :class="{curr:taxRate == 2}" @click="onTaxRate(2)">
                                <!-- 未选中 -->
                                <img class="icon" v-if="taxRate!=2" :src="$config.resource + 'wxz.png'" alt="">
                                <!-- 已选中 -->
                                <img class="icon" v-if="taxRate==2" :src="$config.resource + 'xz.png'" alt="">
                                <p>9%</p>
                            </div>
                            <div class="unify" :class="{curr:taxRate == 3}" @click="onTaxRate(3)">
                                <!-- 未选中 -->
                                <img class="icon" v-if="taxRate!=3" :src="$config.resource + 'wxz.png'" alt="">
                                <!-- 已选中 -->
                                <img class="icon" v-if="taxRate==3" :src="$config.resource + 'xz.png'" alt="">
                                <p>6%</p>
                            </div>
                            <div class="unify" :class="{curr:taxRate == 4}" @click="onTaxRate(4)">
                                <!-- 未选中 -->
                                <img class="icon" v-if="taxRate!=4" :src="$config.resource + 'wxz.png'" alt="">
                                <!-- 已选中 -->
                                <img class="icon" v-if="taxRate==4" :src="$config.resource + 'xz.png'" alt="">
                                <p>5%</p>
                            </div>
                            <div class="unify" :class="{curr:taxRate == 5}" @click="onTaxRate(5)">
                                <!-- 未选中 -->
                                <img class="icon" v-if="taxRate!=5" :src="$config.resource + 'wxz.png'" alt="">
                                <!-- 已选中 -->
                                <img class="icon" v-if="taxRate==5" :src="$config.resource + 'xz.png'" alt="">
                                <p>3%</p>
                            </div>
                            <div class="unify" :class="{curr:taxRate == 6}" @click="onTaxRate(6)">
                                <!-- 未选中 -->
                                <img class="icon"  v-if="taxRate!=6" :src="$config.resource + 'wxz.png'" alt="">
                                <!-- 已选中 -->
                                <img class="icon" v-if="taxRate==6" :src="$config.resource + 'xz.png'" alt="">
                                <p>1%</p>
                            </div>
                        </dd>
                    </dl>
                    <dl class="basics_box">
                        <dt>
                        <p>*</p>
                            <div class="short">
                                <em>结</em>
                                <div class="flex-1"></div>
                                <em>算</em>
                                <div class="flex-1"></div>
                                <em>方</em>
                                <div class="flex-1"></div>
                                <em>式：</em>
                            </div>
                        </dt>
                        <dd>
                            <div class="unify" :class="{curr:balance == 1}" @click="onBalance(1)">
                                <!-- 未选中 -->
                                <img class="icon" v-if="balance!=1" :src="$config.resource + 'wxz.png'" alt="">
                                <!-- 已选中 -->
                                <img class="icon" v-if="balance==1" :src="$config.resource + 'xz.png'" alt="">
                                <p>当月结</p>
                            </div>
                            <div class="unify" :class="{curr:balance == 2}" @click="onBalance(2)">
                                <!-- 未选中 -->
                                <img class="icon" v-if="balance!=2" :src="$config.resource + 'wxz.png'" alt="">
                                <!-- 已选中 -->
                                <img class="icon" v-if="balance==2" :src="$config.resource + 'xz.png'" alt="">
                                <p>月结30天</p>
                            </div>
                            <div class="unify" :class="{curr:balance == 3}" @click="onBalance(3)">
                                <!-- 未选中 -->
                                <img class="icon" v-if="balance!=3" :src="$config.resource + 'wxz.png'" alt="">
                                <!-- 已选中 -->
                                <img class="icon" v-if="balance==3" :src="$config.resource + 'xz.png'" alt="">
                                <p>月结60天</p>
                            </div>
                            <div class="unify" :class="{curr:balance == 4}" @click="onBalance(4)">
                                <!-- 未选中 -->
                                <img class="icon" v-if="balance!=4" :src="$config.resource + 'wxz.png'" alt="">
                                <!-- 已选中 -->
                                <img class="icon" v-if="balance==4" :src="$config.resource + 'xz.png'" alt="">
                                <p>其它</p>
                                <div class="closing">
                                    <input v-if="balance==4" class="inp" type="text" v-model="closing" ref="closing" />
                                </div>
                            </div>
                        </dd>
                    </dl>
                    <dl class="basics_box">
                        <dt>
                        <p>*</p>
                            <div class="short">
                                <em>收</em>
                                <div class="flex-1"></div>
                                <em>付</em>
                                <div class="flex-1"></div>
                                <em>方</em>
                                <div class="flex-1"></div>
                                <em>式：</em>
                            </div>
                        </dt>
                        <dd>
                            <div class="unify" :class="{curr:receive == 1}" @click="onReceive(1)">
                                <!-- 未选中 -->
                                <img class="icon" v-if="receive!=1" :src="$config.resource + 'wxz.png'" alt="">
                                <!-- 已选中 -->
                                <img class="icon" v-if="receive==1" :src="$config.resource + 'xz.png'" alt="">
                                <p>银行汇款</p>
                            </div>
                            <div class="unify" :class="{curr:receive == 2}" @click="onReceive(2)">
                                <!-- 未选中 -->
                                <img class="icon" v-if="receive!=2" :src="$config.resource + 'wxz.png'" alt="">
                                <!-- 已选中 -->
                                <img class="icon" v-if="receive==2" :src="$config.resource + 'xz.png'" alt="">
                                <p>银行承兑</p>
                            </div>
                            <div class="unify" :class="{curr:receive == 3}" @click="onReceive(3)">
                                <!-- 未选中 -->
                                <img class="icon" v-if="receive!=3" :src="$config.resource + 'wxz.png'" alt="">
                                <!-- 已选中 -->
                                <img class="icon" v-if="receive==3" :src="$config.resource + 'xz.png'" alt="">
                                <p>迪链</p>
                            </div>
                            <div class="unify" :class="{curr:receive == 4}" @click="onReceive(4)">
                                <!-- 未选中 -->
                                <img class="icon" v-if="receive!=4" :src="$config.resource + 'wxz.png'" alt="">
                                <!-- 已选中 -->
                                <img class="icon" v-if="receive==4" :src="$config.resource + 'xz.png'" alt="">
                                <p>E信通</p>
                            </div>
                            <div class="unify" :class="{curr:receive == 5}" @click="onReceive(5)">
                                <!-- 未选中 -->
                                <img class="icon" v-if="receive!=5" :src="$config.resource + 'wxz.png'" alt="">
                                <!-- 已选中 -->
                                <img class="icon" v-if="receive==5" :src="$config.resource + 'xz.png'" alt="">
                                <p>中企云链</p>
                            </div>
                        </dd>
                    </dl>
                    <dl class="basics_box">
                        <dt>
                        <p>*</p>
                            <div class="short">
                                <em>企</em>
                                <div class="flex-1"></div>
                                <em>业</em>
                                <div class="flex-1"></div>
                                <em>性</em>
                                <div class="flex-1"></div>
                                <em>质：</em>
                            </div>
                        </dt>
                        <dd>
                            <div class="unify" :class="{curr:firm == 1}" @click="onFirm(1)">
                                <!-- 未选中 -->
                                <img class="icon" v-if="firm!=1" :src="$config.resource + 'wxz.png'" alt="">
                                <!-- 已选中 -->
                                <img class="icon" v-if="firm==1" :src="$config.resource + 'xz.png'" alt="">
                                <p>生产企业</p>
                            </div>
                            <div class="unify" :class="{curr:firm == 2}" @click="onFirm(2)">
                                <!-- 未选中 -->
                                <img class="icon" v-if="firm!=2" :src="$config.resource + 'wxz.png'" alt="">
                                <!-- 已选中 -->
                                <img class="icon" v-if="firm==2" :src="$config.resource + 'xz.png'" alt="">
                                <p>贸易公司</p>
                            </div>
                            <div class="unify" :class="{curr:firm == 3}" @click="onFirm(3)">
                                <!-- 未选中 -->
                                <img class="icon" v-if="firm!=3" :src="$config.resource + 'wxz.png'" alt="">
                                <!-- 已选中 -->
                                <img class="icon" v-if="firm==3" :src="$config.resource + 'xz.png'" alt="">
                                <p>设计研发公司</p>
                            </div>
                            <div class="unify" :class="{curr:firm == 4}" @click="onFirm(4)">
                                <!-- 未选中 -->
                                <img class="icon" v-if="firm!=4" :src="$config.resource + 'wxz.png'" alt="">
                                <!-- 已选中 -->
                                <img class="icon" v-if="firm==4" :src="$config.resource + 'xz.png'" alt="">
                                <p>采购中心</p>
                            </div>
                            <div class="unify" :class="{curr:firm == 5}" @click="onFirm(5)">
                                <!-- 未选中 -->
                                <img class="icon" v-if="firm!=5" :src="$config.resource + 'wxz.png'" alt="">
                                <!-- 已选中 -->
                                <img class="icon" v-if="firm==5" :src="$config.resource + 'xz.png'" alt="">
                                <p>平台中心</p>
                            </div>
                            <div class="unify" :class="{curr:firm == 6}" @click="onFirm(6)">
                                <!-- 未选中 -->
                                <img class="icon" v-if="firm!=6" :src="$config.resource + 'wxz.png'" alt="">
                                <!-- 已选中 -->
                                <img class="icon" v-if="firm==6" :src="$config.resource + 'xz.png'" alt="">
                                <p>服务机构</p>
                            </div>
                            <div class="unify" :class="{curr:firm == 7}" @click="onFirm(7)">
                                <!-- 未选中 -->
                                <img class="icon" v-if="firm!=7" :src="$config.resource + 'wxz.png'" alt="">
                                <!-- 已选中 -->
                                <img class="icon" v-if="firm==7" :src="$config.resource + 'xz.png'" alt="">
                                <p>进出口商</p>
                            </div>
                            <div class="unify" :class="{curr:firm == 8}" @click="onFirm(8)">
                                <!-- 未选中 -->
                                <img class="icon" v-if="firm!=8" :src="$config.resource + 'wxz.png'" alt="">
                                <!-- 已选中 -->
                                <img class="icon" v-if="firm==8" :src="$config.resource + 'xz.png'" alt="">
                                <p>代理商</p>
                            </div>
                            <div class="unify" :class="{curr:firm == 9}" @click="onFirm(9)">
                                <!-- 未选中 -->
                                <img class="icon" v-if="firm!=9" :src="$config.resource + 'wxz.png'" alt="">
                                <!-- 已选中 -->
                                <img class="icon" v-if="firm==9" :src="$config.resource + 'xz.png'" alt="">
                                <p>其它</p>
                                <div class="typeid">
                                    <input v-if="firm==9" class="inp" type="text" v-model="property" ref="property" />
                                </div>
                            </div>
                        </dd>
                    </dl>
                    <dl class="basics_box">
                        <dt>
                        <p>*</p>
                            <div class="short">
                                <em>资</em>
                                <div class="flex-1"></div>
                                <em>本</em>
                                <div class="flex-1"></div>
                                <em>类</em>
                                <div class="flex-1"></div>
                                <em>型：</em>
                            </div>
                        </dt>
                        <dd>
                            <div class="unify" :class="{curr:capital == 1}" @click="onCapital(1)">
                                <!-- 未选中 -->
                                <img class="icon" v-if="capital!=1" :src="$config.resource + 'wxz.png'" alt="">
                                <!-- 已选中 -->
                                <img class="icon" v-if="capital==1" :src="$config.resource + 'xz.png'" alt="">
                                <p>有限责任公司</p>
                            </div>
                            <div class="unify" :class="{curr:capital == 2}" @click="onCapital(2)">
                                <!-- 未选中 -->
                                <img class="icon" v-if="capital!=2" :src="$config.resource + 'wxz.png'" alt="">
                                <!-- 已选中 -->
                                <img class="icon" v-if="capital==2" :src="$config.resource + 'xz.png'" alt="">
                                <p>股份公司</p>
                            </div>
                            <div class="unify" :class="{curr:capital == 3}" @click="onCapital(3)">
                                <!-- 未选中 -->
                                <img class="icon" v-if="capital!=3" :src="$config.resource + 'wxz.png'" alt="">
                                <!-- 已选中 -->
                                <img class="icon" v-if="capital==3" :src="$config.resource + 'xz.png'" alt="">
                                <p>上市公司</p>
                            </div>
                            <div class="unify" :class="{curr:capital == 4}" @click="onCapital(4)">
                                <!-- 未选中 -->
                                <img class="icon" v-if="capital!=4" :src="$config.resource + 'wxz.png'" alt="">
                                <!-- 已选中 -->
                                <img class="icon" v-if="capital==4" :src="$config.resource + 'xz.png'" alt="">
                                <p>全资子公司</p>
                            </div>
                            <div class="unify" :class="{curr:capital == 5}" @click="onCapital(5)">
                                <!-- 未选中 -->
                                <img class="icon" v-if="capital!=5" :src="$config.resource + 'wxz.png'" alt="">
                                <!-- 已选中 -->
                                <img class="icon" v-if="capital==5" :src="$config.resource + 'xz.png'" alt="">
                                <p>中外合资公司</p>
                            </div>
                            <div class="unify" :class="{curr:capital == 6}" @click="onCapital(6)">
                                <!-- 未选中 -->
                                <img class="icon" v-if="capital!=6" :src="$config.resource + 'wxz.png'" alt="">
                                <!-- 已选中 -->
                                <img class="icon" v-if="capital==6" :src="$config.resource + 'xz.png'" alt="">
                                <p>外资公司</p>
                            </div>
                            <div class="unify" :class="{curr:capital == 7}" @click="onCapital(7)">
                                <!-- 未选中 -->
                                <img class="icon" v-if="capital!=7" :src="$config.resource + 'wxz.png'" alt="">
                                <!-- 已选中 -->
                                <img class="icon" v-if="capital==7" :src="$config.resource + 'xz.png'" alt="">
                                <p>投资控股公司</p>
                            </div>
                            <div class="unify" :class="{curr:capital == 8}" @click="onCapital(8)">
                                <!-- 未选中 -->
                                <img class="icon" v-if="capital!=8" :src="$config.resource + 'wxz.png'" alt="">
                                <!-- 已选中 -->
                                <img class="icon" v-if="capital==8" :src="$config.resource + 'xz.png'" alt="">
                                <p>其它</p>
                                <div class="typeid">
                                    <input v-if="capital==8" class="inp" type="text" v-model="company_type" ref="company_type" />
                                </div>
                            </div>
                        </dd>
                    </dl>
                    <dl class="basics_box">
                        <dt>
                            <p>*</p>
                            <div class="long">填写有母（子）公司或其他关联公司与利元亨合作的。如有，请列明名称或无：</div>
                        </dt>
                        <dd>
                            <div class="unify" :class="{curr:relevancy == 1}" @click="onRelevancy(1)">
                                <!-- 未选中 -->
                                <img class="icon" v-if="relevancy!=1" :src="$config.resource + 'wxz.png'" alt="">
                                <!-- 已选中 -->
                                <img class="icon" v-if="relevancy==1" :src="$config.resource + 'xz.png'" alt="">
                                <p>无</p>
                            </div>
                            <div class="unify" :class="{curr:relevancy == 2}" @click="onRelevancy(2)">
                                <!-- 未选中 -->
                                <img class="icon" v-if="relevancy!=2" :src="$config.resource + 'wxz.png'" alt="">
                                <!-- 已选中 -->
                                <img class="icon" v-if="relevancy==2" :src="$config.resource + 'xz.png'" alt="">
                                <p>有</p>
                                <div class="relation">
                                    <input v-if="relevancy==2" class="inp" type="text" v-model="relevancy_name" ref="relevancy_name" />
                                </div>
                            </div>
                        </dd>
                    </dl>
                    <dl class="basics_box">
                        <dt>
                            <p>*</p>
                            <div class="long">是否与利元亨董事、监事或高层有投资关联关系或直系近系亲属关系。如有，请列明名称或无：</div>
                        </dt>
                        <dd>
                            <div class="unify" :class="{curr:clan == 1}" @click="onClan(1)">
                                <!-- 未选中 -->
                                <img class="icon" v-if="clan!=1" :src="$config.resource + 'wxz.png'" alt="">
                                <!-- 已选中 -->
                                <img class="icon" v-if="clan==1" :src="$config.resource + 'xz.png'" alt="">
                                <p>无</p>
                            </div>
                            <div class="unify" :class="{curr:clan == 2}" @click="onClan(2)">
                                <!-- 未选中 -->
                                <img class="icon" v-if="clan!=2" :src="$config.resource + 'wxz.png'" alt="">
                                <!-- 已选中 -->
                                <img class="icon" v-if="clan==2" :src="$config.resource + 'xz.png'" alt="">
                                <p>有</p>
                                <div class="relation">
                                    <input v-if="clan==2" class="inp" type="text" v-model="clan_name" ref="clan_name" />
                                </div>
                            </div>
                        </dd>
                    </dl>
                    <dl class="basics_box">
                        <dt>
                            <p>*</p>
                            <div class="long">是否能按利元亨要求调整物料产品包装。如否，请说明原因：</div>
                        </dt>
                        <dd>
                            <div class="unify" :class="{curr:material == 1}" @click="onMaterial(1)">
                                <!-- 未选中 -->
                                <img class="icon" v-if="material!=1" :src="$config.resource + 'wxz.png'" alt="">
                                <!-- 已选中 -->
                                <img class="icon" v-if="material==1" :src="$config.resource + 'xz.png'" alt="">
                                <p>是</p>
                            </div>
                            <div class="unify" :class="{curr:material == 2}" @click="onMaterial(2)">
                                <!-- 未选中 -->
                                <img class="icon" v-if="material!=2" :src="$config.resource + 'wxz.png'" alt="">
                                <!-- 已选中 -->
                                <img class="icon" v-if="material==2" :src="$config.resource + 'xz.png'" alt="">
                                <p>否</p>
                                <div class="cause">
                                    <input v-if="material==2" class="inp" type="text" v-model="pack" ref="pack" />
                                </div>
                            </div>
                        </dd>
                    </dl>
                </div>
                <!-- 主要客户 -->
                <div class="alike">
                    <div class="top_box">
                        <div class="pattern"></div>
                        <p>主要客户</p>
                    </div>
                    <ul>
                        <li>
                            <div class="name">
                                <p>*</p>
                                <div class="tt">主要客户1：</div>
                            </div>
                            <div class="inp_unit">
                                <input class="inp" type="text" v-model="client_one" />
                            </div>
                        </li>
                        <li>
                            <div class="name">
                                <p>*</p>
                                <div class="tt">业务量占比：</div>
                            </div>
                            <div class="inp_unit">
                                <input class="inp" type="text" v-model="portfolio_one" />
                                <div class="unit">%</div>
                            </div>
                        </li>
                        <li>
                            <div class="name">
                                <p>*</p>
                                <div class="tt">合作产品：</div>
                            </div>
                            <div class="inp_unit">
                                <input class="inp" type="text" v-model="cooperate_one" />
                            </div>
                        </li>
                        <li>
                            <div class="name">
                                <p>*</p>
                                <div class="tt">主要客户2：</div>
                            </div>
                            <div class="inp_unit">
                                <input class="inp" type="text" v-model="client_two" />
                            </div>
                        </li>
                        <li>
                            <div class="name">
                                <p>*</p>
                                <div class="tt">业务量占比：</div>
                            </div>
                            <div class="inp_unit">
                                <input class="inp" type="text" v-model="portfolio_two" />
                                <div class="unit">%</div>
                            </div>
                        </li>
                        <li>
                            <div class="name">
                                <p>*</p>
                                <div class="tt">合作产品：</div>
                            </div>
                            <div class="inp_unit">
                                <input class="inp" type="text" v-model="cooperate_two" />
                            </div>
                        </li>
                        <li>
                            <div class="name">
                                <p>*</p>
                                <div class="tt">主要客户3：</div>
                            </div>
                            <div class="inp_unit">
                                <input class="inp" type="text" v-model="client_tri" />
                            </div>
                        </li>
                        <li>
                            <div class="name">
                                <p>*</p>
                                <div class="tt">业务量占比：</div>
                            </div>
                            <div class="inp_unit">
                                <input class="inp" type="text" v-model="portfolio_tri" />
                                <div class="unit">%</div>
                            </div>
                        </li>
                        <li>
                            <div class="name">
                                <p>*</p>
                                <div class="tt">合作产品：</div>
                            </div>
                            <div class="inp_unit">
                                <input class="inp" type="text" v-model="cooperate_tri" />
                            </div>
                        </li>
                    </ul>
                </div>
                <!-- 人员概况 -->
                <div class="alike">
                    <div class="top_box">
                        <div class="pattern"></div>
                        <p>人员概况</p>
                    </div>
                    <ul>
                        <li>
                            <div class="name">
                                <p>*</p>
                                <div class="tt">人员总数：</div>
                            </div>
                            <div class="inp_unit">
                                <input class="inp" type="number" v-model="total" />
                                <div class="unit">人</div>
                            </div>
                        </li>
                        <li>
                            <div class="name">
                                <p>*</p>
                                <div class="tt">管理人员：</div>
                            </div>
                            <div class="inp_unit">
                                <input class="inp" type="number" v-model="manage" />
                                <div class="unit">人</div>
                            </div>
                        </li>
                        <li>
                            <div class="name">
                                <p>*</p>
                                <div class="tt">生产人员：</div>
                            </div>
                            <div class="inp_unit">
                                <input class="inp" type="number" v-model="production" />
                                <div class="unit">人</div>
                            </div>
                        </li>
                        <li>
                            <div class="name">
                                <p>*</p>
                                <div class="tt">研发人员：</div>
                            </div>
                            <div class="inp_unit">
                                <input class="inp" type="number" v-model="research_staff" />
                                <div class="unit">人</div>
                            </div>
                        </li>
                        <li>
                            <div class="name">
                                <p>*</p>
                                <div class="tt">质量人员：</div>
                            </div>
                            <div class="inp_unit">
                                <input class="inp" type="number" v-model="quality" />
                                <div class="unit">人</div>
                            </div>
                        </li>
                        <li>
                            <div class="name">
                                <p>*</p>
                                <div class="tt">销售人数：</div>
                            </div>
                            <div class="inp_unit">
                                <input class="inp" type="number" v-model="sell" />
                                <div class="unit">人</div>
                            </div>
                        </li>
                        <li>
                            <div class="name">
                                <p>*</p>
                                <div class="tt">售后人员：</div>
                            </div>
                            <div class="inp_unit">
                                <input class="inp" type="number" v-model="after_sale" />
                                <div class="unit">人</div>
                            </div>
                        </li>
                        <li>
                            <div class="name">
                                <p>*</p>
                                <div class="tt">其他人员：</div>
                            </div>
                            <div class="inp_unit">
                                <input class="inp" type="number" v-model="rests" />
                                <div class="unit">人</div>
                            </div>
                        </li>
                        <li>
                            <div class="name">
                                <p>*</p>
                                <div class="tt">是否支持国外售后：</div>
                            </div>
                            <el-select class="elect" v-model="service" @change="getService">
                                <el-option
                                v-for="item in leaseback"
                                :key="item.name"
                                :label="item.name"
                                :value="item">
                                </el-option>
                            </el-select>
                        </li>
                    </ul>
                </div>
                <!-- 研发设计能力 -->
                <div class="alike">
                    <div class="top_box">
                        <div class="pattern"></div>
                        <p>研发设计能力</p>
                    </div>
                    <ul>
                        <li>
                            <div class="name">
                                <div class="tt design">每年研发投入金额：</div>
                            </div>
                            <div class="inp_unit">
                                <input class="inp" type="number" v-model="money" />
                                <div class="unit">万元</div>
                            </div>
                        </li>
                        <li>
                            <div class="name">
                                <div class="tt design">设计领域：</div>
                            </div>
                            <div class="inp_unit">
                                <input class="inp" type="text" v-model="field" />
                            </div>
                        </li>
                        <li>
                            <div class="name">
                                <div class="tt design">设计软件名称：</div>
                            </div>
                            <div class="inp_unit">
                                <input class="inp" type="text" v-model="software" />
                            </div>
                        </li>
                    </ul>
                </div>
                <!-- 工厂状况 -->
                <div class="alike">
                    <div class="top_box">
                        <div class="pattern"></div>
                        <p>工厂状况</p>
                        <div class="remark">备注：有则输入面积，无工厂则输入0</div>
                    </div>
                    <ul>
                        <li>
                            <div class="name">
                                <p>*</p>
                                <div class="tt">工厂占地面积：</div>
                            </div>
                            <div class="inp_unit">
                                <input class="inp" type="number" v-model="floor_area" />
                                <div class="unit">m²</div>
                            </div>
                        </li>
                        <li>
                            <div class="name">
                                <p>*</p>
                                <div class="tt">工厂建筑面积：</div>
                            </div>
                            <div class="inp_unit">
                                <input class="inp" type="number" v-model="covered_area" />
                                <div class="unit">m²</div>
                            </div>
                        </li>
                        <li>
                            <div class="name">
                                <p>*</p>
                                <div class="tt">仓库面积：</div>
                            </div>
                            <div class="inp_unit">
                                <input class="inp" type="number" v-model="storage_area" />
                                <div class="unit">m²</div>
                            </div>
                        </li>
                        <li>
                            <div class="name">
                                <p>*</p>
                                <div class="tt">工厂生产面积：</div>
                            </div>
                            <div class="inp_unit">
                                <input class="inp" type="number" v-model="production_area" />
                                <div class="unit">m²</div>
                            </div>
                        </li>
                    </ul>
                </div>
                <!-- 产品品类（按品类填，品类多按以下内容提供-供货清单） -->
                <div class="alike alike_one">
                    <div class="top_box">
                        <div class="pattern"></div>
                        <p>产品品类（按品类填，品类多按以下内容提供-供货清单）</p>
                        <div class="remark">备注：提供纯服务供应商无须填写（其他供应商需必填）</div>
                    </div>
                    <ul>
                        <li>
                            <div class="name">
                                <div class="tt design">主要生产产品种类：</div>
                            </div>
                            <div class="inp_unit">
                                <input class="inp" type="text" v-model="kind_one" />
                            </div>
                        </li>
                        <li>
                            <div class="name">
                                <div class="tt design">上年年产量：</div>
                            </div>
                            <div class="inp_unit">
                                <input class="inp" type="number" v-model="last_year_one" />
                            </div>
                        </li>
                        <li>
                            <div class="name">
                                <div class="tt design">实际年产量：</div>
                            </div>
                            <div class="inp_unit">
                                <input class="inp" type="number" v-model="practical_one" />
                            </div>
                        </li>
                        <li>
                            <div class="name">
                                <div class="tt design">总体销售额：</div>
                            </div>
                            <div class="inp_unit">
                                <input class="inp" type="number" v-model="total_one" />
                                <div class="unit">万元</div>
                            </div>
                        </li>
                        <li>
                            <div class="name">
                                <div class="tt design">配套额：</div>
                            </div>
                            <div class="inp_unit">
                                <input class="inp" type="number" v-model="mating_one" />
                                <div class="unit">万元</div>
                            </div>
                        </li>
                        <li>
                            <div class="name">
                                <div class="tt design">综合质量能力PPM：</div>
                            </div>
                            <div class="inp_unit">
                                <input class="inp" type="text" v-model="quality_one" />
                            </div>
                        </li>
                    </ul>
                    <ul v-if="variety">
                        <li>
                            <div class="name">
                                <div class="tt design">主要生产产品种类：</div>
                            </div>
                            <div class="inp_unit">
                                <input class="inp" type="text" v-model="kind_two" />
                            </div>
                        </li>
                        <li>
                            <div class="name">
                                <div class="tt design">上年年产量：</div>
                            </div>
                            <div class="inp_unit">
                                <input class="inp" type="number" v-model="last_year_two" />
                            </div>
                        </li>
                        <li>
                            <div class="name">
                                <div class="tt design">实际年产量：</div>
                            </div>
                            <div class="inp_unit">
                                <input class="inp" type="number" v-model="practical_two" />
                            </div>
                        </li>
                        <li>
                            <div class="name">
                                <div class="tt design">总体销售额：</div>
                            </div>
                            <div class="inp_unit">
                                <input class="inp" type="number" v-model="total_two" />
                                <div class="unit">万元</div>
                            </div>
                        </li>
                        <li>
                            <div class="name">
                                <div class="tt design">配套额：</div>
                            </div>
                            <div class="inp_unit">
                                <input class="inp" type="number" v-model="mating_two" />
                                <div class="unit">万元</div>
                            </div>
                        </li>
                        <li>
                            <div class="name">
                                <div class="tt design">综合质量能力PPM：</div>
                            </div>
                            <div class="inp_unit">
                                <input class="inp" type="text" v-model="quality_two" />
                            </div>
                        </li>
                    </ul>
                    <div class="add" v-if="!variety&&isType==1" @click="onVariety">新增产品品类</div>
                </div>
                <!-- 体系认证情况/行业资质情况 -->
                <div class="alike alike_one">
                    <div class="top_box">
                        <div class="pattern"></div>
                        <p>体系认证情况/行业资质情况</p>
                    </div>
                    <ul>
                        <li>
                            <div class="name">
                                <p>*</p>
                                <div class="tt">何种体系认证/何种资质证书：</div>
                            </div>
                            <div class="inp_unit">
                                <input class="inp" type="text" v-model="approve_one" />
                            </div>
                        </li>
                        <li>
                            <div class="name">
                                <p>*</p>
                                <div class="tt">认证时间：</div>
                            </div>
                            <el-date-picker
                                v-model="ms_one"
                                type="date"
                                value-format="yyyy-MM-dd"
                                placeholder="请选择">
                            </el-date-picker>
                        </li>
                        <li>
                            <div class="name">
                                <p>*</p>
                                <div class="tt">有效期：</div>
                            </div>
                            <el-date-picker
                                v-model="validity_one"
                                type="date"
                                value-format="yyyy-MM-dd"
                                placeholder="请选择">
                            </el-date-picker>
                        </li>
                        <li>
                            <div class="name">
                                <p>*</p>
                                <div class="tt">认证机构：</div>
                            </div>
                            <div class="inp_unit">
                                <input class="inp" type="text" v-model="institution_one" />
                            </div>
                        </li>
                        <li>
                            <div class="name">
                                <p>*</p>
                                <div class="tt">证书编号：</div>
                            </div>
                            <div class="inp_unit">
                                <input class="inp" type="text" v-model="number_one" />
                            </div>
                        </li>
                    </ul>
                    <ul v-if="isRapex">
                        <li>
                            <div class="name">
                                <p>*</p>
                                <div class="tt">何种体系认证/何种资质证书：</div>
                            </div>
                            <div class="inp_unit">
                                <input class="inp" type="text" v-model="approve_two" />
                            </div>
                        </li>
                        <li>
                            <div class="name">
                                <p>*</p>
                                <div class="tt">认证时间：</div>
                            </div>
                            <el-date-picker
                                v-model="ms_two"
                                type="date"
                                value-format="yyyy-MM-dd"
                                placeholder="请选择">
                            </el-date-picker>
                        </li>
                        <li>
                            <div class="name">
                                <p>*</p>
                                <div class="tt">有效期：</div>
                            </div>
                            <el-date-picker
                                v-model="validity_two"
                                type="date"
                                value-format="yyyy-MM-dd"
                                placeholder="请选择">
                            </el-date-picker>
                        </li>
                        <li>
                            <div class="name">
                                <p>*</p>
                                <div class="tt">认证机构：</div>
                            </div>
                            <div class="inp_unit">
                                <input class="inp" type="text" v-model="institution_two" />
                            </div>
                        </li>
                        <li>
                            <div class="name">
                                <p>*</p>
                                <div class="tt">证书编号：</div>
                            </div>
                            <div class="inp_unit">
                                <input class="inp" type="text" v-model="number_two" />
                            </div>
                        </li>
                    </ul>
                    <div class="add" v-if="!isRapex&&isType==1" @click="onRapex">新增体系认证情况</div>
                </div>
                <!-- 代理（品类多按以下内容提供-供货清单） -->
                <div class="alike">
                    <div class="top_box">
                        <div class="pattern"></div>
                        <p>代理（品类多按以下内容提供-供货清单）</p>
                        <div class="remark">备注：提供纯服务供应商无须填写（其他供应商需必填）</div>
                    </div>
                    <ul>
                        <li>
                            <div class="name">
                                <div class="tt design">主代理品牌：</div>
                            </div>
                            <div class="inp_unit">
                                <input class="inp" type="text" v-model="lord" />
                            </div>
                        </li>
                        <li>
                            <div class="name">
                                <div class="tt design">代理等级：</div>
                            </div>
                            <div class="inp_unit">
                                <input class="inp" type="text" v-model="grade_one" />
                            </div>
                        </li>
                        <li>
                            <div class="name">
                                <div class="tt design">代理年限（需附代理证书）：</div>
                            </div>
                            <div class="inp_unit">
                                <input 
                                    class="uploadBtn" 
                                    name="key" 
                                    type="file" 
                                    @change="proxyFile($event)" 
                                    ref="inputer_sixteen" 
                                    accept=".pdf" 
                                />
                                <p v-if="agency_one!=''">已上传</p>
                                <img class="icon" :src="$config.resource + 'scwj.png'" alt="">
                            </div>
                        </li>
                        <li>
                            <div class="name">
                                <div class="tt design">其他代理品牌：</div>
                            </div>
                            <div class="inp_unit">
                                <input class="inp" type="text" v-model="rest" />
                            </div>
                        </li>
                        <li>
                            <div class="name">
                                <div class="tt design">代理等级：</div>
                            </div>
                            <div class="inp_unit">
                                <input class="inp" type="text" v-model="grade_two" />
                            </div>
                        </li>
                        <li>
                            <div class="name">
                                <div class="tt design">代理年限（需附代理证书）：</div>
                            </div>
                            <div class="inp_unit">
                                <input 
                                    class="uploadBtn" 
                                    name="key" 
                                    type="file" 
                                    @change="restsFile($event)" 
                                    ref="inputer_fifteen" 
                                    accept=".pdf" 
                                />
                                <p v-if="agency_two!=''">已上传</p>
                                <img class="icon" :src="$config.resource + 'scwj.png'" alt="">
                            </div>
                        </li>
                        <li>
                            <div class="name">
                                <div class="tt design">代理区域：</div>
                            </div>
                            <el-select class="elect" v-model="area_name" @change="getArea">
                                <el-option
                                v-for="item in area"
                                :key="item.name"
                                :label="item.name"
                                :value="item">
                                </el-option>
                            </el-select>
                        </li>
                        <li>
                            <div class="name">
                                <div class="tt design">代理区域市场份额：</div>
                            </div>
                            <el-select class="elect" v-model="quotient_name" @change="getQuotient">
                                <el-option
                                v-for="item in quotient"
                                :key="item.name"
                                :label="item.name"
                                :value="item">
                                </el-option>
                            </el-select>
                        </li>
                        <li>
                            <div class="name">
                                <div class="tt design">主要来货渠道：</div>
                            </div>
                            <div class="inp_unit">
                                <input class="inp" type="text" v-model="channel" />
                            </div>
                        </li>
                        <li>
                            <div class="name">
                                <div class="tt design">曾代理的主要产品：</div>
                            </div>
                            <div class="inp_unit">
                                <input class="inp" type="text" v-model="staple" />
                            </div>
                        </li>
                    </ul>
                </div>
                <!-- 其他 -->
                <div class="alike">
                    <div class="top_box">
                        <div class="pattern"></div>
                        <p>其他</p>
                    </div>
                    <ul>
                        <li>
                            <div class="name">
                                <p>*</p>
                                <div class="tt">交期：</div>
                            </div>
                            <el-select class="elect" v-model="deal_name" @change="getDeal">
                                <el-option
                                v-for="item in deal"
                                :key="item.name"
                                :label="item.name"
                                :value="item">
                                </el-option>
                            </el-select>
                        </li>
                        <li>
                            <div class="name">
                                <p>*</p>
                                <div class="tt">物流配送：</div>
                            </div>
                            <el-select class="elect" v-model="logistics" @change="getDelivery">
                                <el-option
                                v-for="item in delivery"
                                :key="item.name"
                                :label="item.name"
                                :value="item">
                                </el-option>
                            </el-select>
                        </li>
                        <li>
                            <div class="name">
                                <p>*</p>
                                <div class="tt">有无实验室：</div>
                            </div>
                            <el-select class="elect" v-model="lab_name" @change="getLaboratory">
                                <el-option
                                v-for="item in laboratory"
                                :key="item.name"
                                :label="item.name"
                                :value="item">
                                </el-option>
                            </el-select>
                        </li>
                        <li>
                            <div class="name">
                                <p>*</p>
                                <div class="tt">有无生产设备：</div>
                            </div>
                            <el-select class="elect" v-model="facility" @change="getFacility">
                                <el-option
                                v-for="item in equipment"
                                :key="item.name"
                                :label="item.name"
                                :value="item">
                                </el-option>
                            </el-select>
                        </li>
                    </ul>
                </div>
                <!-- 生成文档下载 -->
                <div class="alike alike_one">
                    <!-- 生成文档下载 -->
                    <div class="top_box">
                        <div class="pattern"></div>
                        <p>生成文档下载</p>
                    </div>
                    <dl class="document">
                        <dt @click="onDown">
                            <div class="put_box">
                                <img class="icon" :src="$config.resource + 'xzwj.png'" alt="">
                                <p>文档下载</p>
                            </div>
                        </dt>
                    </dl>
                    <!-- 文档上传 -->
                    <div class="top_box">
                        <div class="pattern"></div>
                        <p>文档上传</p>
                        <div class="remark">
                            <em>备注：{{archive.contont}}</em>
                            <samp @click="onReference(1)" v-if="!isRefer">点击展开查看参考</samp>
                            <samp @click="onReference(2)" v-if="isRefer">点击关闭参考</samp>
                        </div>
                    </div>
                    <dl class="document">
                        <dt>
                            <!-- 未上传 -->
                            <div class="put_box" v-if="supplier_info==''">
                                <img class="put" :src="$config.resource + 'scwj.png'" alt="">
                                <p>文档上传</p>
                                <input 
                                    class="uploadBtn" 
                                    name="key" 
                                    type="file" 
                                    @change="archiveFile($event)" 
                                    ref="inputer_zero" 
                                    accept=".pdf" 
                                />
                            </div>
                            <!-- 已上传 -->
                            <div class="put_box" v-if="supplier_info!=''">
                                <img class="put" :src="$config.resource + 'ysc.png'" alt="">
                                <p>已上传</p>
                                <!-- 删除 -->
                                <img @click="onDelete"  class="delete" :src="$config.resource + 'sc.png'" alt="">
                            </div>
                        </dt>
                        <dd v-if="isRefer">
                            <img class="pic" :src="archive.src" alt="">
                        </dd>
                    </dl>
                </div>
                <!-- 提交 -->
                <div class="btn_box" v-if="isType==1">
                    <div class="btn gray" @click="onSavefirst">保存草稿</div>
                    <div class="btn red" @click="onSubmitfirst">提交审核</div>
                </div>
                <!-- 查看 -->
                <div class="btn_box" v-if="isType==2">
                    <div class="btn gray" @click="onFirstup">上一页</div>
                    <div class="btn red" @click="onFirstnext">下一页</div>
                </div>
            </div>
            <!-- 详细信息填写 -->
            <div class="write_box" v-if="isDetailed">
                <figure>
                    <h6>详细信息填写</h6>
                    <div class="wire"></div>
                </figure>
                <!-- 知识产权调查表 -->
                <div class="alike">
                    <div class="top_box">
                        <div class="pattern"></div>
                        <p>知识产权调查表</p>
                    </div>
                    <ul>
                        <li>
                            <div class="name">
                                <p>*</p>
                                <div class="tt">供应产品/服务/技术名称：</div>
                            </div>
                            <div class="inp_unit">
                                <input class="inp" type="text" v-model="technical_name" />
                            </div>
                        </li>
                        <li>
                            <div class="name">
                                <p>*</p>
                                <div class="tt">发明专利数量：</div>
                            </div>
                            <div class="inp_unit">
                                <input class="inp" type="number" v-model="invent" placeholder="没有则填0" />
                            </div>
                        </li>
                        <li>
                            <div class="name">
                                <p>*</p>
                                <div class="tt">著作权数量:</div>
                            </div>
                            <div class="inp_unit">
                                <input class="inp" type="number" v-model="copyright" placeholder="没有则填0" />
                            </div>
                        </li>
                        <li>
                            <div class="name">
                                <p>*</p>
                                <div class="tt">实用新型专利数量:</div>
                            </div>
                            <div class="inp_unit">
                                <input class="inp" type="number" v-model="practical" placeholder="没有则填0" />
                            </div>
                        </li>
                        <li>
                            <div class="name">
                                <p>*</p>
                                <div class="tt">其它：</div>
                            </div>
                            <div class="inp_unit">
                                <input class="inp" type="number" v-model="other" placeholder="没有则填0" />
                            </div>
                        </li>
                        <li>
                            <div class="name">
                                <p>*</p>
                                <div class="tt">商标数量:</div>
                            </div>
                            <div class="inp_unit">
                                <input class="inp" type="number" v-model="brand" placeholder="没有则填0" />
                            </div>
                        </li>
                        <li>
                            <div class="name">
                                <p>*</p>
                                <div class="tt">外观专利数量:</div>
                            </div>
                            <div class="inp_unit">
                                <input class="inp" type="number" v-model="facade" placeholder="没有则填0" />
                            </div>
                        </li>
                        <li v-if="isType==1">
                            <div class="roof_box"></div>
                            <div class="inp_unit">
                                <div class="symbol">*</div>
                                <div class="btn" @click="onLearningDown">下载知识产权调查表</div>
                                <div class="equally" v-if="isEclipse_one">已下载</div>
                            </div>
                        </li>
                        <li v-if="isType==1">
                            <div class="roof_box"></div>
                            <div class="inp_unit">
                                <div class="symbol">*</div>
                                <input 
                                    class="uploadBtn" 
                                    name="key" 
                                    type="file" 
                                    @change="knowledgeFile($event)" 
                                    ref="inputer_knowledge" 
                                    accept=".pdf" 
                                />
                                <div class="btn">上传知识产权调查表</div>
                                <div class="equally" v-if="ip_inquiry!=''">已上传</div>
                            </div>
                        </li>
                    </ul>
                </div>
                <!-- 信息系统管理情况 -->
                <div class="alike alike_one">
                    <div class="top_box">
                        <div class="pattern"></div>
                        <p>信息系统管理情况</p>
                    </div>
                    <dl class="in_detail">
                        <dt>
                            <p>人</p>
                            <div class="flex-1"></div>
                            <p>员</p>
                            <div class="flex-1"></div>
                            <p>管</p>
                            <div class="flex-1"></div>
                            <p>理:</p>
                        </dt>
                        <dd>
                            <div class="row_box">
                                <div class="tt">岗位信息安全和保密责任制度：</div>
                                <div class="row">
                                    <div class="unify" :class="{curr:duty == 1}" @click="onDuty(1)">
                                        <!-- 未选中 -->
                                        <img class="icon" v-if="duty!=1" :src="$config.resource + 'wxz.png'" alt="">
                                        <!-- 已选中 -->
                                        <img class="icon" v-if="duty==1" :src="$config.resource + 'xz.png'" alt="">
                                        <p>已建立</p>
                                    </div>
                                    <div class="unify" :class="{curr:duty == 2}" @click="onDuty(2)">
                                        <!-- 未选中 -->
                                        <img class="icon" v-if="duty!=2" :src="$config.resource + 'wxz.png'" alt="">
                                        <!-- 已选中 -->
                                        <img class="icon" v-if="duty==2" :src="$config.resource + 'xz.png'" alt="">
                                        <p>未建立</p>
                                    </div>
                                </div>
                            </div>
                            <div class="row_box">
                                <div class="tt">重要岗位人员信息安全和保密协议：</div>
                                <div class="row">
                                    <div class="unify" :class="{curr:agreement == 1}" @click="onAgreement(1)">
                                        <!-- 未选中 -->
                                        <img class="icon" v-if="agreement!=1" :src="$config.resource + 'wxz.png'" alt="">
                                        <!-- 已选中 -->
                                        <img class="icon" v-if="agreement==1" :src="$config.resource + 'xz.png'" alt="">
                                        <p>全部签订</p>
                                    </div>
                                    <div class="unify" :class="{curr:agreement == 2}" @click="onAgreement(2)">
                                        <!-- 未选中 -->
                                        <img class="icon" v-if="agreement!=2" :src="$config.resource + 'wxz.png'" alt="">
                                        <!-- 已选中 -->
                                        <img class="icon" v-if="agreement==2" :src="$config.resource + 'xz.png'" alt="">
                                        <p>部分签订</p>
                                    </div>
                                    <div class="unify" :class="{curr:agreement == 3}" @click="onAgreement(3)">
                                        <!-- 未选中 -->
                                        <img class="icon" v-if="agreement!=3" :src="$config.resource + 'wxz.png'" alt="">
                                        <!-- 已选中 -->
                                        <img class="icon" v-if="agreement==3" :src="$config.resource + 'xz.png'" alt="">
                                        <p>均未签订</p>
                                    </div>
                                </div>
                            </div>
                            <div class="row_box">
                                <div class="tt">人员离岗离职安全管理规定：</div>
                                <div class="row">
                                    <div class="unify" :class="{curr:dimission == 1}" @click="onDimission(1)">
                                        <!-- 未选中 -->
                                        <img class="icon" v-if="dimission!=1" :src="$config.resource + 'wxz.png'" alt="">
                                        <!-- 已选中 -->
                                        <img class="icon" v-if="dimission==1" :src="$config.resource + 'xz.png'" alt="">
                                        <p>已制定</p>
                                    </div>
                                    <div class="unify" :class="{curr:dimission == 2}" @click="onDimission(2)">
                                        <!-- 未选中 -->
                                        <img class="icon" v-if="dimission!=2" :src="$config.resource + 'wxz.png'" alt="">
                                        <!-- 已选中 -->
                                        <img class="icon" v-if="dimission==2" :src="$config.resource + 'xz.png'" alt="">
                                        <p>未制定</p>
                                    </div>
                                </div>
                            </div>
                        </dd>
                    </dl>
                    <dl class="in_detail">
                        <dt>
                            <p>资</p>
                            <div class="flex-1"></div>
                            <p>产</p>
                            <div class="flex-1"></div>
                            <p>管</p>
                            <div class="flex-1"></div>
                            <p>理:</p>
                        </dt>
                        <dd>
                            <div class="row_box">
                                <div class="tt">信息安全设备运维管理：</div>
                                <div class="row">
                                    <div class="unify" :class="{curr:safety_manage == 1}" @click="onSafety_manage(1)">
                                        <!-- 未选中 -->
                                        <img class="icon" v-if="safety_manage!=1" :src="$config.resource + 'wxz.png'" alt="">
                                        <!-- 已选中 -->
                                        <img class="icon" v-if="safety_manage==1" :src="$config.resource + 'xz.png'" alt="">
                                        <p>已明确专人负责</p>
                                    </div>
                                    <div class="unify" :class="{curr:safety_manage == 2}" @click="onSafety_manage(2)">
                                        <!-- 未选中 -->
                                        <img class="icon" v-if="safety_manage!=2" :src="$config.resource + 'wxz.png'" alt="">
                                        <!-- 已选中 -->
                                        <img class="icon" v-if="safety_manage==2" :src="$config.resource + 'xz.png'" alt="">
                                        <p>未明确</p>
                                    </div>
                                    <div class="unify" :class="{curr:safety_manage == 3}" @click="onSafety_manage(3)">
                                        <!-- 未选中 -->
                                        <img class="icon" v-if="safety_manage!=3" :src="$config.resource + 'wxz.png'" alt="">
                                        <!-- 已选中 -->
                                        <img class="icon" v-if="safety_manage==3" :src="$config.resource + 'xz.png'" alt="">
                                        <p>定期进行配置检查、日志审计等</p>
                                    </div>
                                    <div class="unify unify_OPS" :class="{curr:safety_manage == 4}" @click="onSafety_manage(4)">
                                        <!-- 未选中 -->
                                        <img class="icon" v-if="safety_manage!=4" :src="$config.resource + 'wxz.png'" alt="">
                                        <!-- 已选中 -->
                                        <img class="icon" v-if="safety_manage==4" :src="$config.resource + 'xz.png'" alt="">
                                        <p>未进行</p>
                                    </div>
                                </div>
                            </div>
                            <div class="row_box">
                                <div class="tt">设备维修维护和报废销毁管理：</div>
                                <div class="row">
                                    <div class="unify scrap" :class="{curr:destroy == 1}" @click="onDestroy(1)">
                                        <!-- 未选中 -->
                                        <img class="icon" v-if="destroy!=1" :src="$config.resource + 'wxz.png'" alt="">
                                        <!-- 已选中 -->
                                        <img class="icon" v-if="destroy==1" :src="$config.resource + 'xz.png'" alt="">
                                        <p>已建立管理制度，且维修维护和报废销毁记录完整</p>
                                    </div>
                                    <div class="unify scrap" :class="{curr:destroy == 2}" @click="onDestroy(2)">
                                        <!-- 未选中 -->
                                        <img class="icon" v-if="destroy!=2" :src="$config.resource + 'wxz.png'" alt="">
                                        <!-- 已选中 -->
                                        <img class="icon" v-if="destroy==2" :src="$config.resource + 'xz.png'" alt="">
                                        <p>已建立管理制度，且维修维护和报废销毁记录不完整</p>
                                    </div>
                                    <div class="unify" :class="{curr:destroy == 3}" @click="onDestroy(3)">
                                        <!-- 未选中 -->
                                        <img class="icon" v-if="destroy!=3" :src="$config.resource + 'wxz.png'" alt="">
                                        <!-- 已选中 -->
                                        <img class="icon" v-if="destroy==3" :src="$config.resource + 'xz.png'" alt="">
                                        <p>尚未建立管理制度</p>
                                    </div>
                                </div>
                            </div>
                        </dd>
                    </dl>
                </div>
                <!-- 信息安全防护管理情况 -->
                <div class="alike">
                    <div class="top_box">
                        <div class="pattern"></div>
                        <p>信息安全防护管理情况</p>
                    </div>
                    <dl class="in_detail">
                        <dt>网络边界防护管理：</dt>
                        <dd>
                            <div class="row_box">
                                <div class="tt">网络区域划分是否合理：</div>
                                <div class="row">
                                    <div class="unify" :class="{curr:areas == 1}" @click="onArea(1)">
                                        <!-- 未选中 -->
                                        <img class="icon" v-if="areas!=1" :src="$config.resource + 'wxz.png'" alt="">
                                        <!-- 已选中 -->
                                        <img class="icon" v-if="areas==1" :src="$config.resource + 'xz.png'" alt="">
                                        <p>合理</p>
                                    </div>
                                    <div class="unify" :class="{curr:areas == 2}" @click="onArea(2)">
                                        <!-- 未选中 -->
                                        <img class="icon" v-if="areas!=2" :src="$config.resource + 'wxz.png'" alt="">
                                        <!-- 已选中 -->
                                        <img class="icon" v-if="areas==2" :src="$config.resource + 'xz.png'" alt="">
                                        <p>不合理</p>
                                    </div>
                                </div>
                            </div>
                            <div class="row_box">
                                <div class="tt">安全防护设备策略：</div>
                                <div class="row">
                                    <div class="unify" :class="{curr:tactics == 1}" @click="onTactics(1)">
                                        <!-- 未选中 -->
                                        <img class="icon" v-if="tactics!=1" :src="$config.resource + 'wxz.png'" alt="">
                                        <!-- 已选中 -->
                                        <img class="icon" v-if="tactics==1" :src="$config.resource + 'xz.png'" alt="">
                                        <p>使用默认配置</p>
                                    </div>
                                    <div class="unify" :class="{curr:tactics == 2}" @click="onTactics(2)">
                                        <!-- 未选中 -->
                                        <img class="icon" v-if="tactics!=2" :src="$config.resource + 'wxz.png'" alt="">
                                        <!-- 已选中 -->
                                        <img class="icon" v-if="tactics==2" :src="$config.resource + 'xz.png'" alt="">
                                        <p>根据应用自主配置</p>
                                    </div>
                                </div>
                            </div>
                            <div class="row_box">
                                <div class="tt">互联网访问控制：</div>
                                <div class="row">
                                    <div class="unify" :class="{curr:control == 1}" @click="onControl(1)">
                                        <!-- 未选中 -->
                                        <img class="icon" v-if="control!=1" :src="$config.resource + 'wxz.png'" alt="">
                                        <!-- 已选中 -->
                                        <img class="icon" v-if="control==1" :src="$config.resource + 'xz.png'" alt="">
                                        <p>有访问控制措施</p>
                                    </div>
                                    <div class="unify" :class="{curr:control == 2}" @click="onControl(2)">
                                        <!-- 未选中 -->
                                        <img class="icon" v-if="control!=2" :src="$config.resource + 'wxz.png'" alt="">
                                        <!-- 已选中 -->
                                        <img class="icon" v-if="control==2" :src="$config.resource + 'xz.png'" alt="">
                                        <p>无访问控制措施</p>
                                    </div>
                                </div>
                            </div>
                            <div class="row_box">
                                <div class="tt">互联网访问日志：</div>
                                <div class="row">
                                    <div class="unify" :class="{curr:log == 1}" @click="onLog(1)">
                                        <!-- 未选中 -->
                                        <img class="icon" v-if="log!=1" :src="$config.resource + 'wxz.png'" alt="">
                                        <!-- 已选中 -->
                                        <img class="icon" v-if="log==1" :src="$config.resource + 'xz.png'" alt="">
                                        <p>留存日志</p>
                                    </div>
                                    <div class="unify" :class="{curr:log == 2}" @click="onLog(2)">
                                        <!-- 未选中 -->
                                        <img class="icon" v-if="log!=2" :src="$config.resource + 'wxz.png'" alt="">
                                        <!-- 已选中 -->
                                        <img class="icon" v-if="log==2" :src="$config.resource + 'xz.png'" alt="">
                                        <p>未留存日志</p>
                                    </div>
                                </div>
                            </div>
                        </dd>
                    </dl>
                    <dl class="in_detail">
                        <dt>门户网站应用管理：</dt>
                        <dd>
                            <div class="row_box">
                                <div class="tt">网站</div>
                                <div class="inp_wrap">
                                    <div class="name_inp">
                                        <div class="name">域名：</div>
                                        <div class="inp_box">
                                            <input class="inp" type="text" name="" id="" v-model="org" />
                                        </div>
                                    </div>
                                    <div class="name_inp">
                                        <div class="name">IP地址：</div>
                                        <div class="inp_box">
                                            <input class="inp" type="text" name="" id="" v-model="address" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row_box">
                                <div class="tt">网站是否备案：</div>
                                <div class="row">
                                    <div class="unify" :class="{curr:file == 1}" @click="onFile(1)">
                                        <!-- 未选中 -->
                                        <img class="icon" v-if="file!=1" :src="$config.resource + 'wxz.png'" alt="">
                                        <!-- 已选中 -->
                                        <img class="icon" v-if="file==1" :src="$config.resource + 'xz.png'" alt="">
                                        <p>是</p>
                                    </div>
                                    <div class="unify" :class="{curr:file == 2}" @click="onFile(2)">
                                        <!-- 未选中 -->
                                        <img class="icon" v-if="file!=2" :src="$config.resource + 'wxz.png'" alt="">
                                        <!-- 已选中 -->
                                        <img class="icon" v-if="file==2" :src="$config.resource + 'xz.png'" alt="">
                                        <p>否</p>
                                    </div>
                                </div>
                            </div>
                            <div class="row_box">
                                <div class="tt">门户网站账户安全管理：</div>
                                <div class="row">
                                    <div class="unify" :class="{curr:account == 1}" @click="onAccount(1)">
                                        <!-- 未选中 -->
                                        <img class="icon" v-if="account!=1" :src="$config.resource + 'wxz.png'" alt="">
                                        <!-- 已选中 -->
                                        <img class="icon" v-if="account==1" :src="$config.resource + 'xz.png'" alt="">
                                        <p>已清理无关账户</p>
                                    </div>
                                    <div class="unify" :class="{curr:account == 2}" @click="onAccount(2)">
                                        <!-- 未选中 -->
                                        <img class="icon" v-if="account!=2" :src="$config.resource + 'wxz.png'" alt="">
                                        <!-- 已选中 -->
                                        <img class="icon" v-if="account==2" :src="$config.resource + 'xz.png'" alt="">
                                        <p>未清理</p>
                                    </div>
                                    <div class="unify" :class="{curr:account == 3}" @click="onAccount(3)">
                                        <!-- 未选中 -->
                                        <img class="icon" v-if="account!=3" :src="$config.resource + 'wxz.png'" alt="">
                                        <!-- 已选中 -->
                                        <img class="icon" v-if="account==3" :src="$config.resource + 'xz.png'" alt="">
                                        <p>无，空口令、弱口令和默认口令</p>
                                    </div>
                                </div>
                            </div>
                            <div class="row_box">
                                <div class="tt">清理网站临时文件、关闭网站目录遍历功能等清理：</div>
                                <div class="row">
                                    <div class="unify" :class="{curr:clear == 1}" @click="onClear(1)">
                                        <!-- 未选中 -->
                                        <img class="icon" v-if="clear!=1" :src="$config.resource + 'wxz.png'" alt="">
                                        <!-- 已选中 -->
                                        <img class="icon" v-if="clear==1" :src="$config.resource + 'xz.png'" alt="">
                                        <p>已清理</p>
                                    </div>
                                    <div class="unify" :class="{curr:clear == 2}" @click="onClear(2)">
                                        <!-- 未选中 -->
                                        <img class="icon" v-if="clear!=2" :src="$config.resource + 'wxz.png'" alt="">
                                        <!-- 已选中 -->
                                        <img class="icon" v-if="clear==2" :src="$config.resource + 'xz.png'" alt="">
                                        <p>未清理</p>
                                    </div>
                                </div>
                            </div>
                            <div class="row_box">
                                <div class="tt">门户网站信息发布管理：</div>
                                <div class="row">
                                    <div class="unify portal" :class="{curr:issue == 1}" @click="onIssue(1)">
                                        <!-- 未选中 -->
                                        <img class="icon" v-if="issue!=1" :src="$config.resource + 'wxz.png'" alt="">
                                        <!-- 已选中 -->
                                        <img class="icon" v-if="issue==1" :src="$config.resource + 'xz.png'" alt="">
                                        <p>已建立审核制度，且审核记录完整</p>
                                    </div>
                                    <div class="unify portal" :class="{curr:issue == 2}" @click="onIssue(2)">
                                        <!-- 未选中 -->
                                        <img class="icon" v-if="issue!=2" :src="$config.resource + 'wxz.png'" alt="">
                                        <!-- 已选中 -->
                                        <img class="icon" v-if="issue==2" :src="$config.resource + 'xz.png'" alt="">
                                        <p>已建立审核制度，但审核记录不完整</p>
                                    </div>
                                    <div class="unify" :class="{curr:issue == 3}" @click="onIssue(3)">
                                        <!-- 未选中 -->
                                        <img class="icon" v-if="issue!=3" :src="$config.resource + 'wxz.png'" alt="">
                                        <!-- 已选中 -->
                                        <img class="icon" v-if="issue==3" :src="$config.resource + 'xz.png'" alt="">
                                        <p>尚未建立审核制度</p>
                                    </div>
                                </div>
                            </div>
                        </dd>
                    </dl>
                    <dl class="in_detail">
                        <dt>存储设备安全管理：</dt>
                        <dd>
                            <div class="row_box">
                                <div class="tt">移动储蓄设备管理方式：</div>
                                <div class="row">
                                    <div class="unify allocate" :class="{curr:savings == 1}" @click="onSavings(1)">
                                        <!-- 未选中 -->
                                        <img class="icon" v-if="savings!=1" :src="$config.resource + 'wxz.png'" alt="">
                                        <!-- 已选中 -->
                                        <img class="icon" v-if="savings==1" :src="$config.resource + 'xz.png'" alt="">
                                        <p>集中管理，同意登记、配发、回收、维修、报废、销毁</p>
                                    </div>
                                    <div class="unify" :class="{curr:savings == 2}" @click="onSavings(2)">
                                        <!-- 未选中 -->
                                        <img class="icon" v-if="savings!=2" :src="$config.resource + 'wxz.png'" alt="">
                                        <!-- 已选中 -->
                                        <img class="icon" v-if="savings==2" :src="$config.resource + 'xz.png'" alt="">
                                        <p>未采取集中管理相关措施</p>
                                    </div>
                                </div>
                            </div>
                            <div class="row_box">
                                <div class="tt">在非涉密信息系统和涉密信息系统间混用情况：</div>
                                <div class="row">
                                    <div class="unify" :class="{curr:blended == 1}" @click="onBlended(1)">
                                        <!-- 未选中 -->
                                        <img class="icon" v-if="blended!=1" :src="$config.resource + 'wxz.png'" alt="">
                                        <!-- 已选中 -->
                                        <img class="icon" v-if="blended==1" :src="$config.resource + 'xz.png'" alt="">
                                        <p>不存在</p>
                                    </div>
                                    <div class="unify" :class="{curr:blended == 2}" @click="onBlended(2)">
                                        <!-- 未选中 -->
                                        <img class="icon" v-if="blended!=2" :src="$config.resource + 'wxz.png'" alt="">
                                        <!-- 已选中 -->
                                        <img class="icon" v-if="blended==2" :src="$config.resource + 'xz.png'" alt="">
                                        <p>存在</p>
                                    </div>
                                </div>
                            </div>
                        </dd>
                    </dl>
                    <dl class="in_detail">
                        <dt>信息系统安全管理：</dt>
                        <dd>
                            <div class="row_box">
                                <div class="tt">服务器安全防护：</div>
                                <div class="tt">不必要的应用、服务、端口:</div>
                                <div class="row fence">
                                    <div class="unify" :class="{curr:serve == 1}" @click="onServe(1)">
                                        <!-- 未选中 -->
                                        <img class="icon" v-if="serve!=1" :src="$config.resource + 'wxz.png'" alt="">
                                        <!-- 已选中 -->
                                        <img class="icon" v-if="serve==1" :src="$config.resource + 'xz.png'" alt="">
                                        <p>关闭</p>
                                    </div>
                                    <div class="unify" :class="{curr:serve == 2}" @click="onServe(2)">
                                        <!-- 未选中 -->
                                        <img class="icon" v-if="serve!=2" :src="$config.resource + 'wxz.png'" alt="">
                                        <!-- 已选中 -->
                                        <img class="icon" v-if="serve==2" :src="$config.resource + 'xz.png'" alt="">
                                        <p>未关闭</p>
                                    </div>
                                </div>
                                <div class="tt">账户口令设置8位，包含数字、字母或符号:</div>
                                <div class="row fence">
                                    <div class="unify" :class="{curr:set_one == 1}" @click="onSet_one(1)">
                                        <!-- 未选中 -->
                                        <img class="icon" v-if="set_one!=1" :src="$config.resource + 'wxz.png'" alt="">
                                        <!-- 已选中 -->
                                        <img class="icon" v-if="set_one==1" :src="$config.resource + 'xz.png'" alt="">
                                        <p>满足</p>
                                    </div>
                                    <div class="unify" :class="{curr:set_one == 2}" @click="onSet_one(2)">
                                        <!-- 未选中 -->
                                        <img class="icon" v-if="set_one!=2" :src="$config.resource + 'wxz.png'" alt="">
                                        <!-- 已选中 -->
                                        <img class="icon" v-if="set_one==2" :src="$config.resource + 'xz.png'" alt="">
                                        <p>不满足</p>
                                    </div>
                                </div>
                                <div class="tt">扫描、病毒木马监测:</div>
                                <div class="row fence">
                                    <div class="unify" :class="{curr:scan_one == 1}" @click="onScan_one(1)">
                                        <!-- 未选中 -->
                                        <img class="icon" v-if="scan_one!=1" :src="$config.resource + 'wxz.png'" alt="">
                                        <!-- 已选中 -->
                                        <img class="icon" v-if="scan_one==1" :src="$config.resource + 'xz.png'" alt="">
                                        <p>定期进行</p>
                                    </div>
                                    <div class="unify" :class="{curr:scan_one == 2}" @click="onScan_one(2)">
                                        <!-- 未选中 -->
                                        <img class="icon" v-if="scan_one!=2" :src="$config.resource + 'wxz.png'" alt="">
                                        <!-- 已选中 -->
                                        <img class="icon" v-if="scan_one==2" :src="$config.resource + 'xz.png'" alt="">
                                        <p>未进行</p>
                                    </div>
                                </div>
                            </div>
                            <div class="row_box">
                                <div class="tt">网络设备防护：</div>
                                <div class="tt">安全策略配置:</div>
                                <div class="row fence">
                                    <div class="unify" :class="{curr:defend == 1}" @click="onDefend(1)">
                                        <!-- 未选中 -->
                                        <img class="icon" v-if="defend!=1" :src="$config.resource + 'wxz.png'" alt="">
                                        <!-- 已选中 -->
                                        <img class="icon" v-if="defend==1" :src="$config.resource + 'xz.png'" alt="">
                                        <p>有效</p>
                                    </div>
                                    <div class="unify" :class="{curr:defend == 2}" @click="onDefend(2)">
                                        <!-- 未选中 -->
                                        <img class="icon" v-if="defend!=2" :src="$config.resource + 'wxz.png'" alt="">
                                        <!-- 已选中 -->
                                        <img class="icon" v-if="defend==2" :src="$config.resource + 'xz.png'" alt="">
                                        <p>无效</p>
                                    </div>
                                </div>
                                <div class="tt">账户口令设置8位，包含数字、字母或符号:</div>
                                <div class="row fence">
                                    <div class="unify" :class="{curr:set_two == 1}" @click="onSet_two(1)">
                                        <!-- 未选中 -->
                                        <img class="icon" v-if="set_two!=1" :src="$config.resource + 'wxz.png'" alt="">
                                        <!-- 已选中 -->
                                        <img class="icon" v-if="set_two==1" :src="$config.resource + 'xz.png'" alt="">
                                        <p>满足</p>
                                    </div>
                                    <div class="unify" :class="{curr:set_two == 2}" @click="onSet_two(2)">
                                        <!-- 未选中 -->
                                        <img class="icon" v-if="set_two!=2" :src="$config.resource + 'wxz.png'" alt="">
                                        <!-- 已选中 -->
                                        <img class="icon" v-if="set_two==2" :src="$config.resource + 'xz.png'" alt="">
                                        <p>不满足</p>
                                    </div>
                                </div>
                                <div class="tt">扫描、病毒木马监测:</div>
                                <div class="row fence">
                                    <div class="unify" :class="{curr:scan_two == 1}" @click="onScan_two(1)">
                                        <!-- 未选中 -->
                                        <img class="icon" v-if="scan_two!=1" :src="$config.resource + 'wxz.png'" alt="">
                                        <!-- 已选中 -->
                                        <img class="icon" v-if="scan_two==1" :src="$config.resource + 'xz.png'" alt="">
                                        <p>定期进行</p>
                                    </div>
                                    <div class="unify" :class="{curr:scan_two == 2}" @click="onScan_two(2)">
                                        <!-- 未选中 -->
                                        <img class="icon" v-if="scan_two!=2" :src="$config.resource + 'wxz.png'" alt="">
                                        <!-- 已选中 -->
                                        <img class="icon" v-if="scan_two==2" :src="$config.resource + 'xz.png'" alt="">
                                        <p>未进行</p>
                                    </div>
                                </div>
                            </div>
                            <div class="row_box">
                                <div class="tt">信息安全设备部署及使用：</div>
                                <div class="tt">防病毒、防火墙、入侵检测、安全审计等功能的设备:</div>
                                <div class="row fence">
                                    <div class="unify" :class="{curr:deploy == 1}" @click="onDeploy(1)">
                                        <!-- 未选中 -->
                                        <img class="icon" v-if="deploy!=1" :src="$config.resource + 'wxz.png'" alt="">
                                        <!-- 已选中 -->
                                        <img class="icon" v-if="deploy==1" :src="$config.resource + 'xz.png'" alt="">
                                        <p>已部署</p>
                                    </div>
                                    <div class="unify" :class="{curr:deploy == 2}" @click="onDeploy(2)">
                                        <!-- 未选中 -->
                                        <img class="icon" v-if="deploy!=2" :src="$config.resource + 'wxz.png'" alt="">
                                        <!-- 已选中 -->
                                        <img class="icon" v-if="deploy==2" :src="$config.resource + 'xz.png'" alt="">
                                        <p>未部署</p>
                                    </div>
                                    
                                </div>
                                <div class="tt">安全策略配置:</div>
                                <div class="row fence">
                                    <div class="unify" :class="{curr:deploy_two == 1}" @click="onDeploy_two(1)">
                                        <!-- 未选中 -->
                                        <img class="icon" v-if="deploy_two!=1" :src="$config.resource + 'wxz.png'" alt="">
                                        <!-- 已选中 -->
                                        <img class="icon" v-if="deploy_two==1" :src="$config.resource + 'xz.png'" alt="">
                                        <p>有效</p>
                                    </div>
                                    <div class="unify" :class="{curr:deploy_two == 2}" @click="onDeploy_two(2)">
                                        <!-- 未选中 -->
                                        <img class="icon" v-if="deploy_two!=2" :src="$config.resource + 'wxz.png'" alt="">
                                        <!-- 已选中 -->
                                        <img class="icon" v-if="deploy_two==2" :src="$config.resource + 'xz.png'" alt="">
                                        <p>无效</p>
                                    </div>
                                </div>
                            </div>
                        </dd>
                    </dl>
                    <dl class="in_detail">
                        <dt>终端计算机安全管理：</dt>
                        <dd>
                            <div class="row_box">
                                <div class="tt">终端计算机安全管理方式：</div>
                                <div class="row fence">
                                    <div class="unify" :class="{curr:way == 1}" @click="onWay(1)">
                                        <!-- 未选中 -->
                                        <img class="icon" v-if="way!=1" :src="$config.resource + 'wxz.png'" alt="">
                                        <!-- 已选中 -->
                                        <img class="icon" v-if="way==1" :src="$config.resource + 'xz.png'" alt="">
                                        <p>使用同意平台对终端计算机进行集中管理</p>
                                    </div>
                                    <div class="unify" :class="{curr:way == 2}" @click="onWay(2)">
                                        <!-- 未选中 -->
                                        <img class="icon" v-if="way!=2" :src="$config.resource + 'wxz.png'" alt="">
                                        <!-- 已选中 -->
                                        <img class="icon" v-if="way==2" :src="$config.resource + 'xz.png'" alt="">
                                        <p>用户分散管理</p>
                                    </div>
                                </div>
                            </div>
                            <div class="row_box">
                                <div class="tt">账户口令管理：</div>
                                <div class="row fence">
                                    <div class="unify" :class="{curr:word == 1}" @click="onWord(1)">
                                        <!-- 未选中 -->
                                        <img class="icon" v-if="word!=1" :src="$config.resource + 'wxz.png'" alt="">
                                        <!-- 已选中 -->
                                        <img class="icon" v-if="word==1" :src="$config.resource + 'xz.png'" alt="">
                                        <p>无，空口令、弱口令和默认口令</p>
                                    </div>
                                    <div class="unify" :class="{curr:word == 2}" @click="onWord(2)">
                                        <!-- 未选中 -->
                                        <img class="icon" v-if="word!=2" :src="$config.resource + 'wxz.png'" alt="">
                                        <!-- 已选中 -->
                                        <img class="icon" v-if="word==2" :src="$config.resource + 'xz.png'" alt="">
                                        <p>有</p>
                                    </div>
                                </div>
                            </div>
                            <div class="row_box">
                                <div class="tt">接入互联网安全控制措施：</div>
                                <div class="row">
                                    <div class="unify internet" :class="{curr:measure == 1}" @click="onMeasure(1)">
                                        <!-- 未选中 -->
                                        <img class="icon" v-if="measure!=1" :src="$config.resource + 'wxz.png'" alt="">
                                        <!-- 已选中 -->
                                        <img class="icon" v-if="measure==1" :src="$config.resource + 'xz.png'" alt="">
                                        <p>有控制措施（如实名接入、绑定计算机IP和MAC地址等）</p>
                                    </div>
                                    <div class="unify" :class="{curr:measure == 2}" @click="onMeasure(2)">
                                        <!-- 未选中 -->
                                        <img class="icon" v-if="measure!=2" :src="$config.resource + 'wxz.png'" alt="">
                                        <!-- 已选中 -->
                                        <img class="icon" v-if="measure==2" :src="$config.resource + 'xz.png'" alt="">
                                        <p>无控制措施</p>
                                    </div>
                                </div>
                            </div>
                            <div class="row_box">
                                <div class="tt">在非涉密信息系统和涉密信息系统混合使用情况：</div>
                                <div class="row">
                                    <div class="unify" :class="{curr:mingle == 1}" @click="onMingle(1)">
                                        <!-- 未选中 -->
                                        <img class="icon" v-if="mingle!=1" :src="$config.resource + 'wxz.png'" alt="">
                                        <!-- 已选中 -->
                                        <img class="icon" v-if="mingle==1" :src="$config.resource + 'xz.png'" alt="">
                                        <p>不存在</p>
                                    </div>
                                    <div class="unify" :class="{curr:mingle == 2}" @click="onMingle(2)">
                                        <!-- 未选中 -->
                                        <img class="icon" v-if="mingle!=2" :src="$config.resource + 'wxz.png'" alt="">
                                        <!-- 已选中 -->
                                        <img class="icon" v-if="mingle==2" :src="$config.resource + 'xz.png'" alt="">
                                        <p>存在</p>
                                    </div>
                                </div>
                            </div>
                            <div class="row_box">
                                <div class="tt">漏洞扫描木马检测：</div>
                                <div class="row">
                                    <div class="unify" :class="{curr:scan == 1}" @click="onScan(1)">
                                        <!-- 未选中 -->
                                        <img class="icon" v-if="scan!=1" :src="$config.resource + 'wxz.png'" alt="">
                                        <!-- 已选中 -->
                                        <img class="icon" v-if="scan==1" :src="$config.resource + 'xz.png'" alt="">
                                        <p>定期进行</p>
                                    </div>
                                    <div class="unify" :class="{curr:scan == 2}" @click="onScan(2)">
                                        <!-- 未选中 -->
                                        <img class="icon" v-if="scan!=2" :src="$config.resource + 'wxz.png'" alt="">
                                        <!-- 已选中 -->
                                        <img class="icon" v-if="scan==2" :src="$config.resource + 'xz.png'" alt="">
                                        <p>未进行</p>
                                    </div>
                                </div>
                            </div>
                            <div class="row_box">
                                <div class="tt">是否存在使用非涉密计算计算机处理涉密信息情况：</div>
                                <div class="row">
                                    <div class="unify" :class="{curr:existIndex == 1}" @click="onExist(1)">
                                        <!-- 未选中 -->
                                        <img class="icon" v-if="existIndex!=1" :src="$config.resource + 'wxz.png'" alt="">
                                        <!-- 已选中 -->
                                        <img class="icon" v-if="existIndex==1" :src="$config.resource + 'xz.png'" alt="">
                                        <p>不存在</p>
                                    </div>
                                    <div class="unify" :class="{curr:existIndex == 2}" @click="onExist(2)">
                                        <!-- 未选中 -->
                                        <img class="icon" v-if="existIndex!=2" :src="$config.resource + 'wxz.png'" alt="">
                                        <!-- 已选中 -->
                                        <img class="icon" v-if="existIndex==2" :src="$config.resource + 'xz.png'" alt="">
                                        <p>存在，请描述事件：</p>
                                        <div class="relation">
                                            <input v-if="existIndex==2" class="inp" type="text" v-model="exist" ref="exist_one" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </dd>
                    </dl>
                </div>
                <!-- 信息安全应急管理情况 -->
                <div class="alike">
                    <div class="top_box">
                        <div class="pattern"></div>
                        <p>信息安全应急管理情况</p>
                    </div>
                    <div class="parallel">
                        <div class="tt">应急预案制定及备案情况：</div>
                        <div class="row">
                            <div class="unify" :class="{curr:enact == 1}" @click="onEnact(1)">
                                <!-- 未选中 -->
                                <img class="icon" v-if="enact!=1" :src="$config.resource + 'wxz.png'" alt="">
                                <!-- 已选中 -->
                                <img class="icon" v-if="enact==1" :src="$config.resource + 'xz.png'" alt="">
                                <p>已备案</p>
                            </div>
                            <div class="unify" :class="{curr:enact == 2}" @click="onEnact(2)">
                                <!-- 未选中 -->
                                <img class="icon" v-if="enact!=2" :src="$config.resource + 'wxz.png'" alt="">
                                <!-- 已选中 -->
                                <img class="icon" v-if="enact==2" :src="$config.resource + 'xz.png'" alt="">
                                <p>已制定但未备案</p>
                            </div>
                            <div class="unify" :class="{curr:enact == 3}" @click="onEnact(3)">
                                <!-- 未选中 -->
                                <img class="icon" v-if="enact!=3" :src="$config.resource + 'wxz.png'" alt="">
                                <!-- 已选中 -->
                                <img class="icon" v-if="enact==3" :src="$config.resource + 'xz.png'" alt="">
                                <p>未制定</p>
                            </div>
                        </div>
                    </div>
                    <div class="parallel">
                        <div class="tt">应急技术支援队伍：</div>
                        <div class="row">
                            <div class="unify" :class="{curr:skill == 1}" @click="onSkill(1)">
                                <!-- 未选中 -->
                                <img class="icon" v-if="skill!=1" :src="$config.resource + 'wxz.png'" alt="">
                                <!-- 已选中 -->
                                <img class="icon" v-if="skill==1" :src="$config.resource + 'xz.png'" alt="">
                                <p>本单位自身力量</p>
                            </div>
                            <div class="unify" :class="{curr:skill == 2}" @click="onSkill(2)">
                                <!-- 未选中 -->
                                <img class="icon" v-if="skill!=2" :src="$config.resource + 'wxz.png'" alt="">
                                <!-- 已选中 -->
                                <img class="icon" v-if="skill==2" :src="$config.resource + 'xz.png'" alt="">
                                <p>外部专业机构</p>
                            </div>
                            <div class="unify" :class="{curr:skill == 3}" @click="onSkill(3)">
                                <!-- 未选中 -->
                                <img class="icon" v-if="skill!=3" :src="$config.resource + 'wxz.png'" alt="">
                                <!-- 已选中 -->
                                <img class="icon" v-if="skill==3" :src="$config.resource + 'xz.png'" alt="">
                                <p>未明确</p>
                            </div>
                        </div>
                    </div>
                    <dl class="backups">
                        <dt>
                            <p>信</p>
                            <div class="flex-1"></div>
                            <p>息</p>
                            <div class="flex-1"></div>
                            <p>安</p>
                            <div class="flex-1"></div>
                            <p>全</p>
                            <div class="flex-1"></div>
                            <p>备</p>
                            <div class="flex-1"></div>
                            <p>份:</p>
                            <div class="flex-1"></div>
                        </dt>
                        <dd>
                            <div class="row_box">
                                <div class="tt">重要数据</div>
                                <div class="row">
                                    <div class="unify" :class="{curr:wd == 1}" @click="onWd(1)">
                                        <!-- 未选中 -->
                                        <img class="icon" v-if="wd!=1" :src="$config.resource + 'wxz.png'" alt="">
                                        <!-- 已选中 -->
                                        <img class="icon" v-if="wd==1" :src="$config.resource + 'xz.png'" alt="">
                                        <p>备份</p>
                                    </div>
                                    <div class="unify" :class="{curr:wd == 2}" @click="onWd(2)">
                                        <!-- 未选中 -->
                                        <img class="icon" v-if="wd!=2" :src="$config.resource + 'wxz.png'" alt="">
                                        <!-- 已选中 -->
                                        <img class="icon" v-if="wd==2" :src="$config.resource + 'xz.png'" alt="">
                                        <p>未备份</p>
                                    </div>
                                </div>
                            </div>
                            <div class="row_box">
                                <div class="tt">重要信息系统</div>
                                <div class="row">
                                    <div class="unify" :class="{curr:lineage == 1}" @click="onLineage(1)">
                                        <!-- 未选中 -->
                                        <img class="icon" v-if="lineage!=1" :src="$config.resource + 'wxz.png'" alt="">
                                        <!-- 已选中 -->
                                        <img class="icon" v-if="lineage==1" :src="$config.resource + 'xz.png'" alt="">
                                        <p>备份</p>
                                    </div>
                                    <div class="unify" :class="{curr:lineage == 2}" @click="onLineage(2)">
                                        <!-- 未选中 -->
                                        <img class="icon" v-if="lineage!=2" :src="$config.resource + 'wxz.png'" alt="">
                                        <!-- 已选中 -->
                                        <img class="icon" v-if="lineage==2" :src="$config.resource + 'xz.png'" alt="">
                                        <p>未备份</p>
                                    </div>
                                </div>
                            </div>
                        </dd>
                    </dl>
                </div>
                <!-- 信息安全教育培训情况 -->
                <div class="alike">
                    <div class="top_box">
                        <div class="pattern"></div>
                        <p>信息安全教育培训情况</p>
                    </div>
                    <div class="train_box">
                        <div class="attend_box">
                            <div class="name">参加培训情况：</div>
                            <div class="select_box">
                                <div class="unify" :class="{curr:trainIndex == 1}" @click="onTrain(1)">
                                    <!-- 未选中 -->
                                    <img class="icon" v-if="trainIndex!=1" :src="$config.resource + 'wxz.png'" alt="">
                                    <!-- 已选中 -->
                                    <img class="icon" v-if="trainIndex==1" :src="$config.resource + 'xz.png'" alt="">
                                    <p>本年度是否派员参加信息安全相关业务培训，人/次数：</p>
                                    <div class="relation">
                                        <input v-if="trainIndex==1" class="inp" type="text" v-model="attend" ref="attend" />
                                    </div>
                                    <p>培训部门名称：</p>
                                    <div class="relation_two">
                                        <input v-if="trainIndex==1" class="inp" type="text" v-model="branch" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="attend_box">
                            <div class="name">组织培训情况：</div>
                            <div class="select_box">
                                <div class="unify" :class="{curr:tissueIndex == 1}" @click="onTissue(1)">
                                    <!-- 未选中 -->
                                    <img class="icon" v-if="tissueIndex!=1" :src="$config.resource + 'wxz.png'" alt="">
                                    <!-- 已选中 -->
                                    <img class="icon" v-if="tissueIndex==1" :src="$config.resource + 'xz.png'" alt="">
                                    <p>本年度是否组织展开信息安全教育培训，次数：</p>
                                    <div class="organization">
                                        <input v-if="tissueIndex==1" class="inp" type="text" v-model="tissue" ref="tissue" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row row_two">
                            <div class="tt">参训人员比例：</div>
                            <div class="name_inp">
                                <div class="name name_two">本年度参加信息安全教育培训的人员占总人数比例为：</div>
                                <div class="inp_box">
                                    <input class="inp" type="text" name="" id="" v-model="ratio" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 本年度信息安全事件情况 -->
                <div class="alike">
                    <div class="top_box">
                        <div class="pattern"></div>
                        <p>本年度信息安全事件情况</p>
                    </div>
                    <div class="COUNT">
                        <div class="name">本年度安全事件统计：</div>
                        <div class="COUNT_box">
                            <div class="equal">
                                <div class="left_box">
                                    <div class="tt">进行过病毒木马等恶意代码检查服务器的台数：</div>
                                    <div class="inp_box inp_first">
                                        <input class="inp" type="number" name="" id="" v-model="virus" />
                                    </div>
                                </div>
                                <div class="right_box">
                                    <div class="tt">其中感染恶意代码的服务器台数：</div>
                                    <div class="inp_box inp_first">
                                        <input class="inp" type="number" name="" id="" v-model="infection" />
                                    </div>
                                </div>
                            </div>
                            <div class="equal">
                                <div class="left_box">
                                    <div class="tt">进行过病毒木马等恶意代码检测的终端计算机台数：</div>
                                    <div class="inp_box">
                                        <input class="inp" type="number" name="" id="" v-model="viciousness" />
                                    </div>
                                </div>
                                <div class="right_box">
                                    <div class="tt">其中感染恶意代码的终端计算机台数：</div>
                                    <div class="inp_box">
                                        <input class="inp" type="number" name="" id="" v-model="venom" />
                                    </div>
                                </div>
                            </div>
                            <div class="equal">
                                <div class="left_box">
                                    <div class="tt">进行过漏洞扫描的服务器台数：</div>
                                    <div class="inp_box inp_second">
                                        <input class="inp" type="number" name="" id="" v-model="flaw " />
                                    </div>
                                </div>
                                <div class="right_box">
                                    <div class="tt">其中存在漏洞的服务器台数：</div>
                                    <div class="inp_box inp_second">
                                        <input class="inp" type="number" name="" id="" v-model="loophole" />
                                    </div>
                                </div>
                            </div>
                            <div class="equal">
                                <div class="left_box">
                                    <div class="tt">其中存在高风险漏洞的服务器台数：</div>
                                    <div class="inp_box inp_third">
                                        <input class="inp" type="number" name="" id="" v-model="defect" />
                                    </div>
                                </div>
                            </div>
                            <div class="equal">
                                <div class="left_box">
                                    <div class="tt">进行过漏洞扫描的终端计算机台数：</div>
                                    <div class="inp_box inp_third">
                                        <input class="inp" type="number" name="" id="" v-model="leak" />
                                    </div>
                                </div>
                                <div class="right_box">
                                    <div class="tt">其中存在漏洞的终端计算器台数：</div>
                                    <div class="inp_box inp_first">
                                        <input class="inp" type="number" name="" id="" v-model="hole" />
                                    </div>
                                </div>
                            </div>
                            <div class="equal">
                                <div class="left_box">
                                    <div class="tt">其中存在高风险漏洞的终端计算器台数：</div>
                                    <div class="inp_box inp_fourth">
                                        <input class="inp" type="number" name="" id="" v-model="high_risk" />
                                    </div>
                                </div>
                            </div>
                            <div class="equal">
                                <div class="left_box">
                                    <div class="tt">门户网站网页被篡改（内含嵌恶意代码）次数：</div>
                                    <div class="inp_box inp_first">
                                        <input class="inp" type="number" name="" id="" v-model="spite" />
                                    </div>
                                </div>
                            </div>
                            <div class="equal">
                                <div class="left_box">
                                    <div class="tt">使用非涉密终端计算机处理涉密信息事件数：</div>
                                    <div class="inp_box">
                                        <input class="inp" type="number" name="" id="" v-model="use" />
                                    </div>
                                </div>
                            </div>
                            <div class="equal">
                                <div class="left_box">
                                    <div class="tt">终端计算机在非涉密系统和涉密系统间混用事件数：</div>
                                    <div class="inp_box">
                                        <input class="inp" type="number" name="" id="" v-model="system" />
                                    </div>
                                </div>
                            </div>
                            <div class="equal">
                                <div class="finally">
                                    <div class="tt">移动存储介质在非涉密系统和涉密系统间交叉使用事件数：</div>
                                    <div class="inp_box">
                                        <input class="inp" type="number" name="" id="" v-model="shift" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 信息安全管理体系认证情况 -->
                <div class="alike">
                    <div class="top_box">
                        <div class="pattern"></div>
                        <p>信息安全管理体系认证情况</p>
                    </div>
                    <div class="system">
                        <div class="unify" :class="{curr:attestationIndex == 1}" @click="onAttestation(1)">
                            <!-- 未选中 -->
                            <img class="icon" v-if="attestationIndex!=1" :src="$config.resource + 'wxz.png'" alt="">
                            <!-- 已选中 -->
                            <img class="icon" v-if="attestationIndex==1" :src="$config.resource + 'xz.png'" alt="">
                            <p>已通过认证，认证机构：</p>
                            <div class="relation">
                                <input v-if="attestationIndex==1" class="inp" type="text" v-model="attestation" ref="attestation" />
                            </div>
                        </div>
                        <div class="unify" :class="{curr:attestationIndex == 2}" @click="onAttestation(2)">
                            <!-- 未选中 -->
                            <img class="icon" v-if="attestationIndex!=2" :src="$config.resource + 'wxz.png'" alt="">
                            <!-- 已选中 -->
                            <img class="icon" v-if="attestationIndex==2" :src="$config.resource + 'xz.png'" alt="">
                            <p>未认证</p>
                        </div>
                    </div>
                    <ul v-if="isType==1">
                        <li>
                            <div class="inp_unit">
                                <div class="symbol">*</div>
                                <div class="btn" @click="onSafetyDown">下载信息安全调查表</div>
                                <div class="equally" v-if="isEclipse_two">已下载</div>
                            </div>
                        </li>
                        <li>
                            <div class="inp_unit">
                                <div class="symbol">*</div>
                                <input 
                                    class="uploadBtn" 
                                    name="key" 
                                    type="file" 
                                    @change="safetyFile($event)" 
                                    ref="inputer_safety" 
                                    accept=".pdf" 
                                />
                                <div class="btn">上传信息安全调查表</div>
                                <div class="equally" v-if="inquiry!=''">已上传</div>
                            </div>
                        </li>
                    </ul>
                </div>
                <!-- 附件上传（要求最新复印件，加盖公章） -->
                <div class="alike">
                    <div class="top_box">
                        <div class="pattern"></div>
                        <p>附件上传（要求最新复印件，加盖公章）</p>
                        <div class="remark">备注：有则上传；无则附说明函</div>
                    </div>
                    <ul>
                        <li>
                            <div class="name">
                                <p>*</p>
                                <div class="tt">企业法人营业执照：</div>
                            </div>
                            <div class="inp_unit">
                                <input 
                                    class="uploadBtn" 
                                    name="key" 
                                    type="file" 
                                    @change="licenseFile($event)" 
                                    ref="inputer_one" 
                                    accept=".pdf" 
                                />
                                <p v-if="company_license!=''">已上传</p>
                                <img class="icon" :src="$config.resource + 'scwj.png'" alt="">
                            </div>
                        </li>
                        <li>
                            <div class="name">
                                <p>*</p>
                                <div class="tt">开票资料：</div>
                            </div>
                            <div class="inp_unit">
                                <input 
                                    class="uploadBtn" 
                                    name="key" 
                                    type="file" 
                                    @change="ticketFile($event)" 
                                    ref="inputer_two" 
                                    accept=".pdf" 
                                />
                                <p v-if="invoice!=''">已上传</p>
                                <img class="icon" :src="$config.resource + 'scwj.png'" alt="">
                            </div>
                        </li>
                        <li>
                            <div class="name">
                                <p>*</p>
                                <div class="tt">一般纳税人资格认定证书：</div>
                            </div>
                            <div class="inp_unit">
                                <input 
                                    class="uploadBtn" 
                                    name="key" 
                                    type="file" 
                                    @change="ordinaryFile($event)" 
                                    ref="inputer_tri" 
                                    accept=".pdf" 
                                />
                                <p v-if="taxpayers_book!=''">已上传</p>
                                <img class="icon" :src="$config.resource + 'scwj.png'" alt="">
                            </div>
                        </li>
                        <li>
                            <div class="name">
                                <p>*</p>
                                <div class="tt">基本存款账户信息：</div>
                            </div>
                            <div class="inp_unit">
                                <input 
                                    class="uploadBtn" 
                                    name="key" 
                                    type="file" 
                                    @change="baseFile($event)" 
                                    ref="inputer_four" 
                                    accept=".pdf" 
                                />
                                <p v-if="deposits!=''">已上传</p>
                                <img class="icon" :src="$config.resource + 'scwj.png'" alt="">
                            </div>
                        </li>
                        <li>
                            <div class="name">
                                <p>*</p>
                                <div class="tt">纳税信用等级证明：</div>
                            </div>
                            <div class="inp_unit">
                                <input 
                                    class="uploadBtn" 
                                    name="key" 
                                    type="file" 
                                    @change="gradeFile($event)" 
                                    ref="inputer_five" 
                                    accept=".pdf" 
                                />
                                <p v-if="taxpayers_level!=''">已上传</p>
                                <img class="icon" :src="$config.resource + 'scwj.png'" alt="">
                            </div>
                        </li>
                        <li>
                            <div class="name">
                                <p>*</p>
                                <div class="tt">上年度12月份及近1个月的资产负债表：</div>
                            </div>
                            <div class="inp_unit">
                                <input 
                                    class="uploadBtn" 
                                    name="key" 
                                    type="file" 
                                    @change="liabilitiesFile($event)" 
                                    ref="inputer_six" 
                                    accept=".pdf" 
                                />
                                <p v-if="liabilities!=''">已上传</p>
                                <img class="icon" :src="$config.resource + 'scwj.png'" alt="">
                            </div>
                        </li>
                        <li>
                            <div class="name">
                                <p>*</p>
                                <div class="tt">年度12月份及近1个月的利润表：</div>
                            </div>
                            <div class="inp_unit">
                                <input 
                                    class="uploadBtn" 
                                    name="key" 
                                    type="file" 
                                    @change="profitFile($event)" 
                                    ref="inputer_seven" 
                                    accept=".pdf" 
                                />
                                <p v-if="profit_list!=''">已上传</p>
                                <img class="icon" :src="$config.resource + 'scwj.png'" alt="">
                            </div>
                        </li>
                        <li>
                            <div class="name">
                                <p>*</p>
                                <div class="tt">上年度12月份及近1个月的增值税纳税申报表：</div>
                            </div>
                            <div class="inp_unit">
                                <input 
                                    class="uploadBtn" 
                                    name="key" 
                                    type="file" 
                                    @change="declareFile($event)" 
                                    ref="inputer_eight" 
                                    accept=".pdf" 
                                />
                                <p v-if="tax_table!=''">已上传</p>
                                <img class="icon" :src="$config.resource + 'scwj.png'" alt="">
                            </div>
                        </li>
                        <li>
                            <div class="name">
                                <p>*</p>
                                <div class="tt">供货清单：</div>
                            </div>
                            <div class="inp_unit">
                                <input 
                                    class="uploadBtn" 
                                    name="key" 
                                    type="file" 
                                    @change="supplyFile($event)" 
                                    ref="inputer_nine" 
                                    accept=".pdf" 
                                />
                                <p v-if="list!=''">已上传</p>
                                <img class="icon" :src="$config.resource + 'scwj.png'" alt="">
                            </div>
                        </li>
                        <li class="explain">
                            <div class="name">
                                <p>*</p>
                                <div class="tt">体系认证书/行业资质证书：</div>
                            </div>
                            <div class="inp_unit">
                                <input 
                                    class="uploadBtn" 
                                    name="key" 
                                    type="file" 
                                    @change="systemFile($event)" 
                                    ref="inputer_ten" 
                                    accept=".pdf" 
                                />
                                <p v-if="system_book!=''">已上传</p>
                                <img class="icon" :src="$config.resource + 'scwj.png'" alt="">
                            </div>
                            <div class="depict">如无关相关证书、报告。证明，请上传说明函</div>
                        </li>
                        <li>
                            <div class="name">
                                <p>*</p>
                                <div class="tt">设备检测仪器清单：</div>
                            </div>
                            <div class="inp_unit">
                                <input 
                                    class="uploadBtn" 
                                    name="key" 
                                    type="file" 
                                    @change="facilityFile($event)" 
                                    ref="inputer_eleven" 
                                    accept=".pdf" 
                                />
                                <p v-if="instrument_list!=''">已上传</p>
                                <img class="icon" :src="$config.resource + 'scwj.png'" alt="">
                            </div>
                        </li>
                        <li class="explain">
                            <div class="name">
                                <p>*</p>
                                <div class="tt">审计报告：</div>
                            </div>
                            <div class="inp_unit">
                                <input 
                                    class="uploadBtn" 
                                    name="key" 
                                    type="file" 
                                    @change="auditFile($event)" 
                                    ref="inputer_twelve" 
                                    accept=".pdf" 
                                />
                                <p v-if="audit!=''">已上传</p>
                                <img class="icon" :src="$config.resource + 'scwj.png'" alt="">
                            </div>
                            <div class="depict">如无关相关证书、报告。证明，请上传说明函</div>
                        </li>
                        <li class="explain">
                            <div class="name">
                                <p>*</p>
                                <div class="tt">知识产权权属证明：</div>
                            </div>
                            <div class="inp_unit">
                                <input 
                                    class="uploadBtn" 
                                    name="key" 
                                    type="file" 
                                    @change="ownershipFile($event)" 
                                    ref="inputer_thirteen" 
                                    accept=".pdf" 
                                />
                                <p v-if="ip_prove!=''">已上传</p>
                                <img class="icon" :src="$config.resource + 'scwj.png'" alt="">
                            </div>
                            <div class="depict">如无关相关证书、报告。证明，请上传说明函</div>
                        </li>
                        <li>
                            <div class="name">
                                <p>*</p>
                                <div class="tt">现场/办公室照片：</div>
                            </div>
                            <div class="inp_unit">
                                <input 
                                    class="uploadBtn" 
                                    name="key" 
                                    type="file" 
                                    @change="sceneFile($event)" 
                                    ref="inputer_fourteen" 
                                    accept=".pdf" 
                                />
                                <p v-if="site_pic!=''">已上传</p>
                                <img class="icon" :src="$config.resource + 'scwj.png'" alt="">
                            </div>
                        </li>
                    </ul>
                </div>
                <!-- 提交 -->
                <div class="btn_box" v-if="isType==1">
                    <div class="btn gray" @click="onUpeventually">上一页</div>
                    <div class="btn gray" @click="onSaveeventually">保存草稿</div>
                    <div class="btn red" @click="onSubmiteventually">提交审核</div>
                </div>
                <!-- 查看 -->
                <div class="btn_box" v-if="isType==2">
                    <div class="btn gray" @click="onEndup">上一页</div>
                    <div class="btn red" @click="onEnd">查看完毕</div>
                </div>
            </div>
        </div>
        <!-- 登录弹窗 -->
        <div class="popup" v-if="isEnter">
            <div class="Masked"></div>
            <div class="enter">
                <h6>欢迎您的加入</h6>
                <div class="exterior">
                    <div class="row">
                        <p>企业名称</p>
                        <div class="inp_box">
                            <input type="text" class="inp" placeholder="请输入企业名称" v-model="company_name" />
                        </div>
                    </div>
                    <div class="row">
                        <p>登录/注册密码</p>
                        <div class="inp_box">
                            <input type="text" class="inp" placeholder="请输入密码"  v-model="password" />
                        </div>
                    </div>
                    <div class="row">
                        <p>联系电话</p>
                        <div class="inp_box">
                            <input type="text" class="inp" placeholder="请输入联系电话" v-model="mobile" />
                        </div>
                    </div>
                    <div class="row">
                        <p>验证码</p>
                        <div class="inp_box">
                            <input type="text" class="inp" placeholder="请输入验证码" v-model="code" />
                            <img @click="onFlush" class="CAPTCHA" :src="picture" alt="">
                        </div>
                    </div>
                    <div class="row">
                        <div class="btn" @click="onEnter">登录/注册</div>
                        <div class="shield" v-if="isShield"></div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 未填写提示 -->
        <div class="popup" v-if="isNot">
            <div class="Masked"></div>
            <div class="hint_box">
                <div class="top_box">
                    <div class="pattern"></div>
                    <p>提示</p>
                </div>
                <div class="content">
                    <p v-html="tips"></p>
                </div>
                <div class="btn" @click="onShut">已了解</div>
            </div>
        </div>
        <!-- 已填写提示 -->
        <div class="popup" v-if="isFilled">
            <div class="Masked"></div>
            <div class="hint_box">
                <div class="top_box">
                    <div class="pattern"></div>
                    <p>提示</p>
                </div>
                <div class="content">
                    <p>贵公司填写的内容已通过审核</p>
                    <p>仅可查看先前填写或选择的内容与查看上传的文档</p>
                    <p>不可修改任何信息和上传文档</p>
                </div>
                <div class="btn" @click="onShut">点击查看</div>
            </div>
        </div>
        <!-- 提交成功提示 -->
        <div class="popup" v-if="isPopup">
            <div class="Masked"></div>
            <div class="hint">
                <img class="pic" :src="$config.resource + 'tjcg.png'" alt="">
                <img class="icon" @click="onShut" :src="$config.resource + 'gb.png'" alt="">
            </div>
        </div>
        <!-- 底部栏 -->
        <div class="base-wrap">
            <ul>
                <!-- Lyric © 2020 -->
                <li><a href="javascript:void(0);" >{{link.lyric}}</a></li>
                <!-- 粤ICP备号 -->
                <li><a href="javascript:void(0);" @click="$jump.toWindowHref(link.record)">{{link.record_name}}</a></li>
                <!-- 条款和条件 -->
                <li><a href="javascript:void(0);" @click="$jump.toWindowHref(link.terms)">{{link.terms_name}}</a></li>
                <!-- 隐私 -->
                <li><a href="javascript:void(0);" @click="$jump.toWindowHref(link.privacy)">{{link.privacy_name}}</a></li>
                <!-- 法律 -->
                <li><a href="javascript:void(0);" @click="$jump.toWindowHref(link.law)">{{link.law_name}}</a></li>
                <!-- 联系 -->
                <li><a href="javascript:void(0);" @click="$jump.toWindowHref(link.contact)">{{link.contact_name}}</a></li>
                <!-- 招聘 -->
                <li><a href="javascript:void(0);" @click="$jump.toWindowHref(link.recruitment)">{{link.recruitment_name}}</a></li>
            </ul>
        </div>

        <!-- 置顶 -->
        <div class="stick_box" v-if="searchBarFixed">
            <a href="#">
                <img class="icon" :src="$config.resource + 'zd.png'" alt="" />
            </a>
        </div>
        <el-image-viewer
            v-if="isPicture"
            :on-close="closeViewer"
            :url-list="guide"
        />
    </div>
</template>
<script>
(function(window){
                function Dotline(option){
                    this.opt = this.extend({
                        dom:'J_dotLine',//画布id
                        cw:1000,//画布宽
                        ch:500,//画布高
                        ds:100,//点的个数
                        r:0.5,//圆点半径
                        cl:'#000',//颜色
                        dis:100//触发连线的距离
                    },option);
                    this.c = document.getElementById(this.opt.dom);//canvas元素id
                    this.ctx = this.c.getContext('2d');
                    this.c.width = this.opt.cw;//canvas宽
                    this.c.height = this.opt.ch;//canvas高
                    this.dotSum = this.opt.ds;//点的数量
                    this.radius = this.opt.r;//圆点的半径
                    this.disMax = this.opt.dis*this.opt.dis;//点与点触发连线的间距
                    this.color = this.color2rgb(this.opt.cl);//设置粒子线颜色
                    this.dots = [];
                    //requestAnimationFrame控制canvas动画
                    var RAF = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function(callback) {
                                window.setTimeout(callback, 1000 / 60);
                            };
                    var _self = this;
                    //增加鼠标效果
                    var mousedot = {x:null,y:null,label:'mouse'};
                    this.c.onmousemove = function(e){
                        var e = e || window.event;
                        mousedot.x = e.clientX - _self.c.offsetLeft;
                        mousedot.y = e.clientY - _self.c.offsetTop;
                    };
                    this.c.onmouseout = function(e){
                        mousedot.x = null;
                        mousedot.y = null;
                    }
                    //控制动画
                    this.animate = function(){
                        _self.ctx.clearRect(0, 0, _self.c.width, _self.c.height);
                        _self.drawLine([mousedot].concat(_self.dots));
                        RAF(_self.animate);
                    };
                }
                //合并配置项，es6直接使用obj.assign();
                Dotline.prototype.extend = function(o,e){
                    for(var key in e){
                        if(e[key]){
                            o[key]=e[key]
                        }
                    }
                    return o;
                };
                //设置线条颜色(参考{抄袭}张鑫旭大大，http://www.zhangxinxu.com/wordpress/2010/03/javascript-hex-rgb-hsl-color-convert/)
                Dotline.prototype.color2rgb = function(colorStr){
                    var red = null,
                        green = null,
                        blue = null;
                    var cstr = colorStr.toLowerCase();//变小写
                    var cReg = /^#[0-9a-fA-F]{3,6}$/;//确定是16进制颜色码
                    if(cstr&&cReg.test(cstr)){
                        if(cstr.length==4){
                            var cstrnew = '#';
                            for(var i=1;i<4;i++){
                                cstrnew += cstr.slice(i,i+1).concat(cstr.slice(i,i+1));
                            }
                            cstr = cstrnew;
                        }
                        red = parseInt('0x'+cstr.slice(1,3));
                        green = parseInt('0x'+cstr.slice(3,5));
                        blue = parseInt('0x'+cstr.slice(5,7));
                    }
                    return red+','+green+','+blue;
                }
                //画点
                Dotline.prototype.addDots = function(){
                    var dot;
                    for(var i=0; i<this.dotSum; i++){//参数
                        dot = {
                            x : Math.floor(Math.random()*this.c.width)-this.radius,
                            y : Math.floor(Math.random()*this.c.height)-this.radius,
                            ax : (Math.random() * 2 - 1) / 1.5,
                            ay : (Math.random() * 2 - 1) / 1.5
                        }
                        this.dots.push(dot);
                    }
                };
                //点运动
                Dotline.prototype.move = function(dot){
                    dot.x += dot.ax;
                    dot.y += dot.ay;
                    //点碰到边缘返回
                    dot.ax *= (dot.x>(this.c.width-this.radius)||dot.x<this.radius)?-1:1;
                    dot.ay *= (dot.y>(this.c.height-this.radius)||dot.y<this.radius)?-1:1;
                    //绘制点
                    this.ctx.beginPath();
                    this.ctx.arc(dot.x, dot.y, this.radius, 0, Math.PI*2, true);
                    this.ctx.stroke();
                };
                //点之间画线
                Dotline.prototype.drawLine = function(dots){
                    var nowDot;
                    var _that = this;
                    //自己的思路：遍历两次所有的点，比较点之间的距离，函数的触发放在animate里
                    this.dots.forEach(function(dot){
                        
                        _that.move(dot);
                        for(var j=0; j<dots.length; j++){
                            nowDot = dots[j];
                            if(nowDot===dot||nowDot.x===null||nowDot.y===null) continue;//continue跳出当前循环开始新的循环
                            var dx = dot.x - nowDot.x,//别的点坐标减当前点坐标
                                dy = dot.y - nowDot.y;
                            var dc = dx*dx + dy*dy;
                            if(Math.sqrt(dc)>Math.sqrt(_that.disMax)) continue;
                            // 如果是鼠标，则让粒子向鼠标的位置移动
                            if (nowDot.label && Math.sqrt(dc) >Math.sqrt(_that.disMax)/2) {
                                dot.x -= dx * 0.02;
                                dot.y -= dy * 0.02;
                            }
                            var ratio;
                            ratio = (_that.disMax - dc) / _that.disMax;
                            _that.ctx.beginPath();
                            _that.ctx.lineWidth = ratio / 2;
                            _that.ctx.strokeStyle = 'rgba('+_that.color+',' + parseFloat(ratio + 0.2).toFixed(1) + ')';
                            _that.ctx.moveTo(dot.x, dot.y);
                            _that.ctx.lineTo(nowDot.x, nowDot.y);
                            _that.ctx.stroke();//不描边看不出效果

                            //dots.splice(dots.indexOf(dot), 1);
                        }
                    });
                };
                //开始动画
                Dotline.prototype.start = function(){
                    var _that = this;
                    this.addDots();
                    setTimeout(function() {
                        _that.animate();
                    }, 100);
                }
                window.Dotline = Dotline;
            }(window));
            //调用
            window.onload = function(){
                var dotline = new Dotline({
                    dom:'J_dotLine',//画布id
                    cw:1000,//画布宽
                    ch:500,//画布高
                    ds:100,//点的个数
                    r:0.5,//圆点半径
                    cl:'#AFAFAF',//粒子线颜色
                    dis:100//触发连线的距离
                }).start();
            }
import store from '../vuex/store.js';
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
    export default {
        data(){
            return{
                searchBarFixed:false,
                isShield:false,

                lineGraph:true,// 

                user:'',// 用户信息
                flow:'',// 流程状态
                guide:'',// 大图
                isPicture:false,// 预览大图
                mobile:'',//账号（手机号）
                company_name:'',//公司名（公司全称）
                code:'',//输入验证码
                key:'',//验证码
                picture:'',//验证码
                password:'',//密码

                tips:'',//未填写提示

                link:'',//底部链接
                
                isType:1,// 1.提交 2.查看详情

                // 基础信息
                isBasics:false,// 初审表单
                provision_name:'',// 供应商类型名称
                provision:[],// 供应商类型
                provisionId:'',// 供应商类型id
                definite_name:'',// 具体类型名称
                definite:[],// 具体类型
                definiteId:'',// 具体类型id
                firm_name:'',// 企业名称
                credit_code:'',// 统一社会信用代码
                establish:'',// 成立年份
                delegate:'',// 法人代表
                post:'',// 法人代表职务
                phone:'',// 法人联系电话
                checker_pos:'',// 对账人
                checker_phone:'',// 对账人电话
                checker_email:'',// 对账人邮箱
                abutment:'',// 业务对接人
                job:'',// 业务对接人职务
                telephone:'',// 业务对接人联系电话
                gmail:'',// 业务对接人E-mail
                run:'',// 经营范围
                trade:'',// 行业类别
                url:'',// 企业网址
                address:'',// 注册地址
                site:'',// 通信地址
                principal:'',// 注册资本
                company_money:'',// 资产总值
                saleroom:'',// 上年度销售额

                ratepaying:'',// 纳税人类别
                taxRate:'',// 税 率
                balance:'',// 结算方式
                closing:'',// 结算方式输入框
                receive:'',// 收付方式
                firm:'',// 企业性质
                property:'',// 企业性质输入框
                capital:'',// 资本类型
                company_type:'',// 资本类型输入框
                relevancy:'',// 关联公司
                relevancy_name:'',// 关联公司输入框
                clan:'',// 亲属关系
                clan_name:'',// 亲属关系输入框
                material:'',// 物料产品包装
                pack:'',// 物料产品包装输入框

                client_one:'',// 客户1
                portfolio_one:'',// 业务量占比
                cooperate_one:'',// 合作产品
                client_two:'',// 客户2
                portfolio_two:'',// 业务量占比
                cooperate_two:'',// 合作产品
                client_tri:'',// 客户3
                portfolio_tri:'',// 业务量占比
                cooperate_tri:'',// 合作产品

                total:'',// 人员总数
                manage:'',// 管理人员
                production:'',// 生产人员
                research_staff :'',// 研发人员
                quality:'',// 质量人员
                sell:'',// 销售人数
                after_sale:'',// 售后人员
                rests:'',// 其它人员
                service:'',// 是否支持国外售后
                leaseback:[// 是否支持国外售后
                    {
                        id:1,
                        name:'是，售后响应时间24H',
                    },
                    {
                        id:2,
                        name:'是，售后响应时间48H',
                    },
                    {
                        id:0,
                        name:'否',
                    },
                ],
                serviceId:'',// 是否支持国外售后
                money:'',// 每年研发投入金额
                field:'',// 设计领域
                software:'',// 设计软件名称
                floor_area:'',// 工厂占地面积
                covered_area:'',// 工厂建筑面积
                storage_area:'',// 仓库面积
                production_area:'',// 工厂生产面积

                kind_one:'',// 主要生产产品种类一
                last_year_one:'',// 上年年产量一
                practical_one:'',// 实际年产量一
                total_one:'',// 总体销售额一
                mating_one:'',// 配套额一
                quality_one:'',// 综合质量能力PPM一
                kind_two:'',// 主要生产产品种类二
                last_year_two:'',// 上年年产量二
                practical_two:'',// 实际年产量二
                total_two:'',// 总体销售额二
                mating_two:'',// 配套额二
                quality_two:'',// 综合质量能力PPM二
                variety:false,// 新增产品品类显示隐藏
                approve_one:'',// 何种体系认证/何种资质证书一
                ms_one:'',// 认证时间一
                validity_one:'',// 有效期一
                institution_one:'',// 认证机构一
                number_one:'',// 证书编号一
                approve_two:'',// 何种体系认证/何种资质证书二
                ms_two:'',// 认证时间二
                validity_two:'',// 有效期二
                institution_two:'',// 认证机构二
                number_two:'',// 证书编号二
                isRapex:false,// 新增体系认证情况显示隐藏
                lord:'',// 主代理品牌
                grade_one:'',// 代理等级
                agency_one:'',// 代理证书
                rest:'',// 其他代理品牌
                grade_two:'',// 代理等级
                agency_two:'',// 代理证书
                area_name:'',// 代理区域
                area:[// 代理区域
                    {
                        id:1,
                        name:'全国',
                    },
                    {
                        id:2,
                        name:'区域',
                    },
                    {
                        id:3,
                        name:'其他',
                    }
                ],
                areaId:'',// 代理区域
                quotient_name:'',// 代理区域市场份额
                quotient:[// 代理区域市场份额
                    {
                        id:1,
                        name:'前五',
                    },
                    {
                        id:2,
                        name:'前十',
                    },
                    {
                        id:3,
                        name:'前二十',
                    },
                    {
                        id:4,
                        name:'其他',
                    }
                ],
                quotientId:'',// 代理区域市场份额
                channel:'',// 主要来货渠道
                staple:'',// 曾代理的主要产品
                deal_name:'',// 交期
                deal:[// 交期
                    {
                        id:1,
                        name:'≤3天',
                    },
                    {
                        id:2,
                        name:'≤5天',
                    },
                    {
                        id:3,
                        name:'≤7天',
                    },
                    {
                        id:4,
                        name:'≤15天',
                    },
                    {
                        id:5,
                        name:'≤20天',
                    }
                ],
                dealId:'',// 交期
                logistics:'',// 物流配送
                delivery:[// 物流配送
                    {
                        id:1,
                        name:'自有专车物流配送',
                    },
                    {
                        id:2,
                        name:'第三方物流为主',
                    }
                ],
                deliveryId:'',// 物流配送
                lab_name:'',// 有无实验室
                laboratory:[// 有无实验室
                    {
                        id:1,
                        name:'有',
                    },
                    {
                        id:2,
                        name:'无',
                    }
                ],
                laboratoryId:'',// 有无实验室
                facility:'',// 有无生产设备
                equipment:[// 有无生产设备
                    {
                        id:1,
                        name:'有',
                    },
                    {
                        id:2,
                        name:'无',
                    }
                ],
                facilityId:'',// 有无生产设备

                isRefer:false,// 参考
                supplier_info:'',// 上传文档
                archive:'',// 参考容器

                // 详细信息
                isDetailed:false,// 详细信息表
                technical_name:'',// 供应产品/服务/技术名称
                invent:'',// 发明专利数量
                copyright:'',// 著作权数量
                practical:'',// 实用新型专利数量
                other:'',// 其它
                brand:'',// 商标数量
                facade:'',// 外观专利数量

                duty:'',// 岗位信息安全和保密责任制度
                agreement:'',// 重要岗位人员信息安全和保密协议
                dimission:'',// 人员离岗离职安全管理规定
                safety_manage:'',// 信息安全设备运维管理
                destroy:'',// 设备维修维护和报废销毁管理

                areas:'',// 网络区域划分是否合理
                tactics:'',// 安全防护设备策略
                control:'',// 互联网访问控制
                log:'',// 互联网访问日志
                org:'',// 域名
                address:'',// IP地址
                file:'',// 网站是否备案
                account:'',// 门户网站账户安全管理
                clear:'',// 清理网站临时文件、关闭网站目录遍历功能等清理
                issue:'',// 门户网站信息发布管理
                savings:'',// 移动储蓄设备管理方式
                blended:'',// 在非涉密信息系统和涉密信息系统间混用情况
                serve:'',// 服务器安全防护:不必要的应用、服务、端口
                set_one:'',// 服务器安全防护:账户口令设置8位，包含数字、字母或符号
                scan_one:'',// 服务器安全防护:扫描、病毒木马监测
                defend:'',// 网络设备防护:安全策略配置
                set_two:'',// 网络设备防护:账户口令设置8位，包含数字、字母或符号
                scan_two:'',// 网络设备防护:扫描、病毒木马监测
                deploy:'',// 信息安全设备部署及使用:防病毒、防火墙、入侵检测、安全审计等功能的设备
                deploy_two:'',// 信息安全设备部署及使用:安全策略配置
                way:'',// 终端计算机安全管理方式
                word:'',// 账户口令管理
                measure:'',// 接入互联网安全控制措施
                mingle:'',// 在非涉密信息系统和涉密信息系统混合使用情况
                scan:'',// 漏洞扫描木马检测
                existIndex:'',// 是否存在使用非涉密计算计算机处理涉密信息情况
                exist:'',// 是否存在使用非涉密计算计算机处理涉密信息情况输入框
                
                enact:'',// 应急预案制定及备案情况
                skill:'',// 应急技术支援队伍
                wd:'',// 重要数据
                lineage:'',// 重要信息系统

                trainIndex:0,// 参加培训情况
                attend:'',// 本年度是否派员参加信息安全相关业务培训，人/次数
                branch:'',// 培训部门名称
                tissueIndex:0,// 组织培训情况
                tissue:'',// 本年度是否组织展开信息安全教育培训，人/次数
                ratio:'',// 参训人员比例

                virus:'',// 进行过病毒木马等恶意代码检查服务器的台数
                infection:'',// 其中感染恶意代码的服务器台数
                viciousness:'',// 进行过病毒木马等恶意代码检测的终端计算机台数
                venom:'',// 其中感染恶意代码的终端计算机台数
                flaw:'',// 进行过漏洞扫描的服务器台数
                loophole:'',// 其中存在漏洞的服务器台数
                defect:'',// 其中存在高风险漏洞的服务器台数
                leak:'',// 进行过漏洞扫描的终端计算机台数
                hole:'',// 其中存在漏洞的终端计算器台数
                high_risk:'',// 其中存在高风险漏洞的终端计算器台数
                spite:'',// 门户网站网页被篡改（内含嵌恶意代码）次数
                use:'',// 使用非涉密终端计算机处理涉密信息事件数
                system:'',// 终端计算器在非涉密系统和涉密系统间混用事件数
                shift:'',// 移动存储介质在非涉密系统和涉密系统间交叉使用事件数

                attestationIndex:'',// 信息安全管理体系认证情况
                attestation:'',// 信息安全管理体系认证情况输入框

                company_license:'',//  企业法人营业执照
                invoice:'',//  开票资料
                taxpayers_book:'',//  一般纳税人资格认定证书
                deposits:'',//  基本存款账户信息
                taxpayers_level:'',//  纳税信用等级证明
                liabilities:'',//  上年度12月份及近1个月的资产负债表
                profit_list:'',//  年度12月份及近1个月的利润表
                tax_table:'',//  上年度12月份及近1个月的增值税纳税申报表
                list:'',//  供货清单
                system_book:'',//  体系认证书/行业资质证书
                instrument_list:'',//  设备检测仪器清单
                audit:'',//  审计报告
                ip_prove:'',//  知识产权权属证明
                site_pic:'',//  现场/办公室照片

                ip_inquiry:'',//  知识产权调查表
                isEclipse_one:false,//  下载知识产权调查表提示
                inquiry:'',//  信息安全调查表
                isEclipse_two:false,//  下载信息安全调查表提示

                isEnter:false,// 登录弹窗
                isNot:false,// 步骤一未填写弹窗
                isFilled:false,// 步骤一查看弹窗
                isPopup:false,// 提交成功提示
            }
        },
        store,
        methods: {
            //页面跳转
            toViewPage($path,$query) {
                this.$jump.toViewPage(this,$path,$query)
            },
            // 用户信息
            getUser(){
                const that = this
                that.$request({
                    that: that,
                    api: that.$api.consumer,
                    data: {},
                    success(res) {
                       that.user = res.data
                       that.homeState()// 获取流程状态
                       that.getForm()// 获取分类
                       that.getRefer()// 参考
                       that.getHint()// 获取提示
                    }
                })
            },
            // 获取提示
            getHint(){
                const that = this
                that.$request({
                    that: that,
                    api: that.$api.gettips,
                    data: {},
                    success(res) {
                       that.tips = res.data.tips
                    }
                })
            }, 
            // 查看指导书
            onPreview(){
                this.isPicture = true
            },
            // 关闭图片预览
            closeViewer() {
                this.isPicture = false
            },
            // 预览指导书
            getPreview(){
                const that = this
                that.$request({
                    that: that,
                    api: that.$api.pvwInstructor,
                    data: {},
                    success(res) {
                       that.guide = res.data.src
                       console.log('指导书',res.data)
                    }
                })
            },
            // 获取流程状态
            homeState(){
                const that = this
                that.$request({
                    that: that,
                    api: that.$api.flowState,
                    data: {},
                    success(res) {
                       that.flow = res.data
                       console.log('456+++',that.flow)
                    }
                })
            },
            // 获取分类
            getForm(){
                const that = this
                that.$request({
                    that: that,
                    api: that.$api.categoryList,
                    data: {},
                    success(res) {
                       that.provision = res.data
                    }
                })
            },
            // 参考
            getRefer(){
                const that = this
                that.$request({
                    that: that,
                    api: that.$api.refer,
                    data: {},
                    success(res) {
                       that.archive = res.data
                    }
                })
            },
            //获取验证码
            getCAPTCHA(){
                const that = this
                that.$request({
                    that: that,
                    api: that.$api.captcha,
                    data: {},
                    success(res) {
                        that.picture = res.data.base64 
                        that.key = res.data.key
                    }
                })
            },
            // 刷新验证码
            onFlush(){
                const that = this
                that.getCAPTCHA()//验证码
            },
            // 登录
            onEnter(){
                const that = this
                var setTimeFlag = null;
                that.isShield = true
                that.$request({
                    that: that,
                    api: that.$api.login,
                    data: {
                        mobile:that.mobile,
                        company_name:that.company_name,
                        code:that.code,
                        key:that.key,
                        password:that.password
                    },
                    success(res) {
                       //存储用户登录凭证
                            that.$storage.set('accesstoken',res.data.token)
                            //登录成功发起页面跳转
                            that.$dialog.toast({
                                mes: '登录成功',
                                timeout: 1500,
                                icon: 'success',
                                callback(){
                                    that.isEnter = false
                                    that.user = ''
                                    that.guide = ''
                                    that.picture = ''
                                    that.key = ''
                                    that.link = ''
                                    that.flow = ''
                                    that.getUser()// 用户信息
                                    that.getPreview()// 指导书
                                    that.getCAPTCHA()//获取验证码
                                    that.getSole()//底部链接
                                }
                            })
                            setTimeFlag=setTimeout(()=>{   //设置延迟执行
                                that.isShield = false
                            },2000);
                    },
                    fail(err){
                        that.key = ''
                        that.code = ''
                        that.getCAPTCHA()
                        setTimeFlag=setTimeout(()=>{   //设置延迟执行
                            that.isShield = false
                        },2000);
                    }
                })
            },
            // 退出
            onQuit(){
                const that = this
                //存储用户登录凭证
                that.$storage.remove('accesstoken')

                //登录成功发起页面跳转
                that.$dialog.toast({
                    mes: '退出登录成功',
                    timeout: 2000,
                    icon: 'success',
                    callback(){
                        that.isEnter = true
                        that.picture = ''
                        that.key = ''
                        that.getCAPTCHA()
                    }
                })
            },
            // 供应商类型
            getProvision(value){
                this.provision_name = value.name
                this.provisionId = value.id
                this.definite = value.son
                this.definite_name = ''
                this.definiteId = ''
            },
            // 具体类型
            getDefinite(value){
                this.definite_name = value.name
                this.definiteId = value.id
            },
            // 新增产品品类
            onVariety(){
                this.variety = true
            },
            // 新增体系认证情况
            onRapex(){
                this.isRapex = true
            },
            // 代理区域
            getArea(value){
                this.area_name = value.name
                this.areaId = value.id
            },
            // 代理区域市场份额
            getQuotient(value){
                this.quotient_name = value.name
                this.quotientId = value.id
            },
            // 交期
            getDeal(value){
                this.deal_name = value.name
                this.dealId = value.id
            },
            // 物流配送
            getDelivery(value){
                this.logistics = value.name
                this.deliveryId = value.id
            },
            // 有无实验室
            getLaboratory(value){
                this.lab_name = value.name
                this.laboratoryId = value.id
            },
            // 有无生产设备
            getFacility(value){
                this.facility = value.name
                this.facilityId = value.id
            },
            // 是否支持国外售后
            getService(value){
                console.log('打印',value)
                this.serviceId = value.id
                this.service = value.name
            },
            // 文档下载
            onDown(){
                const that = this
                let settle_type = '';// 结算方式
                if(that.balance==4){
                    settle_type = that.closing
                }else{
                    settle_type = that.balance
                }
                let company_nature = '';// 企业性质
                if(that.firm==9){
                    company_nature = that.property
                }else{
                    company_nature = that.firm
                }
                let company_type = '';// 资本类型
                if(that.capital==8){
                    company_type = that.company_type
                }else{
                    company_type = that.capital
                }
                let is_other = '';// 关联公司
                if(that.relevancy==2){
                    is_other = that.relevancy_name
                }else{
                    is_other = 0
                }
                let is_family = '';// 亲属关系
                if(that.clan==2){
                    is_family = that.clan_name
                }else{
                    is_family = 0
                }
                let adjust = '';// 物料产品包装
                if(that.material==2){
                    adjust = that.pack
                }else{
                    adjust = 1
                }

                let lab ='';// 有无实验室
                if(that.laboratoryId==2){
                    lab = 0
                }else{
                    lab = 1
                }
                let equipment ='';// 有无生产设备
                if(that.facilityId==2){
                    equipment = 0
                }else{
                    equipment = 1
                }
                that.$request({
                    that: that,
                    api: that.$api.firstTrialDown,
                    data: {
                        parent_class:that.provisionId, // 供应商类型id
                        subclass:that.definiteId, // 具体类型id
                        company_name:that.firm_name, // 企业名称
                        code:that.credit_code,// 统一社会信用代码
                        company_year:that.establish,// 成立年份
                        legal_person:that.delegate,// 法人代表
                        legal_pos:that.post,// 法人代表职务
                        legal_phone:that.phone,// 法人联系电话
                        checker_pos:that.checker_pos,// 对账人
                        checker_phone:that.checker_phone,// 对账人电话
                        checker_email:that.checker_email,// 对账人邮箱
                        service_person:that.abutment,// 业务对接人
                        service_position:that.job,// 业务对接人职务
                        service_phone:that.telephone,// 业务对接人联系电话
                        service_email:that.gmail,// 业务对接人E-mail
                        scope:that.run,// 经营范围
                        category:that.trade,// 行业类别
                        company_url:that.url,// 企业网址
                        register_add:that.address,// 注册地址
                        company_address:that.site,// 通信地址
                        money:that.principal,// 注册资本
                        company_money:that.company_money,// 资产总值
                        year_sales:that.saleroom,// 上年度销售额
                        taxpayers:that.ratepaying,// 纳税人类别
                        rate:that.taxRate,// 税 率
                        settle_type:settle_type,// 结算方式
                        pay_method:that.receive,// 收付方式
                        company_nature:company_nature,// 企业性质
                        company_type:company_type,// 资本类型
                        is_other:is_other,// 关联公司
                        is_family:is_family,// 亲属关系
                        adjust:adjust,// 物料产品包装
                        clients_name:that.client_one,// 客户1
                        client_share:that.portfolio_one,// 业务量占比1
                        provide:that.cooperate_one,// 合作产品1
                        s_clients_name:that.client_two,// 客户2
                        s_client_share:that.portfolio_two,// 业务量占比2
                        s_provide:that.cooperate_two,// 合作产品2
                        t_clients_name:that.client_tri,// 客户3
                        t_client_share:that.portfolio_tri,// 业务量占比3
                        t_provide:that.cooperate_tri,// 合作产品3

                        total:that.total,// 人员总数
                        management:that.manage,// 管理人员
                        production:that.production,// 生产人员
                        rd:that.research_staff,// 研发人员
                        quality:that.quality,// 质量人员
                        sales:that.sell,// 销售人数
                        after_sales:that.after_sale,// 售后人员
                        other:that.rests,// 其它人员
                        foreign_af:that.serviceId,// 是否支持国外售后
                        rd_money:that.money,// 每年研发投入金额
                        design:that.field,// 设计领域
                        software:that.software,// 设计软件名称
                        area:that.floor_area,// 工厂占地面积
                        buil_area:that.covered_area,// 工厂建筑面积
                        warehouse:that.storage_area,// 仓库面积
                        production_area:that.production_area,// 工厂生产面积

                        product_type1:that.kind_one,// 主要生产产品种类一
                        year_capacity1:that.last_year_one,// 上年年产量一
                        reality_capacity1:that.practical_one,// 实际年产量一
                        total_sales1:that.total_one,// 总体销售额一
                        set_amount1:that.mating_one,// 配套额一
                        ppm1:that.quality_one,// 综合质量能力PPM一
                        product_type2:that.kind_two,// 主要生产产品种类二
                        year_capacity2:that.last_year_two,// 上年年产量二
                        reality_capacity2:that.practical_two,// 实际年产量二
                        total_sales2:that.total_two,// 总体销售额二
                        set_amount2:that.mating_two,// 配套额二
                        ppm2:that.quality_two,// 综合质量能力PPM二
                        system1:that.approve_one,// 何种体系认证/何种资质证书一
                        approve_time1:that.ms_one,// 认证时间一
                        end_time1:that.validity_one,// 有效期一
                        approve_body1:that.institution_one,// 认证机构一
                        book_code1:that.number_one,// 证书编号一
                        system2:that.approve_two,// 何种体系认证/何种资质证书二
                        approve_time2:that.ms_two,// 认证时间二
                        end_time2:that.validity_two,// 有效期二
                        approve_body2:that.institution_two,// 认证机构二
                        book_code2:that.number_two,// 证书编号二
                        agent_brand:that.lord,// 主代理品牌
                        agent_level:that.grade_one,// 代理等级
                        agent_book:that.agency_one,// 代理证书
                        other_brand:that.rest,//  其他代理品牌
                        other_level:that.grade_two,// 代理等级
                        other_book:that.agency_two,// 代理证书
                        agent_area:that.areaId,// 代理区域
                        market_share:that.quotientId,// 代理区域市场份额
                        channel:that.channel,// 主要来货渠道
                        once_products:that.staple,// 曾代理的主要产品
                        delivery_cycle:that.dealId,// 交期
                        logistics:that.deliveryId,// 物流配送
                        lab:lab,// 有无实验室
                        equipment:equipment,// 有无生产设备
                    },
                    loading: true,
                    success(res) {
                        window.open(res.data.path)
                        console.log('下载打印',res.data)
                    }
                })
            },
            // 关闭弹窗
            onShut(){
                this.isNot = false // 未填写提示
                this.isFilled = false // 已填写提示
                this.isPopup = false // 提交成功提示
                this.flow = ''
                this.homeState()
            },
            // 基础填写
            onWrite_one(){
                this.isBasics = true
                this.isNot = true // 未填写提示
                this.getBasisDraft()// 获取基础草稿
            },
            // 获取基础草稿
            getBasisDraft(){
                const that = this
                that.$request({
                    that: that,
                    api: that.$api.firstTrialDraft,
                    data: {},
                    success(res) {
                       if(res.data.parent_class!=null&&res.data.parent_class!=''){
                            that.provisionId = res.data.parent_class
                            that.provision_name = res.data.parent_name
                        }
                        // 具体类型
                        if(res.data.subclass!=null&&res.data.subclass!=''){
                            that.definiteId = res.data.subclass
                            that.definite_name = res.data.subclass_name
                        }
                        that.firm_name = res.data.company_name // 企业名称
                        that.credit_code = res.data.code // 统一社会信用代码
                        // 成立年份
                        if(res.data.company_year!=null&&res.data.company_year!=''){
                            that.establish = res.data.company_year 
                        }
                        that.delegate = res.data.legal_person // 法人代表
                        that.post = res.data.legal_pos //法人代表职务 
                        that.phone = res.data.legal_phone // 法人联系电话
                        that.checker_pos = res.data.checker_pos // 对账人
                        that.checker_phone = res.data.checker_phone// 对账人电话
                        that.checker_email = res.data.checker_email// 对账人邮箱
                        that.abutment = res.data.service_person // 业务对接人
                        that.job = res.data.service_position // 业务对接人职务
                        that.telephone = res.data.service_phone // 业务对接人联系电话
                        that.gmail = res.data.service_email // 业务对接人E-mail
                        that.run = res.data.scope // 经营范围
                        that.trade = res.data.category // 行业类别
                        that.url = res.data.company_url // 企业网址
                        that.address = res.data.register_add // 注册地址
                        that.site = res.data.company_address // 通信地址
                        that.principal = res.data.money // 注册资本
                        that.company_money = res.data.company_money // 资产总值
                        that.saleroom = res.data.year_sales // 上年度销售额

                        that.ratepaying = res.data.taxpayers // 纳税人类别
                        that.taxRate = res.data.rate // 税 率
                        if(res.data.settle_type!=1&&res.data.settle_type!=2&&res.data.settle_type!=3&&res.data.settle_type!=null&&res.data.settle_type!=''){// 结算方式
                            that.balance = 4
                            that.closing = res.data.settle_type
                        }else{
                            that.balance = res.data.settle_type
                        }
                        that.receive = res.data.pay_method // 收付方式
                        if(res.data.company_nature!=1&&res.data.company_nature!=2&&res.data.company_nature!=3&&res.data.company_nature!=4&&res.data.company_nature!=5&&res.data.company_nature!=6&&res.data.company_nature!=7&&res.data.company_nature!=8&&res.data.company_nature!=null&&res.data.company_nature!=''){//企业性质
                            that.firm = 9
                            that.property = res.data.company_nature
                        }else{
                            that.firm = res.data.company_nature
                        }
                        if(res.data.company_type!=1&&res.data.company_type!=2&&res.data.company_type!=3&&res.data.company_type!=4&&res.data.company_type!=5&&res.data.company_type!=6&&res.data.company_type!=7&&res.data.company_type!=null&&res.data.company_type!=''){//资本类型
                            that.capital = 8
                            that.company_type = res.data.company_type
                        }else{
                            that.capital = res.data.company_type
                        }
                        if(res.data.is_other!=null&&res.data.is_other!=''){// 关联公司
                            if(res.data.is_other==0){
                                that.relevancy = 1
                            }else{
                                that.relevancy = 2
                                that.relevancy_name = res.data.is_other
                            }
                        }
                        if(res.data.is_family!=null&&res.data.is_family!=''){// 亲属关系
                            if(res.data.is_family==0){
                                that.clan = 1
                            }else{
                                that.clan = 2
                                that.clan_name = res.data.is_family
                            }
                        }
                        if(res.data.adjust!=null&&res.data.adjust!=''){// 物料产品包装
                            if(res.data.adjust==1){
                                that.material = 1
                            }else{
                                that.material = 2
                                that.pack = res.data.adjust 
                            }
                        }

                        that.client_one = res.data.clients_name // 客户1
                        that.portfolio_one = res.data.client_share // 业务量占比1
                        that.cooperate_one =  res.data.provide // 合作产品1

                        that.client_two = res.data.s_clients_name // 客户2
                        that.portfolio_two = res.data.s_client_share // 业务量占比2
                        that.cooperate_two =  res.data.s_provide // 合作产品2

                        that.client_tri = res.data.t_clients_name // 客户3
                        that.portfolio_tri = res.data.t_client_share // 业务量占比3
                        that.cooperate_tri =  res.data.t_provide // 合作产品3

                        that.total = res.data.total // 人员总数
                        that.manage = res.data.management // 管理人员
                        that.production = res.data.production // 生产人员
                        that.research_staff = res.data.rd // 研发人员
                        that.quality = res.data.quality // 质量人员
                        that.sell = res.data.sales // 销售人数
                        that.after_sale = res.data.after_sales // 售后人员
                        that.rests = res.data.other // 其它人员
                        if(res.data.foreign_af!=null&&res.data.foreign_af!=''){// 是否支持国外售后
                            if(res.data.foreign_af==0){
                                that.serviceId = res.data.foreign_af
                                that.service = '否'
                            }
                            if(res.data.foreign_af==1){
                                that.serviceId = res.data.foreign_af
                                that.service = '是，售后响应时间24H'
                            }
                            if(res.data.foreign_af==2){
                                that.serviceId = res.data.foreign_af
                                that.service = '是，售后响应时间48H'
                            }
                        }
                        that.money = res.data.rd_money // 每年研发投入金额
                        that.field = res.data.design // 设计领域
                        that.software = res.data.software // 设计软件名称
                        that.floor_area = res.data.area // 工厂占地面积
                        that.covered_area = res.data.buil_area // 工厂建筑面积
                        that.storage_area = res.data.warehouse // 仓库面积
                        that.production_area = res.data.production_area // 工厂生产面积

                        that.kind_one = res.data.product_type1 // 主要生产产品种类一
                        that.last_year_one = res.data.year_capacity1 // 上年年产量一
                        that.practical_one = res.data.reality_capacity1 // 实际年产量一
                        that.total_one = res.data.total_sales1 // 总体销售额一
                        that.mating_one = res.data.set_amount1 //  配套额一
                        that.quality_one = res.data.ppm1 // 综合质量能力PPM一
                        if(res.data.product_type2!=null&&res.data.product_type2!=''){
                            that.variety = true
                        }
                        that.kind_two = res.data.product_type2 // 主要生产产品种类二
                        that.last_year_two = res.data.year_capacity2 // 上年年产量二
                        that.practical_two = res.data.reality_capacity2 // 实际年产量二
                        that.total_two = res.data.total_sales2 // 总体销售额二 
                        that.mating_two = res.data.set_amount2 // 配套额二
                        that.quality_two = res.data.ppm2 // 综合质量能力PPM二
                        that.approve_one = res.data.system1 // 何种体系认证/何种资质证书一
                        if(res.data.approve_time1!=null&&res.data.approve_time1!=''&&res.data.approve_time1!=''){// 认证时间一
                            that.ms_one = res.data.approve_time1 
                        }
                        if(res.data.end_time1!=null&&res.data.end_time1!=''&&res.data.end_time1!=0){// 有效期一
                            that.validity_one = res.data.end_time1 
                        }
                        that.institution_one = res.data.approve_body1 // 认证机构一
                        that.number_one = res.data.book_code1 // 证书编号一
                        if(res.data.system2!=null&&res.data.system2!=''){
                            that.isRapex = true
                        }
                        that.approve_two = res.data.system2 // 何种体系认证/何种资质证书二
                        if(res.data.approve_time2!=null&&res.data.approve_time2!=''&&res.data.approve_time2!=0){// 认证时间二
                            that.ms_two = res.data.approve_time2 
                        }
                        if(res.data.end_time2!=null&&res.data.end_time2!=''&&res.data.end_time2!=0){// 有效期二
                            that.validity_two = res.data.end_time2 
                        }
                        that.institution_two = res.data.approve_body2 // 认证机构二
                        that.number_two = res.data.book_code2 // 证书编号二
                        that.lord = res.data.agent_brand // 主代理品牌
                        that.grade_one = res.data.agent_level // 代理等级
                        if(res.data.agent_book!=null&&res.data.agent_book!=''){// 代理证书
                            that.agency_one = res.data.agent_book 
                        }
                        that.rest = res.data.other_brand // 其他代理品牌
                        that.grade_two = res.data.other_level // 代理等级
                        if(res.data.other_book!=null&&res.data.other_book!=''){// 代理证书
                            that.agency_two = res.data.other_book 
                        }
                        
                        if(res.data.agent_area!=null&&res.data.agent_area!=''){// 代理区域
                                that.areaId = res.data.agent_area 
                                if(res.data.agent_area==1){
                                    that.area_name = '全国'
                                }
                                if(res.data.agent_area==2){
                                    that.area_name = '区域'
                                }
                                if(res.data.agent_area==3){
                                    that.area_name = '其他'
                                }
                        }
                        if(res.data.market_share!=null&&res.data.market_share!=''){// 代理区域市场份额
                                that.quotientId = res.data.market_share 
                                if(res.data.market_share==1){
                                    that.quotient_name = '前五'
                                }
                                if(res.data.market_share==2){
                                    that.quotient_name = '前十'
                                }
                                if(res.data.market_share==3){
                                    that.quotient_name = '前二十'
                                }
                                if(res.data.market_share==4){
                                    that.quotient_name = '其他'
                                }
                        }
                        that.channel = res.data.channel // 主要来货渠道
                        that.staple = res.data.once_products // 曾代理的主要产品
                        if(res.data.delivery_cycle!=null&&res.data.delivery_cycle!=''){// 交期
                                that.dealId = res.data.delivery_cycle
                                if(res.data.delivery_cycle==1){
                                    that.deal_name = '≤3天'
                                }
                                if(res.data.delivery_cycle==2){
                                    that.deal_name = '≤5天'
                                }
                                if(res.data.delivery_cycle==3){
                                    that.deal_name = '≤7天'
                                }
                                if(res.data.delivery_cycle==4){
                                    that.deal_name = '≤15天'
                                }
                                if(res.data.delivery_cycle==5){
                                    that.deal_name = '≤20天'
                                }
                        }
                        
                        if(res.data.logistics!=null&&res.data.logistics!=''){// 物流配送
                                that.deliveryId = res.data.logistics
                                if(res.data.logistics==1){
                                    that.logistics = '自有专车物流配送'
                                }else{
                                    that.logistics = '第三方物流为主'
                                }
                        }
                        
                        if(res.data.lab!=null&&res.data.lab!=''){// 有无实验室
                                if(res.data.lab==0){
                                    that.laboratoryId = 2
                                    that.lab_name = '无'
                                }else{
                                    that.laboratoryId = 1
                                    that.lab_name = '有'
                                }
                        }
                        
                        if(res.data.equipment!=null&&res.data.equipment!=''){// 有无生产设备
                                if(res.data.equipment==0){
                                    that.facilityId = 2
                                    that.facility = '无'
                                }else{
                                    that.facilityId = 1
                                    that.facility = '有'
                                }
                        }

                        if(res.data.supplier_info!=null&&res.data.supplier_info!=''){
                            that.supplier_info = res.data.supplier_info
                        }
                    }
                })
            },
            // 详细填写
            onWrite_two(){
                this.isDetailed = true
                this.getInDetailDraft()// 获取详细草稿
            },
            // 获取详细草稿
            getInDetailDraft(){
                const that = this
                that.$request({
                    that: that,
                    api: that.$api.examineDetails,
                    data: {},
                    success(res) {
                       if(res.data.technical_name!=null&&res.data.technical_name!=''){// 供应产品/服务/技术名称
                            that.technical_name = res.data.technical_name 
                        }
                        if(res.data.patents!=null&&res.data.patents!=''){// 发明专利数量
                            that.invent = res.data.patents 
                        }
                        if(res.data.copyrights_name!=null&&res.data.copyrights_name!=''){// 著作权数量
                            that.copyright = res.data.copyrights_name 
                        }
                        if(res.data.utility_patents!=null&&res.data.utility_patents!=''){// 实用新型专利数量
                            that.practical = res.data.utility_patents 
                        }
                        if(res.data.other_patents!=null&&res.data.other_patents!=''){// 其它
                            that.other = res.data.other_patents 
                        }
                        if(res.data.logo!=null&&res.data.logo!=''){// 商标数量
                            that.brand = res.data.logo 
                        }
                        if(res.data.design_patent!=null&&res.data.design_patent!=''){// 外观专利数量
                            that.facade = res.data.design_patent 
                        }


                        if(res.data.is_system!=null&&res.data.is_system!=''){// 岗位信息安全和保密责任制度
                            that.duty = res.data.is_system 
                        }
                        if(res.data.is_nda!=null&&res.data.is_nda!=''){// 重要岗位人员信息安全和保密协议
                            that.agreement = res.data.is_nda 
                        }
                        if(res.data.is_safety!=null&&res.data.is_safety!=''){// 人员离岗离职安全管理规定
                            that.dimission = res.data.is_safety 
                        }
                        if(res.data.safety_manage!=null&&res.data.safety_manage!=''){// 信息安全设备运维管理
                            that.safety_manage = res.data.safety_manage 
                        }
                        if(res.data.plant_manage!=null&&res.data.plant_manage!=''){// 设备维修维护和报废销毁管理
                            that.destroy = res.data.plant_manage 
                        }
                        if(res.data.areas!=null&&res.data.areas!=''){// 网络区域划分是否合理
                            that.areas = res.data.areas 
                        }
                        if(res.data.safety_eq!=null&&res.data.safety_eq!=''){// 安全防护设备策略
                            that.tactics = res.data.safety_eq 
                        }
                        if(res.data.access!=null&&res.data.access!=''){// 互联网访问控制
                            that.control = res.data.access 
                        }
                        if(res.data.is_log!=null&&res.data.is_log!=''){// 互联网访问日志
                            that.log = res.data.is_log 
                        }
                        that.org = res.data.domain // 域名
                        that.address = res.data.ip // IP地址
                        if(res.data.web_record!=null&&res.data.web_record!=''){// 网站是否备案
                            that.file = res.data.web_record 
                        }
                        if(res.data.account!=null&&res.data.account!=''){// 门户网站账户安全管理
                            that.account = res.data.account 
                        }
                        if(res.data.clear!=null&&res.data.clear!=''){// 清理网站临时文件、关闭网站目录遍历功能等清理
                            that.clear = res.data.clear 
                        }
                        if(res.data.website!=null&&res.data.website!=''){// 门户网站信息发布管理
                            that.issue = res.data.website 
                        }
                        if(res.data.memory!=null&&res.data.memory!=''){// 移动储蓄设备管理方式
                            that.savings = res.data.memory 
                        }
                        if(res.data.system_mix!=null&&res.data.system_mix!=''){// 在非涉密信息系统和涉密信息系统间混用情况
                            that.blended = res.data.system_mix 
                        }
                        if(res.data.server_protection!=null&&res.data.server_protection!=''){// 服务器安全防护:不必要的应用、服务、端口
                            that.serve = res.data.server_protection 
                        }
                        if(res.data.server_account!=null&&res.data.server_account!=''){// 服务器安全防护:账户口令设置8位，包含数字、字母或符号
                            that.set_one = res.data.server_account 
                        }
                        if(res.data.server_scan!=null&&res.data.server_scan!=''){// 服务器安全防护:扫描、病毒木马监测
                            that.scan_one = res.data.server_scan 
                        }
                        if(res.data.network_protection!=null&&res.data.network_protection!=''){// 网络设备防护:安全策略配置
                            that.defend = res.data.network_protection 
                        }
                        if(res.data.network_account!=null&&res.data.network_account!=''){// 网络设备防护:账户口令设置8位，包含数字、字母或符号
                            that.set_two = res.data.network_account 
                        }
                        if(res.data.network_scan!=null&&res.data.network_scan!=''){// 网络设备防护:扫描、病毒木马监测
                            that.scan_two = res.data.network_scan 
                        }
                        if(res.data.safety!=null&&res.data.safety!=''){// 信息安全设备部署及使用:防病毒、防火墙、入侵检测、安全审计等功能的设备
                            that.deploy = res.data.safety 
                        }
                        if(res.data.policy!=null&&res.data.policy!=''){// 信息安全设备部署及使用:安全策略配置
                            that.deploy_two = res.data.policy 
                        }
                        if(res.data.computer!=null&&res.data.computer!=''){// 终端计算机安全管理方式
                            that.way = res.data.computer 
                        }
                        if(res.data.account_token!=null&&res.data.account_token!=''){// 账户口令管理
                            that.word = res.data.account_token 
                        }
                        if(res.data.net_safe!=null&&res.data.net_safe!=''){// 接入互联网安全控制措施
                            that.measure = res.data.net_safe 
                        }
                        if(res.data.mixing!=null&&res.data.mixing!=''){// 在非涉密信息系统和涉密信息系统混合使用情况
                            that.mingle = res.data.mixing 
                        }
                        if(res.data.scanning!=null&&res.data.scanning!=''){// 漏洞扫描木马检测
                            that.scan = res.data.scanning 
                        }
                        if(res.data.classified!=null&&res.data.classified!=''){// 是否存在使用非涉密计算计算机处理涉密信息情况
                            if(res.data.classified == 0){
                                that.existIndex = 1 
                            }else{
                                that.existIndex = 2
                                that.exist = res.data.classified 
                            }
                        }

                        if(res.data.plan_record!=null&&res.data.plan_record!=''){// 应急预案制定及备案情况
                            that.enact = res.data.plan_record 
                        }
                        if(res.data.support_team!=null&&res.data.support_team!=''){// 应急技术支援队伍
                            that.skill = res.data.support_team 
                        }
                        if(res.data.backup_data!=null&&res.data.backup_data!=''){// 重要数据
                            that.wd = res.data.backup_data 
                        }
                        if(res.data.backup_sys!=null&&res.data.backup_sys!=''){// 重要信息系统
                            that.lineage = res.data.backup_sys 
                        }
                        

                        if(res.data.is_train!=null&&res.data.is_train!=''){// 参加培训情况
                            that.trainIndex = res.data.is_train // 参加培训情况
                            that.attend = res.data.people // 本年度是否派员参加信息安全相关业务培训，人/次数
                            that.branch = res.data.train_name // 培训部门名称
                        }
                        if(res.data.start_train!=null&&res.data.start_train!=''){// 组织培训情况
                            if(res.data.start_train==0){
                                that.tissueIndex = res.data.start_train // 组织培训情况
                            }else{
                                that.tissueIndex = 1
                                that.tissue = res.data.start_train // 组织培训情况
                            }
                        }
                        that.ratio = res.data.ratio // 参训人员比例

                        that.virus = res.data.virusfree_servers // 进行过病毒木马等恶意代码检查服务器的台数
                        that.infection = res.data.virus_servers // 其中感染恶意代码的服务器台数
                        that.viciousness = res.data.virusfree_computer // 进行过病毒木马等恶意代码检测的终端计算机台数
                        that.venom = res.data.virus_computer // 其中感染恶意代码的终端计算机台数
                        that.flaw = res.data.scanned_servers // 进行过漏洞扫描的服务器台数
                        that.loophole = res.data.vulnerable_servers // 其中存在漏洞的服务器台数
                        that.defect = res.data.highrisk_servers // 其中存在高风险漏洞的服务器台数
                        that.leak = res.data.scanned_computer // 进行过漏洞扫描的终端计算机台数
                        that.hole = res.data.vulnerable_computer // 其中存在漏洞的终端计算器台数
                        that.high_risk = res.data.highrisk_computer // 其中存在高风险漏洞的终端计算器台数
                        that.spite = res.data.tamper_number // 门户网站网页被篡改（内含嵌恶意代码）次数
                        that.use = res.data.process_number // 使用非涉密终端计算机处理涉密信息事件数
                        that.system = res.data.mixed_number // 终端计算器在非涉密系统和涉密系统间混用事件数
                        that.shift = res.data.storage_mixed // 移动存储介质在非涉密系统和涉密系统间交叉使用事件数
                        
                        if(res.data.is_pass!=null&&res.data.is_pass!=''){// 信息安全管理体系认证情况
                            if(res.data.is_pass == 0){
                                that.attestationIndex = 2 
                            }else{
                                that.attestationIndex = 1
                                that.attestation = res.data.is_pass
                            }
                        }

                        if(res.data.company_license!=null&&res.data.company_license!=''){// 企业法人营业执照
                            that.company_license = res.data.company_license 
                        }
                        if(res.data.invoice!=null&&res.data.invoice!=''){// 开票资料
                            that.invoice = res.data.invoice 
                        }
                        if(res.data.taxpayers_book!=null&&res.data.taxpayers_book!=''){// 一般纳税人资格认定证书
                            that.taxpayers_book = res.data.taxpayers_book 
                        }
                        if(res.data.deposits!=null&&res.data.deposits!=''){// 基本存款账户信息
                            that.deposits = res.data.deposits 
                        }
                        if(res.data.taxpayers_level!=null&&res.data.taxpayers_level!=''){// 纳税信用等级证明
                            that.taxpayers_level = res.data.taxpayers_level 
                        }
                        if(res.data.liabilities!=null&&res.data.liabilities!=''){// 上年度12月份及近1个月的资产负债表
                            that.liabilities = res.data.liabilities 
                        }
                        if(res.data.profit_list!=null&&res.data.profit_list!=''){// 年度12月份及近1个月的利润表
                            that.profit_list = res.data.profit_list 
                        }
                        if(res.data.tax_table!=null&&res.data.tax_table!=''){// 上年度12月份及近1个月的增值税纳税申报表
                            that.tax_table = res.data.tax_table 
                        }
                        if(res.data.list!=null&&res.data.list!=''){// 供货清单
                            that.list = res.data.list 
                        }
                        if(res.data.system_book!=null&&res.data.system_book!=''){// 体系认证书/行业资质证书
                            that.system_book = res.data.system_book 
                        }
                        if(res.data.instrument_list!=null&&res.data.instrument_list!=''){// 设备检测仪器清单
                            that.instrument_list = res.data.instrument_list 
                        }
                        if(res.data.audit!=null&&res.data.audit!=''){// 审计报告
                            that.audit = res.data.audit 
                        }
                        if(res.data.ip_prove!=null&&res.data.ip_prove!=''){// 知识产权权属证明
                            that.ip_prove = res.data.ip_prove 
                        }
                        if(res.data.site_pic!=null&&res.data.site_pic!=''){// 现场/办公室照片
                            that.site_pic = res.data.site_pic 
                        }
                    }
                })
            },
            // 初审保存草稿
            onSavefirst(){
                const that = this
                let settle_type = '';// 结算方式
                if(that.balance==4){
                    settle_type = that.closing
                }else{
                    settle_type = that.balance
                }
                let company_nature = '';// 企业性质
                if(that.firm==9){
                    company_nature = that.property
                }else{
                    company_nature = that.firm
                }
                let company_type = '';// 资本类型
                if(that.capital==8){
                    company_type = that.company_type
                }else{
                    company_type = that.capital
                }
                let is_other = '';// 关联公司
                if(that.relevancy==2){
                    is_other = that.relevancy_name
                }else{
                    is_other = 0
                }
                let is_family = '';// 亲属关系
                if(that.clan==2){
                    is_family = that.clan_name
                }else{
                    is_family = 0
                }
                let adjust = '';// 物料产品包装
                if(that.material==2){
                    adjust = that.pack
                }else{
                    adjust = 1
                }

                let lab ='';// 有无实验室
                if(that.laboratoryId==2){
                    lab = 0
                }else{
                    lab = 1
                }
                let equipment ='';// 有无生产设备
                if(that.facilityId==2){
                    equipment = 0
                }else{
                    equipment = 1
                }
                that.$request({
                    that: that,
                    api: that.$api.editinfo,
                    data: {
                        parent_class:that.provisionId, // 供应商类型id
                        subclass:that.definiteId, // 具体类型id
                        company_name:that.firm_name, // 企业名称
                        code:that.credit_code,// 统一社会信用代码
                        company_year:that.establish,// 成立年份
                        legal_person:that.delegate,// 法人代表
                        legal_pos:that.post,// 法人代表职务
                        legal_phone:that.phone,// 法人联系电话
                        checker_pos:that.checker_pos,// 对账人
                        checker_phone:that.checker_phone,// 对账人电话
                        checker_email:that.checker_email,// 对账人邮箱
                        service_person:that.abutment,// 业务对接人
                        service_position:that.job,// 业务对接人职务
                        service_phone:that.telephone,// 业务对接人联系电话
                        service_email:that.gmail,// 业务对接人E-mail
                        scope:that.run,// 经营范围
                        category:that.trade,// 行业类别
                        company_url:that.url,// 企业网址
                        register_add:that.address,// 注册地址
                        company_address:that.site,// 通信地址
                        money:that.principal,// 注册资本
                        company_money:that.company_money,// 资产总值
                        year_sales:that.saleroom,// 上年度销售额
                        taxpayers:that.ratepaying,// 纳税人类别
                        rate:that.taxRate,// 税 率
                        settle_type:settle_type,// 结算方式
                        pay_method:that.receive,// 收付方式
                        company_nature:company_nature,// 企业性质
                        company_type:company_type,// 资本类型
                        is_other:is_other,// 关联公司
                        is_family:is_family,// 亲属关系
                        adjust:adjust,// 物料产品包装
                        clients_name:that.client_one,// 客户1
                        client_share:that.portfolio_one,// 业务量占比1
                        provide:that.cooperate_one,// 合作产品1
                        s_clients_name:that.client_two,// 客户2
                        s_client_share:that.portfolio_two,// 业务量占比2
                        s_provide:that.cooperate_two,// 合作产品2
                        t_clients_name:that.client_tri,// 客户3
                        t_client_share:that.portfolio_tri,// 业务量占比3
                        t_provide:that.cooperate_tri,// 合作产品3

                        total:that.total,// 人员总数
                        management:that.manage,// 管理人员
                        production:that.production,// 生产人员
                        rd:that.research_staff,// 研发人员
                        quality:that.quality,// 质量人员
                        sales:that.sell,// 销售人数
                        after_sales:that.after_sale,// 售后人员
                        other:that.rests,// 其它人员
                        foreign_af:that.serviceId,// 是否支持国外售后
                        rd_money:that.money,// 每年研发投入金额
                        design:that.field,// 设计领域
                        software:that.software,// 设计软件名称
                        area:that.floor_area,// 工厂占地面积
                        buil_area:that.covered_area,// 工厂建筑面积
                        warehouse:that.storage_area,// 仓库面积
                        production_area:that.production_area,// 工厂生产面积

                        product_type1:that.kind_one,// 主要生产产品种类一
                        year_capacity1:that.last_year_one,// 上年年产量一
                        reality_capacity1:that.practical_one,// 实际年产量一
                        total_sales1:that.total_one,// 总体销售额一
                        set_amount1:that.mating_one,// 配套额一
                        ppm1:that.quality_one,// 综合质量能力PPM一
                        product_type2:that.kind_two,// 主要生产产品种类二
                        year_capacity2:that.last_year_two,// 上年年产量二
                        reality_capacity2:that.practical_two,// 实际年产量二
                        total_sales2:that.total_two,// 总体销售额二
                        set_amount2:that.mating_two,// 配套额二
                        ppm2:that.quality_two,// 综合质量能力PPM二
                        system1:that.approve_one,// 何种体系认证/何种资质证书一
                        approve_time1:that.ms_one,// 认证时间一
                        end_time1:that.validity_one,// 有效期一
                        approve_body1:that.institution_one,// 认证机构一
                        book_code1:that.number_one,// 证书编号一
                        system2:that.approve_two,// 何种体系认证/何种资质证书二
                        approve_time2:that.ms_two,// 认证时间二
                        end_time2:that.validity_two,// 有效期二
                        approve_body2:that.institution_two,// 认证机构二
                        book_code2:that.number_two,// 证书编号二
                        agent_brand:that.lord,// 主代理品牌
                        agent_level:that.grade_one,// 代理等级
                        agent_book:that.agency_one,// 代理证书
                        other_brand:that.rest,//  其他代理品牌
                        other_level:that.grade_two,// 代理等级
                        other_book:that.agency_two,// 代理证书
                        agent_area:that.areaId,// 代理区域
                        market_share:that.quotientId,// 代理区域市场份额
                        channel:that.channel,// 主要来货渠道
                        once_products:that.staple,// 曾代理的主要产品
                        delivery_cycle:that.dealId,// 交期
                        logistics:that.deliveryId,// 物流配送
                        lab:lab,// 有无实验室
                        equipment:equipment,// 有无生产设备
                        
                        supplier_info:that.supplier_info,// 上传文档
                        type:2,
                    },
                    success(res) {
                        that.$dialog.toast({
                            mes: res.msg,
                            timeout: 1500,
                            icon: 'success',
                        })
                    }
                })
            },
            // 初审提交审核
            onSubmitfirst(){
                const that = this
                let settle_type = '';// 结算方式
                if(that.balance==4){
                    settle_type = that.closing
                }else{
                    settle_type = that.balance
                }
                let company_nature = '';// 企业性质
                if(that.firm==9){
                    company_nature = that.property
                }else{
                    company_nature = that.firm
                }
                let company_type = '';// 资本类型
                if(that.capital==8){
                    company_type = that.company_type
                }else{
                    company_type = that.capital
                }
                let is_other = '';// 关联公司
                if(that.relevancy==2){
                    is_other = that.relevancy_name
                }else{
                    is_other = 0
                }
                let is_family = '';// 亲属关系
                if(that.clan==2){
                    is_family = that.clan_name
                }else{
                    is_family = 0
                }
                let adjust = '';// 物料产品包装
                if(that.material==2){
                    adjust = that.pack
                }else{
                    adjust = 1
                }

                let lab ='';// 有无实验室
                if(that.laboratoryId==2){
                    lab = 0
                }else{
                    lab = 1
                }
                let equipment ='';// 有无生产设备
                if(that.facilityId==2){
                    equipment = 0
                }else{
                    equipment = 1
                }
                that.$request({
                    that: that,
                    api: that.$api.editinfo,
                    data: {
                        parent_class:that.provisionId, // 供应商类型id
                        subclass:that.definiteId, // 具体类型id
                        company_name:that.firm_name, // 企业名称
                        code:that.credit_code,// 统一社会信用代码
                        company_year:that.establish,// 成立年份
                        legal_person:that.delegate,// 法人代表
                        legal_pos:that.post,// 法人代表职务
                        legal_phone:that.phone,// 法人联系电话
                        checker_pos:that.checker_pos,// 对账人
                        checker_phone:that.checker_phone,// 对账人电话
                        checker_email:that.checker_email,// 对账人邮箱
                        service_person:that.abutment,// 业务对接人
                        service_position:that.job,// 业务对接人职务
                        service_phone:that.telephone,// 业务对接人联系电话
                        service_email:that.gmail,// 业务对接人E-mail
                        scope:that.run,// 经营范围
                        category:that.trade,// 行业类别
                        company_url:that.url,// 企业网址
                        register_add:that.address,// 注册地址
                        company_address:that.site,// 通信地址
                        money:that.principal,// 注册资本
                        company_money:that.company_money,// 资产总值
                        year_sales:that.saleroom,// 上年度销售额
                        taxpayers:that.ratepaying,// 纳税人类别
                        rate:that.taxRate,// 税 率
                        settle_type:settle_type,// 结算方式
                        pay_method:that.receive,// 收付方式
                        company_nature:company_nature,// 企业性质
                        company_type:company_type,// 资本类型
                        is_other:is_other,// 关联公司
                        is_family:is_family,// 亲属关系
                        adjust:adjust,// 物料产品包装
                        clients_name:that.client_one,// 客户1
                        client_share:that.portfolio_one,// 业务量占比1
                        provide:that.cooperate_one,// 合作产品1
                        s_clients_name:that.client_two,// 客户2
                        s_client_share:that.portfolio_two,// 业务量占比2
                        s_provide:that.cooperate_two,// 合作产品2
                        t_clients_name:that.client_tri,// 客户3
                        t_client_share:that.portfolio_tri,// 业务量占比3
                        t_provide:that.cooperate_tri,// 合作产品3

                        total:that.total,// 人员总数
                        management:that.manage,// 管理人员
                        production:that.production,// 生产人员
                        rd:that.research_staff,// 研发人员
                        quality:that.quality,// 质量人员
                        sales:that.sell,// 销售人数
                        after_sales:that.after_sale,// 售后人员
                        other:that.rests,// 其它人员
                        foreign_af:that.serviceId,// 是否支持国外售后
                        rd_money:that.money,// 每年研发投入金额
                        design:that.field,// 设计领域
                        software:that.software,// 设计软件名称
                        area:that.floor_area,// 工厂占地面积
                        buil_area:that.covered_area,// 工厂建筑面积
                        warehouse:that.storage_area,// 仓库面积
                        production_area:that.production_area,// 工厂生产面积

                        product_type1:that.kind_one,// 主要生产产品种类一
                        year_capacity1:that.last_year_one,// 上年年产量一
                        reality_capacity1:that.practical_one,// 实际年产量一
                        total_sales1:that.total_one,// 总体销售额一
                        set_amount1:that.mating_one,// 配套额一
                        ppm1:that.quality_one,// 综合质量能力PPM一
                        product_type2:that.kind_two,// 主要生产产品种类二
                        year_capacity2:that.last_year_two,// 上年年产量二
                        reality_capacity2:that.practical_two,// 实际年产量二
                        total_sales2:that.total_two,// 总体销售额二
                        set_amount2:that.mating_two,// 配套额二
                        ppm2:that.quality_two,// 综合质量能力PPM二
                        system1:that.approve_one,// 何种体系认证/何种资质证书一
                        approve_time1:that.ms_one,// 认证时间一
                        end_time1:that.validity_one,// 有效期一
                        approve_body1:that.institution_one,// 认证机构一
                        book_code1:that.number_one,// 证书编号一
                        system2:that.approve_two,// 何种体系认证/何种资质证书二
                        approve_time2:that.ms_two,// 认证时间二
                        end_time2:that.validity_two,// 有效期二
                        approve_body2:that.institution_two,// 认证机构二
                        book_code2:that.number_two,// 证书编号二
                        agent_brand:that.lord,// 主代理品牌
                        agent_level:that.grade_one,// 代理等级
                        agent_book:that.agency_one,// 代理证书
                        other_brand:that.rest,//  其他代理品牌
                        other_level:that.grade_two,// 代理等级
                        other_book:that.agency_two,// 代理证书
                        agent_area:that.areaId,// 代理区域
                        market_share:that.quotientId,// 代理区域市场份额
                        channel:that.channel,// 主要来货渠道
                        once_products:that.staple,// 曾代理的主要产品
                        delivery_cycle:that.dealId,// 交期
                        logistics:that.deliveryId,// 物流配送
                        lab:lab,// 有无实验室
                        equipment:equipment,// 有无生产设备
                        
                        supplier_info:that.supplier_info,// 上传文档
                        type:1,
                    },
                    success(res) {
                        that.$dialog.toast({
                            mes: '提交成功',
                            timeout: 1500,
                            icon: 'success',
                            callback(){
                                that.isBasics = false
                                that.isPopup = true
                            }
                        })
                    }
                })
            },
            // 初审上一页
            onFirstup(){
                // this.isBasics = false
                // this.isType = 1
                location.reload();
            },
            // 初审下一页
            onFirstnext(){
                this.isBasics = false
                this.isDetailed = true
            },
            // 查看填写信息
            onCheck(){
                this.isBasics = true
                this.isType = 2
                this.isFilled = true
                this.getgetDetails() // 获取详情
            },
            // 终审上一页 
            onUpeventually(){
                this.isDetailed = false
            },
            // 终审保存草稿 
            onSaveeventually(){
                const that = this
                let start_train = '';// 组织培训情况
                if(that.tissueIndex ==1){
                    start_train = that.tissue
                }else{
                    start_train = that.tissueIndex
                }
                let classified = '';// 是否存在使用非涉密计算计算机处理涉密信息情况
                if(that.existIndex ==2){
                    classified = that.exist
                }else{
                    classified = 0
                }
                let is_pass = '';// 信息安全管理体系认证情况
                if(that.attestationIndex ==2){
                    is_pass = 0
                }else{
                    is_pass = that.attestation
                }
                that.$request({
                    that: that,
                    api: that.$api.inDetail,
                    data: {
                        technical_name:that.technical_name,// 供应产品/服务/技术名称
                        patents:that.invent,// 发明专利数量
                        copyrights_name:that.copyright,// 著作权数量
                        utility_patents:that.practical,// 实用新型专利数量
                        other_patents:that.other,// 其它
                        logo:that.brand,// 商标数量
                        design_patent:that.facade,// 外观专利数量

                        is_system:that.duty,// 岗位信息安全和保密责任制度
                        is_nda:that.agreement,// 重要岗位人员信息安全和保密协议
                        is_safety:that.dimission,// 人员离岗离职安全管理规定
                        safety_manage:that.safety_manage,// 信息安全设备运维管理
                        plant_manage:that.destroy,// 设备维修维护和报废销毁管理

                        areas:that.areas,// 网络区域划分是否合理
                        safety_eq:that.tactics,// 安全防护设备策略
                        access:that.control,// 互联网访问控制
                        is_log:that.log,// 互联网访问日志
                        domain:that.org,// 域名
                        ip:that.address,// IP地址
                        web_record:that.file,// 网站是否备案
                        account:that.account,// 门户网站账户安全管理
                        clear:that.clear,// 清理网站临时文件、关闭网站目录遍历功能等清理
                        website:that.issue,// 门户网站信息发布管理
                        memory:that.savings,// 移动储蓄设备管理方式
                        system_mix:that.blended,// 在非涉密信息系统和涉密信息系统间混用情况
                        server_protection:that.serve,// 服务器安全防护:不必要的应用、服务、端口
                        server_account:that.set_one,// 服务器安全防护:账户口令设置8位，包含数字、字母或符号
                        server_scan:that.scan_one,// 服务器安全防护:扫描、病毒木马监测
                        network_protection:that.defend,// 网络设备防护:安全策略配置
                        network_account:that.set_two,// 网络设备防护:账户口令设置8位，包含数字、字母或符号
                        network_scan:that.scan_two,// 网络设备防护:扫描、病毒木马监测
                        safety:that.deploy,// 信息安全设备部署及使用:防病毒、防火墙、入侵检测、安全审计等功能的设备
                        policy:that.deploy_two,// 信息安全设备部署及使用:安全策略配置
                        computer:that.way,// 终端计算机安全管理方式
                        account_token:that.word,// 账户口令管理
                        net_safe:that.measure,// 接入互联网安全控制措施
                        mixing:that.mingle,// 在非涉密信息系统和涉密信息系统混合使用情况
                        scanning:that.scan,// 漏洞扫描木马检测
                        classified:classified,// 是否存在使用非涉密计算计算机处理涉密信息情况

                        plan_record:that.enact,// 应急预案制定及备案情况
                        support_team:that.skill,// 应急技术支援队伍
                        backup_data:that.wd,// 重要数据
                        backup_sys:that.lineage,// 重要信息系统

                        is_train:that.tissueIndex,// 参加培训情况
                        people:that.attend,// 本年度是否派员参加信息安全相关业务培训，人/次数
                        train_name:that.branch,// 培训部门名称
                        start_train:start_train,// 组织培训情况
                        ratio:that.ratio,// 参训人员比例

                        virusfree_servers:that.virus,// 进行过病毒木马等恶意代码检查服务器的台数
                        virus_servers:that.infection,// 其中感染恶意代码的服务器台数
                        virusfree_computer:that.viciousness,// 进行过病毒木马等恶意代码检测的终端计算机台数
                        virus_computer:that.venom,// 其中感染恶意代码的终端计算机台数
                        scanned_servers:that.flaw,// 进行过漏洞扫描的服务器台数
                        vulnerable_servers:that.loophole,// 其中存在漏洞的服务器台数
                        highrisk_servers:that.defect,// 其中存在高风险漏洞的服务器台数
                        scanned_computer:that.leak,// 进行过漏洞扫描的终端计算机台数
                        vulnerable_computer:that.hole,// 其中存在漏洞的终端计算器台数
                        highrisk_computer:that.high_risk,// 其中存在高风险漏洞的终端计算器台数
                        tamper_number:that.spite,// 门户网站网页被篡改（内含嵌恶意代码）次数
                        process_number:that.use,// 使用非涉密终端计算机处理涉密信息事件数
                        mixed_number:that.system,// 终端计算器在非涉密系统和涉密系统间混用事件数
                        storage_mixed:that.shift,// 移动存储介质在非涉密系统和涉密系统间交叉使用事件数

                        is_pass:is_pass,// 信息安全管理体系认证情况

                        company_license:that.company_license, //  企业法人营业执照
                        invoice:that.invoice,//  开票资料
                        taxpayers_book:that.taxpayers_book,//  一般纳税人资格认定证书
                        deposits:that.deposits,//  基本存款账户信息
                        taxpayers_level:that.taxpayers_level,//  纳税信用等级证明
                        liabilities:that.liabilities,//  上年度12月份及近1个月的资产负债表
                        profit_list:that.profit_list,//  年度12月份及近1个月的利润表
                        tax_table:that.tax_table,//  上年度12月份及近1个月的增值税纳税申报表
                        list:that.list,//  供货清单
                        system_book:that.system_book,//  体系认证书/行业资质证书
                        instrument_list:that.instrument_list,//  设备检测仪器清单
                        audit:that.audit,//  审计报告
                        ip_prove:that.ip_prove,//  知识产权权属证明
                        site_pic:that.site_pic,//  现场/办公室照片
                        ip_inquiry:that.ip_inquiry,//  知识产权调查表url
                        inquiry:that.inquiry,//  信息安全调查表url
                        type:2,
                    },
                    success(res) {
                        that.$dialog.toast({
                            mes: res.msg,
                            timeout: 1500,
                            icon: 'success',
                        })
                    }
                })
            },
            // 终审提交审核
            onSubmiteventually(){
                const that = this
                let start_train = '';// 组织培训情况
                if(that.tissueIndex ==1){
                    start_train = that.tissue
                }else{
                    start_train = that.tissueIndex
                }
                let classified = '';// 是否存在使用非涉密计算计算机处理涉密信息情况
                if(that.existIndex ==2){
                    classified = that.exist
                }else{
                    classified = 0
                }
                let is_pass = '';// 信息安全管理体系认证情况
                if(that.attestationIndex ==2){
                    is_pass = 0
                }else{
                    is_pass = that.attestation
                }
                that.$request({
                    that: that,
                    api: that.$api.inDetail,
                    data: {
                        technical_name:that.technical_name,// 供应产品/服务/技术名称
                        patents:that.invent,// 发明专利数量
                        copyrights_name:that.copyright,// 著作权数量
                        utility_patents:that.practical,// 实用新型专利数量
                        other_patents:that.other,// 其它
                        logo:that.brand,// 商标数量
                        design_patent:that.facade,// 外观专利数量

                        is_system:that.duty,// 岗位信息安全和保密责任制度
                        is_nda:that.agreement,// 重要岗位人员信息安全和保密协议
                        is_safety:that.dimission,// 人员离岗离职安全管理规定
                        safety_manage:that.safety_manage,// 信息安全设备运维管理
                        plant_manage:that.destroy,// 设备维修维护和报废销毁管理

                        areas:that.areas,// 网络区域划分是否合理
                        safety_eq:that.tactics,// 安全防护设备策略
                        access:that.control,// 互联网访问控制
                        is_log:that.log,// 互联网访问日志
                        domain:that.org,// 域名
                        ip:that.address,// IP地址
                        web_record:that.file,// 网站是否备案
                        account:that.account,// 门户网站账户安全管理
                        clear:that.clear,// 清理网站临时文件、关闭网站目录遍历功能等清理
                        website:that.issue,// 门户网站信息发布管理
                        memory:that.savings,// 移动储蓄设备管理方式
                        system_mix:that.blended,// 在非涉密信息系统和涉密信息系统间混用情况
                        server_protection:that.serve,// 服务器安全防护:不必要的应用、服务、端口
                        server_account:that.set_one,// 服务器安全防护:账户口令设置8位，包含数字、字母或符号
                        server_scan:that.scan_one,// 服务器安全防护:扫描、病毒木马监测
                        network_protection:that.defend,// 网络设备防护:安全策略配置
                        network_account:that.set_two,// 网络设备防护:账户口令设置8位，包含数字、字母或符号
                        network_scan:that.scan_two,// 网络设备防护:扫描、病毒木马监测
                        safety:that.deploy,// 信息安全设备部署及使用:防病毒、防火墙、入侵检测、安全审计等功能的设备
                        policy:that.deploy_two,// 信息安全设备部署及使用:安全策略配置
                        computer:that.way,// 终端计算机安全管理方式
                        account_token:that.word,// 账户口令管理
                        net_safe:that.measure,// 接入互联网安全控制措施
                        mixing:that.mingle,// 在非涉密信息系统和涉密信息系统混合使用情况
                        scanning:that.scan,// 漏洞扫描木马检测
                        classified:classified,// 是否存在使用非涉密计算计算机处理涉密信息情况

                        plan_record:that.enact,// 应急预案制定及备案情况
                        support_team:that.skill,// 应急技术支援队伍
                        backup_data:that.wd,// 重要数据
                        backup_sys:that.lineage,// 重要信息系统

                        is_train:that.tissueIndex,// 参加培训情况
                        people:that.attend,// 本年度是否派员参加信息安全相关业务培训，人/次数
                        train_name:that.branch,// 培训部门名称
                        start_train:start_train,// 组织培训情况
                        ratio:that.ratio,// 参训人员比例

                        virusfree_servers:that.virus,// 进行过病毒木马等恶意代码检查服务器的台数
                        virus_servers:that.infection,// 其中感染恶意代码的服务器台数
                        virusfree_computer:that.viciousness,// 进行过病毒木马等恶意代码检测的终端计算机台数
                        virus_computer:that.venom,// 其中感染恶意代码的终端计算机台数
                        scanned_servers:that.flaw,// 进行过漏洞扫描的服务器台数
                        vulnerable_servers:that.loophole,// 其中存在漏洞的服务器台数
                        highrisk_servers:that.defect,// 其中存在高风险漏洞的服务器台数
                        scanned_computer:that.leak,// 进行过漏洞扫描的终端计算机台数
                        vulnerable_computer:that.hole,// 其中存在漏洞的终端计算器台数
                        highrisk_computer:that.high_risk,// 其中存在高风险漏洞的终端计算器台数
                        tamper_number:that.spite,// 门户网站网页被篡改（内含嵌恶意代码）次数
                        process_number:that.use,// 使用非涉密终端计算机处理涉密信息事件数
                        mixed_number:that.system,// 终端计算器在非涉密系统和涉密系统间混用事件数
                        storage_mixed:that.shift,// 移动存储介质在非涉密系统和涉密系统间交叉使用事件数

                        is_pass:is_pass,// 信息安全管理体系认证情况

                        company_license:that.company_license, //  企业法人营业执照
                        invoice:that.invoice,//  开票资料
                        taxpayers_book:that.taxpayers_book,//  一般纳税人资格认定证书
                        deposits:that.deposits,//  基本存款账户信息
                        taxpayers_level:that.taxpayers_level,//  纳税信用等级证明
                        liabilities:that.liabilities,//  上年度12月份及近1个月的资产负债表
                        profit_list:that.profit_list,//  年度12月份及近1个月的利润表
                        tax_table:that.tax_table,//  上年度12月份及近1个月的增值税纳税申报表
                        list:that.list,//  供货清单
                        system_book:that.system_book,//  体系认证书/行业资质证书
                        instrument_list:that.instrument_list,//  设备检测仪器清单
                        audit:that.audit,//  审计报告
                        ip_prove:that.ip_prove,//  知识产权权属证明
                        site_pic:that.site_pic,//  现场/办公室照片
                        ip_inquiry:that.ip_inquiry,//  知识产权调查表url
                        inquiry:that.inquiry,//  信息安全调查表url
                        type:1,
                    },
                    success(res) {
                        that.$dialog.toast({
                            mes: '提交成功',
                            timeout: 1500,
                            icon: 'success',
                            callback(){
                                that.isDetailed = false
                                that.isPopup = true
                            }
                        })
                    }
                })
            },
            // 终审查看上一页 
            onEndup(){
                this.isBasics = true
                this.isDetailed = false
                this.isFilled = true
            },
            // 终审查看完毕
            onEnd(){
                // this.isDetailed = false
                // this.isType = 1
                location.reload();
            },
            // 参考
            onReference(i){
                if(i==1){
                   this.isRefer = true 
                }else{
                    this.isRefer = false 
                }
            },
            // 获取详情
            getgetDetails(){
                const that = this
                that.$request({
                    that: that,
                    api: that.$api.particulars,
                    data: {},
                    success(res) {
                        // 基础信息
                        // 供应商类型
                        if(res.data.parent_class!=null&&res.data.parent_class!=''){
                            that.provisionId = res.data.parent_class
                            that.provision_name = res.data.parent_name
                        }
                        // 具体类型
                        if(res.data.subclass!=null&&res.data.subclass!=''){
                            that.definiteId = res.data.subclass
                            that.definite_name = res.data.subclass_name
                        }
                        that.firm_name = res.data.company_name // 企业名称
                        that.credit_code = res.data.code // 统一社会信用代码
                        // 成立年份
                        if(res.data.company_year!=null&&res.data.company_year!=''){
                            that.establish = res.data.company_year 
                        }
                        that.delegate = res.data.legal_person // 法人代表
                        that.post = res.data.legal_pos //法人代表职务 
                        that.phone = res.data.legal_phone // 法人联系电话
                        that.checker_pos = res.data.checker_pos // 对账人
                        that.checker_phone = res.data.checker_phone// 对账人电话
                        that.checker_email = res.data.checker_email// 对账人邮箱
                        that.abutment = res.data.service_person // 业务对接人
                        that.job = res.data.service_position // 业务对接人职务
                        that.telephone = res.data.service_phone // 业务对接人联系电话
                        that.gmail = res.data.service_email // 业务对接人E-mail
                        that.run = res.data.scope // 经营范围
                        that.trade = res.data.category // 行业类别
                        that.url = res.data.company_url // 企业网址
                        that.address = res.data.register_add // 注册地址
                        that.site = res.data.company_address // 通信地址
                        that.principal = res.data.money // 注册资本
                        that.company_money = res.data.company_money // 资产总值
                        that.saleroom = res.data.year_sales // 上年度销售额

                        that.ratepaying = res.data.taxpayers // 纳税人类别
                        that.taxRate = res.data.rate // 税 率
                        if(res.data.settle_type!=1&&res.data.settle_type!=2&&res.data.settle_type!=3&&res.data.settle_type!=null&&res.data.settle_type!=''){// 结算方式
                            that.balance = 4
                            that.closing = res.data.settle_type
                        }else{
                            that.balance = res.data.settle_type
                        }
                        that.receive = res.data.pay_method // 收付方式
                        if(res.data.company_nature!=1&&res.data.company_nature!=2&&res.data.company_nature!=3&&res.data.company_nature!=4&&res.data.company_nature!=5&&res.data.company_nature!=6&&res.data.company_nature!=7&&res.data.company_nature!=8&&res.data.company_nature!=null&&res.data.company_nature!=''){//企业性质
                            that.firm = 9
                            that.property = res.data.company_nature
                        }else{
                            that.firm = res.data.company_nature
                        }
                        if(res.data.company_type!=1&&res.data.company_type!=2&&res.data.company_type!=3&&res.data.company_type!=4&&res.data.company_type!=5&&res.data.company_type!=6&&res.data.company_type!=7&&res.data.company_type!=null&&res.data.company_type!=''){//资本类型
                            that.capital = 8
                            that.company_type = res.data.company_type
                        }else{
                            that.capital = res.data.company_type
                        }
                        if(res.data.is_other!=null&&res.data.is_other!=''){// 关联公司
                            if(res.data.is_other==0){
                                that.relevancy = 1
                            }else{
                                that.relevancy = 2
                                that.relevancy_name = res.data.is_other
                            }
                        }
                        if(res.data.is_family!=null&&res.data.is_family!=''){// 亲属关系
                            if(res.data.is_family==0){
                                that.clan = 1
                            }else{
                                that.clan = 2
                                that.clan_name = res.data.is_family
                            }
                        }
                        if(res.data.adjust!=null&&res.data.adjust!=''){// 物料产品包装
                            if(res.data.adjust==1){
                                that.material = 1
                            }else{
                                that.material = 2
                                that.pack = res.data.adjust 
                            }
                        }

                        that.client_one = res.data.clients_name // 客户1
                        that.portfolio_one = res.data.client_share // 业务量占比1
                        that.cooperate_one =  res.data.provide // 合作产品1

                        that.client_two = res.data.s_clients_name // 客户2
                        that.portfolio_two = res.data.s_client_share // 业务量占比2
                        that.cooperate_two =  res.data.s_provide // 合作产品2

                        that.client_tri = res.data.t_clients_name // 客户3
                        that.portfolio_tri = res.data.t_client_share // 业务量占比3
                        that.cooperate_tri =  res.data.t_provide // 合作产品3

                        that.total = res.data.total // 人员总数
                        that.manage = res.data.management // 管理人员
                        that.production = res.data.production // 生产人员
                        that.research_staff = res.data.rd // 研发人员
                        that.quality = res.data.quality // 质量人员
                        that.sell = res.data.sales // 销售人数
                        that.after_sale = res.data.after_sales // 售后人员
                        that.rests = res.data.other // 其它人员
                        if(res.data.foreign_af!=null&&res.data.foreign_af!=''){// 是否支持国外售后
                            if(res.data.foreign_af==0){
                                that.serviceId = res.data.foreign_af
                                that.service = '否'
                            }
                            if(res.data.foreign_af==1){
                                that.serviceId = res.data.foreign_af
                                that.service = '是，售后响应时间24H'
                            }
                            if(res.data.foreign_af==2){
                                that.serviceId = res.data.foreign_af
                                that.service = '是，售后响应时间48H'
                            }
                        }
                        that.money = res.data.rd_money // 每年研发投入金额
                        that.field = res.data.design // 设计领域
                        that.software = res.data.software // 设计软件名称
                        that.floor_area = res.data.area // 工厂占地面积
                        that.covered_area = res.data.buil_area // 工厂建筑面积
                        that.storage_area = res.data.warehouse // 仓库面积
                        that.production_area = res.data.production_area // 工厂生产面积

                        that.kind_one = res.data.product_type1 // 主要生产产品种类一
                        that.last_year_one = res.data.year_capacity1 // 上年年产量一
                        that.practical_one = res.data.reality_capacity1 // 实际年产量一
                        that.total_one = res.data.total_sales1 // 总体销售额一
                        that.mating_one = res.data.set_amount1 //  配套额一
                        that.quality_one = res.data.ppm1 // 综合质量能力PPM一
                        if(res.data.product_type2!=null&&res.data.product_type2!=''){
                            that.variety = true
                        }
                        that.kind_two = res.data.product_type2 // 主要生产产品种类二
                        that.last_year_two = res.data.year_capacity2 // 上年年产量二
                        that.practical_two = res.data.reality_capacity2 // 实际年产量二
                        that.total_two = res.data.total_sales2 // 总体销售额二 
                        that.mating_two = res.data.set_amount2 // 配套额二
                        that.quality_two = res.data.ppm2 // 综合质量能力PPM二
                        that.approve_one = res.data.system1 // 何种体系认证/何种资质证书一
                        if(res.data.approve_time1!=null&&res.data.approve_time1!=''&&res.data.approve_time1!=''){// 认证时间一
                            that.ms_one = res.data.approve_time1 
                        }
                        if(res.data.end_time1!=null&&res.data.end_time1!=''&&res.data.end_time1!=0){// 有效期一
                            that.validity_one = res.data.end_time1 
                        }
                        that.institution_one = res.data.approve_body1 // 认证机构一
                        that.number_one = res.data.book_code1 // 证书编号一
                        if(res.data.system2!=null&&res.data.system2!=''){
                            that.isRapex = true
                        }
                        that.approve_two = res.data.system2 // 何种体系认证/何种资质证书二
                        if(res.data.approve_time2!=null&&res.data.approve_time2!=''&&res.data.approve_time2!=0){// 认证时间二
                            that.ms_two = res.data.approve_time2 
                        }
                        if(res.data.end_time2!=null&&res.data.end_time2!=''&&res.data.end_time2!=0){// 有效期二
                            that.validity_two = res.data.end_time2 
                        }
                        that.institution_two = res.data.approve_body2 // 认证机构二
                        that.number_two = res.data.book_code2 // 证书编号二
                        that.lord = res.data.agent_brand // 主代理品牌
                        that.grade_one = res.data.agent_level // 代理等级
                        if(res.data.agent_book!=null&&res.data.agent_book!=''){// 代理证书
                            that.agency_one = res.data.agent_book 
                        }
                        that.rest = res.data.other_brand // 其他代理品牌
                        that.grade_two = res.data.other_level // 代理等级
                        if(res.data.other_book!=null&&res.data.other_book!=''){// 代理证书
                            that.agency_two = res.data.other_book 
                        }
                        
                        if(res.data.agent_area!=null&&res.data.agent_area!=''){// 代理区域
                                that.areaId = res.data.agent_area 
                                if(res.data.agent_area==1){
                                    that.area_name = '全国'
                                }
                                if(res.data.agent_area==2){
                                    that.area_name = '区域'
                                }
                                if(res.data.agent_area==3){
                                    that.area_name = '其他'
                                }
                        }
                        if(res.data.market_share!=null&&res.data.market_share!=''){// 代理区域市场份额
                                that.quotientId = res.data.market_share 
                                if(res.data.market_share==1){
                                    that.quotient_name = '前五'
                                }
                                if(res.data.market_share==2){
                                    that.quotient_name = '前十'
                                }
                                if(res.data.market_share==3){
                                    that.quotient_name = '前二十'
                                }
                                if(res.data.market_share==4){
                                    that.quotient_name = '其他'
                                }
                        }
                        that.channel = res.data.channel // 主要来货渠道
                        that.staple = res.data.once_products // 曾代理的主要产品
                        if(res.data.delivery_cycle!=null&&res.data.delivery_cycle!=''){// 交期
                                that.dealId = res.data.delivery_cycle
                                if(res.data.delivery_cycle==1){
                                    that.deal_name = '≤3天'
                                }
                                if(res.data.delivery_cycle==2){
                                    that.deal_name = '≤5天'
                                }
                                if(res.data.delivery_cycle==3){
                                    that.deal_name = '≤7天'
                                }
                                if(res.data.delivery_cycle==4){
                                    that.deal_name = '≤15天'
                                }
                                if(res.data.delivery_cycle==5){
                                    that.deal_name = '≤20天'
                                }
                        }
                        
                        if(res.data.logistics!=null&&res.data.logistics!=''){// 物流配送
                                that.deliveryId = res.data.logistics
                                if(res.data.logistics==1){
                                    that.logistics = '自有专车物流配送'
                                }else{
                                    that.logistics = '第三方物流为主'
                                }
                        }
                        
                        if(res.data.lab!=null&&res.data.lab!=''){// 有无实验室
                                if(res.data.lab==0){
                                    that.laboratoryId = 2
                                    that.lab_name = '无'
                                }else{
                                    that.laboratoryId = 1
                                    that.lab_name = '有'
                                }
                        }
                        
                        if(res.data.equipment!=null&&res.data.equipment!=''){// 有无生产设备
                                if(res.data.equipment==0){
                                    that.facilityId = 2
                                    that.facility = '无'
                                }else{
                                    that.facilityId = 1
                                    that.facility = '有'
                                }
                        }

                        if(res.data.supplier_info!=null&&res.data.supplier_info!=''){
                            that.supplier_info = res.data.supplier_info
                        }

                        // 详细信息
                        if(res.data.technical_name!=null&&res.data.technical_name!=''){// 供应产品/服务/技术名称
                            that.technical_name = res.data.technical_name 
                        }
                        if(res.data.patents!=null&&res.data.patents!=''){// 发明专利数量
                            that.invent = res.data.patents 
                        }
                        if(res.data.copyrights_name!=null&&res.data.copyrights_name!=''){// 著作权数量
                            that.copyright = res.data.copyrights_name 
                        }
                        if(res.data.utility_patents!=null&&res.data.utility_patents!=''){// 实用新型专利数量
                            that.practical = res.data.utility_patents 
                        }
                        if(res.data.other_patents!=null&&res.data.other_patents!=''){// 其它
                            that.other = res.data.other_patents 
                        }
                        if(res.data.logo!=null&&res.data.logo!=''){// 商标数量
                            that.brand = res.data.logo 
                        }
                        if(res.data.design_patent!=null&&res.data.design_patent!=''){// 外观专利数量
                            that.facade = res.data.design_patent 
                        }


                        if(res.data.is_system!=null&&res.data.is_system!=''){// 岗位信息安全和保密责任制度
                            that.duty = res.data.is_system 
                        }
                        if(res.data.is_nda!=null&&res.data.is_nda!=''){// 重要岗位人员信息安全和保密协议
                            that.agreement = res.data.is_nda 
                        }
                        if(res.data.is_safety!=null&&res.data.is_safety!=''){// 人员离岗离职安全管理规定
                            that.dimission = res.data.is_safety 
                        }
                        if(res.data.safety_manage!=null&&res.data.safety_manage!=''){// 信息安全设备运维管理
                            that.safety_manage = res.data.safety_manage 
                        }
                        if(res.data.plant_manage!=null&&res.data.plant_manage!=''){// 设备维修维护和报废销毁管理
                            that.destroy = res.data.plant_manage 
                        }
                        if(res.data.areas!=null&&res.data.areas!=''){// 网络区域划分是否合理
                            that.areas = res.data.areas 
                        }
                        if(res.data.safety_eq!=null&&res.data.safety_eq!=''){// 安全防护设备策略
                            that.tactics = res.data.safety_eq 
                        }
                        if(res.data.access!=null&&res.data.access!=''){// 互联网访问控制
                            that.control = res.data.access 
                        }
                        if(res.data.is_log!=null&&res.data.is_log!=''){// 互联网访问日志
                            that.log = res.data.is_log 
                        }
                        that.org = res.data.domain // 域名
                        that.address = res.data.register_add // IP地址
                        if(res.data.web_record!=null&&res.data.web_record!=''){// 网站是否备案
                            that.file = res.data.web_record 
                        }
                        if(res.data.account!=null&&res.data.account!=''){// 门户网站账户安全管理
                            that.account = res.data.account 
                        }
                        if(res.data.clear!=null&&res.data.clear!=''){// 清理网站临时文件、关闭网站目录遍历功能等清理
                            that.clear = res.data.clear 
                        }
                        if(res.data.website!=null&&res.data.website!=''){// 门户网站信息发布管理
                            that.issue = res.data.website 
                        }
                        if(res.data.memory!=null&&res.data.memory!=''){// 移动储蓄设备管理方式
                            that.savings = res.data.memory 
                        }
                        if(res.data.system_mix!=null&&res.data.system_mix!=''){// 在非涉密信息系统和涉密信息系统间混用情况
                            that.blended = res.data.system_mix 
                        }
                        if(res.data.server_protection!=null&&res.data.server_protection!=''){// 服务器安全防护:不必要的应用、服务、端口
                            that.serve = res.data.server_protection 
                        }
                        if(res.data.server_account!=null&&res.data.server_account!=''){// 服务器安全防护:账户口令设置8位，包含数字、字母或符号
                            that.set_one = res.data.server_account 
                        }
                        if(res.data.server_scan!=null&&res.data.server_scan!=''){// 服务器安全防护:扫描、病毒木马监测
                            that.scan_one = res.data.server_scan 
                        }
                        if(res.data.network_protection!=null&&res.data.network_protection!=''){// 网络设备防护:安全策略配置
                            that.defend = res.data.network_protection 
                        }
                        if(res.data.network_account!=null&&res.data.network_account!=''){// 网络设备防护:账户口令设置8位，包含数字、字母或符号
                            that.set_two = res.data.network_account 
                        }
                        if(res.data.network_scan!=null&&res.data.network_scan!=''){// 网络设备防护:扫描、病毒木马监测
                            that.scan_two = res.data.network_scan 
                        }
                        if(res.data.safety!=null&&res.data.safety!=''){// 信息安全设备部署及使用:防病毒、防火墙、入侵检测、安全审计等功能的设备
                            that.deploy = res.data.safety 
                        }
                        if(res.data.policy!=null&&res.data.policy!=''){// 信息安全设备部署及使用:安全策略配置
                            that.deploy_two = res.data.policy 
                        }
                        if(res.data.computer!=null&&res.data.computer!=''){// 终端计算机安全管理方式
                            that.way = res.data.computer 
                        }
                        if(res.data.account_token!=null&&res.data.account_token!=''){// 账户口令管理
                            that.word = res.data.account_token 
                        }
                        if(res.data.net_safe!=null&&res.data.net_safe!=''){// 接入互联网安全控制措施
                            that.measure = res.data.net_safe 
                        }
                        if(res.data.mixing!=null&&res.data.mixing!=''){// 在非涉密信息系统和涉密信息系统混合使用情况
                            that.mingle = res.data.mixing 
                        }
                        if(res.data.scanning!=null&&res.data.scanning!=''){// 漏洞扫描木马检测
                            that.scan = res.data.scanning 
                        }
                        if(res.data.classified!=null&&res.data.classified!=''){// 是否存在使用非涉密计算计算机处理涉密信息情况
                            if(res.data.classified == 0){
                                that.existIndex = 1 
                            }else{
                                that.existIndex = 2
                                that.exist = res.data.classified 
                            }
                        }

                        if(res.data.plan_record!=null&&res.data.plan_record!=''){// 应急预案制定及备案情况
                            that.enact = res.data.plan_record 
                        }
                        if(res.data.support_team!=null&&res.data.support_team!=''){// 应急技术支援队伍
                            that.skill = res.data.support_team 
                        }
                        if(res.data.backup_data!=null&&res.data.backup_data!=''){// 重要数据
                            that.wd = res.data.backup_data 
                        }
                        if(res.data.backup_sys!=null&&res.data.backup_sys!=''){// 重要信息系统
                            that.lineage = res.data.backup_sys 
                        }
                        

                        if(res.data.is_train!=null&&res.data.is_train!=''){// 参加培训情况
                            that.trainIndex = res.data.is_train // 参加培训情况
                            that.attend = res.data.people // 本年度是否派员参加信息安全相关业务培训，人/次数
                            that.branch = res.data.train_name // 培训部门名称
                        }
                        if(res.data.start_train!=null&&res.data.start_train!=''){// 组织培训情况
                            if(res.data.start_train==0){
                                that.tissueIndex = res.data.start_train // 组织培训情况
                            }else{
                                that.tissueIndex = 1
                                that.tissue = res.data.start_train // 组织培训情况
                            }
                        }
                        that.ratio = res.data.ratio // 参训人员比例

                        that.virus = res.data.virusfree_servers // 进行过病毒木马等恶意代码检查服务器的台数
                        that.infection = res.data.virus_servers // 其中感染恶意代码的服务器台数
                        that.viciousness = res.data.virusfree_computer // 进行过病毒木马等恶意代码检测的终端计算机台数
                        that.venom = res.data.virus_computer // 其中感染恶意代码的终端计算机台数
                        that.flaw = res.data.scanned_servers // 进行过漏洞扫描的服务器台数
                        that.loophole = res.data.vulnerable_servers // 其中存在漏洞的服务器台数
                        that.defect = res.data.highrisk_servers // 其中存在高风险漏洞的服务器台数
                        that.leak = res.data.scanned_computer // 进行过漏洞扫描的终端计算机台数
                        that.hole = res.data.vulnerable_computer // 其中存在漏洞的终端计算器台数
                        that.high_risk = res.data.highrisk_computer // 其中存在高风险漏洞的终端计算器台数
                        that.spite = res.data.tamper_number // 门户网站网页被篡改（内含嵌恶意代码）次数
                        that.use = res.data.process_number // 使用非涉密终端计算机处理涉密信息事件数
                        that.system = res.data.mixed_number // 终端计算器在非涉密系统和涉密系统间混用事件数
                        that.shift = res.data.storage_mixed // 移动存储介质在非涉密系统和涉密系统间交叉使用事件数
                        
                        if(res.data.is_pass!=null&&res.data.is_pass!=''){// 信息安全管理体系认证情况
                            if(res.data.is_pass == 0){
                                that.attestationIndex = 2 
                            }else{
                                that.attestationIndex = 1
                                that.attestation = res.data.is_pass
                            }
                        }

                        if(res.data.company_license!=null&&res.data.company_license!=''){// 企业法人营业执照
                            that.company_license = res.data.company_license 
                        }
                        if(res.data.invoice!=null&&res.data.invoice!=''){// 开票资料
                            that.invoice = res.data.invoice 
                        }
                        if(res.data.taxpayers_book!=null&&res.data.taxpayers_book!=''){// 一般纳税人资格认定证书
                            that.taxpayers_book = res.data.taxpayers_book 
                        }
                        if(res.data.deposits!=null&&res.data.deposits!=''){// 基本存款账户信息
                            that.deposits = res.data.deposits 
                        }
                        if(res.data.taxpayers_level!=null&&res.data.taxpayers_level!=''){// 纳税信用等级证明
                            that.taxpayers_level = res.data.taxpayers_level 
                        }
                        if(res.data.liabilities!=null&&res.data.liabilities!=''){// 上年度12月份及近1个月的资产负债表
                            that.liabilities = res.data.liabilities 
                        }
                        if(res.data.profit_list!=null&&res.data.profit_list!=''){// 年度12月份及近1个月的利润表
                            that.profit_list = res.data.profit_list 
                        }
                        if(res.data.tax_table!=null&&res.data.tax_table!=''){// 上年度12月份及近1个月的增值税纳税申报表
                            that.tax_table = res.data.tax_table 
                        }
                        if(res.data.list!=null&&res.data.list!=''){// 供货清单
                            that.list = res.data.list 
                        }
                        if(res.data.system_book!=null&&res.data.system_book!=''){// 体系认证书/行业资质证书
                            that.system_book = res.data.system_book 
                        }
                        if(res.data.instrument_list!=null&&res.data.instrument_list!=''){// 设备检测仪器清单
                            that.instrument_list = res.data.instrument_list 
                        }
                        if(res.data.audit!=null&&res.data.audit!=''){// 审计报告
                            that.audit = res.data.audit 
                        }
                        if(res.data.ip_prove!=null&&res.data.ip_prove!=''){// 知识产权权属证明
                            that.ip_prove = res.data.ip_prove 
                        }
                        if(res.data.site_pic!=null&&res.data.site_pic!=''){// 现场/办公室照片
                            that.site_pic = res.data.site_pic 
                        }
                    }
                })
            },
            // 文档上传
            archiveFile(e){
                console.log('123+++',e.target.files)
                const that = this
                let inputDOM = that.$refs.inputer_zero
                    that.fil = inputDOM.files
                    
                if(that.fil.length == 0) return 
                for(let i=0;i<that.fil.length;i++) {
                    that.uploadData(that.fil[i],0)
                }

                console.log('【that.fil】', that.fil)
            },
            // 企业法人营业执照
            licenseFile(e){
                console.log('123+++',e.target.files)
                const that = this
                let inputDOM = that.$refs.inputer_one
                    that.fil = inputDOM.files
                    
                if(that.fil.length == 0) return 
                for(let i=0;i<that.fil.length;i++) {
                    that.uploadData(that.fil[i],1)
                }

                console.log('【that.fil】', that.fil)
            },
            // 开票资料
            ticketFile(e){
                console.log('123+++',e.target.files)
                const that = this
                let inputDOM = that.$refs.inputer_two
                    that.fil = inputDOM.files
                    
                if(that.fil.length == 0) return 
                for(let i=0;i<that.fil.length;i++) {
                    that.uploadData(that.fil[i],2)
                }

                console.log('【that.fil】', that.fil)
            },
            // 一般纳税人资格认定证书
            ordinaryFile(e){
                console.log('123+++',e.target.files)
                const that = this
                let inputDOM = that.$refs.inputer_tri
                    that.fil = inputDOM.files
                    
                if(that.fil.length == 0) return 
                for(let i=0;i<that.fil.length;i++) {
                    that.uploadData(that.fil[i],3)
                }

                console.log('【that.fil】', that.fil)
            },
            // 基本存款账户信息
            baseFile(e){
                console.log('123+++',e.target.files)
                const that = this
                let inputDOM = that.$refs.inputer_four
                    that.fil = inputDOM.files
                    
                if(that.fil.length == 0) return 
                for(let i=0;i<that.fil.length;i++) {
                    that.uploadData(that.fil[i],4)
                }

                console.log('【that.fil】', that.fil)
            },
            // 纳税信用等级证明
            gradeFile(e){
                console.log('123+++',e.target.files)
                const that = this
                let inputDOM = that.$refs.inputer_five
                    that.fil = inputDOM.files
                    
                if(that.fil.length == 0) return 
                for(let i=0;i<that.fil.length;i++) {
                    that.uploadData(that.fil[i],5)
                }

                console.log('【that.fil】', that.fil)
            },
            // 上年度12月份及近1个月的资产负债表
            liabilitiesFile(e){
                console.log('123+++',e.target.files)
                const that = this
                let inputDOM = that.$refs.inputer_six
                    that.fil = inputDOM.files
                    
                if(that.fil.length == 0) return 
                for(let i=0;i<that.fil.length;i++) {
                    that.uploadData(that.fil[i],6)
                }

                console.log('【that.fil】', that.fil)
            },
            // 年度12月份及近1个月的利润表 
            profitFile(e){
                console.log('123+++',e.target.files)
                const that = this
                let inputDOM = that.$refs.inputer_seven
                    that.fil = inputDOM.files
                    
                if(that.fil.length == 0) return 
                for(let i=0;i<that.fil.length;i++) {
                    that.uploadData(that.fil[i],7)
                }

                console.log('【that.fil】', that.fil)
            },
            // 上年度12月份及近1个月的增值税纳税申报表
            declareFile(e){
                console.log('123+++',e.target.files)
                const that = this
                let inputDOM = that.$refs.inputer_eight
                    that.fil = inputDOM.files
                    
                if(that.fil.length == 0) return 
                for(let i=0;i<that.fil.length;i++) {
                    that.uploadData(that.fil[i],8)
                }

                console.log('【that.fil】', that.fil)
            },
            // 供货清单
            supplyFile(e){
                console.log('123+++',e.target.files)
                const that = this
                let inputDOM = that.$refs.inputer_nine
                    that.fil = inputDOM.files
                    
                if(that.fil.length == 0) return 
                for(let i=0;i<that.fil.length;i++) {
                    that.uploadData(that.fil[i],9)
                }

                console.log('【that.fil】', that.fil)
            },
            // 体系认证书/行业资质证书
            systemFile(e){
                console.log('123+++',e.target.files)
                const that = this
                let inputDOM = that.$refs.inputer_ten
                    that.fil = inputDOM.files
                    
                if(that.fil.length == 0) return 
                for(let i=0;i<that.fil.length;i++) {
                    that.uploadData(that.fil[i],10)
                }

                console.log('【that.fil】', that.fil)
            },
            // 设备检测仪器清单
            facilityFile(e){
                console.log('123+++',e.target.files)
                const that = this
                let inputDOM = that.$refs.inputer_eleven
                    that.fil = inputDOM.files
                    
                if(that.fil.length == 0) return 
                for(let i=0;i<that.fil.length;i++) {
                    that.uploadData(that.fil[i],11)
                }

                console.log('【that.fil】', that.fil)
            },
            // 审计报告
            auditFile(e){
                console.log('123+++',e.target.files)
                const that = this
                let inputDOM = that.$refs.inputer_twelve
                    that.fil = inputDOM.files
                    
                if(that.fil.length == 0) return 
                for(let i=0;i<that.fil.length;i++) {
                    that.uploadData(that.fil[i],12)
                }

                console.log('【that.fil】', that.fil)
            },
            // 知识产权权属证明
            ownershipFile(e){
                console.log('123+++',e.target.files)
                const that = this
                let inputDOM = that.$refs.inputer_thirteen
                    that.fil = inputDOM.files
                    
                if(that.fil.length == 0) return 
                for(let i=0;i<that.fil.length;i++) {
                    that.uploadData(that.fil[i],13)
                }

                console.log('【that.fil】', that.fil)
            },
            // 现场/办公室照片
            sceneFile(e){
                console.log('123+++',e.target.files)
                const that = this
                let inputDOM = that.$refs.inputer_fourteen
                    that.fil = inputDOM.files
                    
                if(that.fil.length == 0) return 
                for(let i=0;i<that.fil.length;i++) {
                    that.uploadData(that.fil[i],14)
                }

                console.log('【that.fil】', that.fil)
            },
            // 其他代理证书上传
            restsFile(e){
                console.log('123+++',e.target.files)
                const that = this
                let inputDOM = that.$refs.inputer_fifteen
                    that.fil = inputDOM.files
                    
                if(that.fil.length == 0) return 
                for(let i=0;i<that.fil.length;i++) {
                    that.uploadData(that.fil[i],15)
                }

                console.log('【that.fil】', that.fil)
            },
            // 主代理证书上传
            proxyFile(e){
                console.log('123+++',e.target.files)
                const that = this
                let inputDOM = that.$refs.inputer_sixteen
                    that.fil = inputDOM.files
                    
                if(that.fil.length == 0) return 
                for(let i=0;i<that.fil.length;i++) {
                    that.uploadData(that.fil[i],16)
                }

                console.log('【that.fil】', that.fil)
            },
            // 上传
            uploadData(pdf,i){
                const that = this
                if(i==0){
                    that.imgData = new FormData()
                    // that.imgData.append('catalog','bourse')
                    // 
                    // that.imgData.append('name','images')
                    that.imgData.append('file',pdf)
                    that.imgData.append('id',that.user.id)
                    that.$request({
                        that: that,
                        api: that.$api.questionnaire,
                        data: that.imgData,
                        headers: { 'content-type': 'multipart/form-data'},
                        discardSign: true,
                        loading: true,
                        success(res){
                            that.supplier_info = res.data.src
                        },
                        fail(err) {
                            console.log(err)
                            that.$dialog.alert({
                                mes:'上传失败'
                            });
                        }
                    })
                }else{
                    let field = ''
                    if(i==1){
                        field = '企业法人营业执照'
                    }
                    if(i==2){
                        field = '开票资料'
                    }
                    if(i==3){
                        field = '一般纳税人资格认定证书'
                    }
                    if(i==4){
                        field = '基本存款账户信息'
                    }
                    if(i==5){
                        field = '纳税信用等级证明'
                    }
                    if(i==6){
                        field = '上年度12月份及近1个月的资产负债表'
                    }
                    if(i==7){
                        field = '年度12月份及近1个月的利润表'
                    }
                    if(i==8){
                        field = '上年度12月份及近1个月的增值税纳税申报表'
                    }
                    if(i==9){
                        field = '供货清单'
                    }
                    if(i==10){
                        field = '体系认证书或行业资质证书'
                    }
                    if(i==11){
                        field = '设备检测仪器清单'
                    }
                    if(i==12){
                        field = '审计报告'
                    }
                    if(i==13){
                        field = '知识产权权属证明'
                    }
                    if(i==14){
                        field = '现场或办公室照片'
                    }
                    that.imgData = new FormData()
                    // that.imgData.append('catalog','bourse')
                    // 
                    // that.imgData.append('name','images')
                    that.imgData.append('type','pdf')
                    that.imgData.append('pdf',pdf)
                    that.imgData.append('name',that.user.company_name)
                    that.imgData.append('field',field)
                    console.log('*********1',that.imgData,i)
                    that.$request({
                        that: that,
                        api: that.$api.uploadFile,
                        data: that.imgData,
                        headers: { 'content-type': 'multipart/form-data'},
                        discardSign: true,
                        loading: true,
                        success(res){
                            console.log('打印本次结果：',res,i)
                            if(i==0){//  文档上传
                                that.supplier_info = res.data.src
                            }
                            if(i==1){//  企业法人营业执照
                                that.company_license = res.data.src
                            }
                            if(i==2){//  开票资料
                                that.invoice = res.data.src
                            }
                            if(i==3){//  一般纳税人资格认定证书
                                that.taxpayers_book = res.data.src
                            }
                            if(i==4){//  基本存款账户信息
                                that.deposits = res.data.src
                            }
                            if(i==5){//  纳税信用等级证明
                                that.taxpayers_level = res.data.src
                            }
                            if(i==6){//  上年度12月份及近1个月的资产负债表
                                that.liabilities = res.data.src
                            }
                            if(i==7){//  年度12月份及近1个月的利润表
                                that.profit_list = res.data.src
                            }
                            if(i==8){//  上年度12月份及近1个月的增值税纳税申报表
                                that.tax_table = res.data.src
                            }
                            if(i==9){//  供货清单
                                that.list = res.data.src
                            }
                            if(i==10){//  体系认证书或行业资质证书
                                that.system_book = res.data.src
                            }
                            if(i==11){//  设备检测仪器清单
                                that.instrument_list = res.data.src
                            }
                            if(i==12){//  审计报告
                                that.audit = res.data.src
                            }
                            if(i==13){//  知识产权权属证明
                                that.ip_prove = res.data.src
                            }
                            if(i==14){//  现场或办公室照片
                                that.site_pic = res.data.src
                            }
                            if(i==15){//  其他代理证书上传
                                that.agency_one = res.data.src
                            }
                            if(i==16){//  主代理证书上传
                                that.agency_two = res.data.src
                            }
                            // console.log('打印查看',that.atlas)
                        },
                        fail(err) {
                            console.log(err)
                            that.$dialog.alert({
                                mes:'上传失败'
                            });
                        }
                    })
                }
                
            },
            // 删除文档重新上传
            onDelete(){
                this.supplier_info = ''
            },
            //底部链接
            getSole(){
                const that = this
                that.$request({
                    that: that,
                    api: that.$api.sole,
                    data: {},
                    success(res) {
                        that.link = res.data
                    }
                })
            },
            // 纳税人类别
            onRatepaying(ratepaying){
                this.ratepaying = ratepaying
            },
            // 税 率
            onTaxRate(taxRate){
               this.taxRate = taxRate
            },
            // 结算方式
            onBalance(balance){
                this.balance = balance 
                if(balance==4){
                    this.$nextTick((x)=>{   //正确写法
                        this.$refs.closing.focus()
                    })
                }
            },
            // 收付方式
            onReceive(receive){
                this.receive = receive 
            },
            // 企业性质
            onFirm(firm){
                this.firm = firm 
                if(firm==9){
                    this.$nextTick((x)=>{   //正确写法
                        this.$refs.property.focus()
                    })
                }
            },
            // 资本类型
            onCapital(capital){
                this.capital = capital 
                if(capital==8){
                    this.$nextTick((x)=>{   //正确写法
                        this.$refs.company_type.focus()
                    })
                }
            },
            // 关联公司
            onRelevancy(relevancy){
                this.relevancy = relevancy
                if(relevancy==2){
                    this.$nextTick((x)=>{   //正确写法
                        this.$refs.relevancy_name.focus()
                    })
                }
            },
            // 亲属关系
            onClan(clan){
                this.clan = clan 
                if(clan==2){
                    this.$nextTick((x)=>{   //正确写法
                        this.$refs.clan_name.focus()
                    })
                }
            },
            // 亲属关系
            onMaterial(material){
                this.material = material
                if(material==2){
                    this.$nextTick((x)=>{   //正确写法
                        this.$refs.pack.focus()
                    })
                }
            },
            // 岗位信息安全和保密责任制度
            onDuty(duty){
                this.duty = duty
            },
            // 重要岗位人员信息安全和保密协议
            onAgreement(agreement){
                this.agreement = agreement
            },
            // 人员离岗离职安全管理规定
            onDimission(dimission){
                this.dimission = dimission
            },
            // 信息安全设备运维管理
            onSafety_manage(safety_manage){
                this.safety_manage = safety_manage
            },
            // 设备维修维护和报废销毁管理
            onDestroy(destroy){
                this.destroy = destroy
            },
            // 网络区域划分是否合理
            onArea(areas){
                this.areas = areas
            },
            // 安全防护设备策略
            onTactics(tactics){
                this.tactics = tactics
            },
            // 互联网访问控制
            onControl(control){
                this.control = control
            },
            // 互联网访问日志
            onLog(log){
                this.log = log
            },
            // 网站是否备案
            onFile(file){
                this.file = file
            },
            // 门户网站账户安全管理
            onAccount(account){
                this.account = account
            },
            // 清理网站临时文件、关闭网站目录遍历功能等清理
            onClear(clear){
                this.clear = clear
            },
            // 门户网站信息发布管理
            onIssue(issue){
                this.issue = issue
            },
            // 移动储蓄设备管理方式
            onSavings(savings){
                this.savings = savings
            },
            // 在非涉密信息系统和涉密信息系统间混用情况
            onBlended(blended){
                this.blended = blended
            },
            // 服务器安全防护:不必要的应用、服务、端口
            onServe(serve){
                this.serve = serve
            },
            // 服务器安全防护:账户口令设置8位，包含数字、字母或符号
            onSet_one(set_one){
                this.set_one = set_one
            },
            // 服务器安全防护:扫描、病毒木马监测
            onScan_one(scan_one){
                this.scan_one = scan_one
            },
            // 网络设备防护:安全策略配置
            onDefend(defend){
                this.defend = defend
            },
            // 网络设备防护:账户口令设置8位，包含数字、字母或符号
            onSet_two(set_two){
                this.set_two = set_two
            },
            // 网络设备防护:扫描、病毒木马监测
            onScan_two(scan_two){
                this.scan_two = scan_two
            },
            // 信息安全设备部署及使用:防病毒、防火墙、入侵检测、安全审计等功能的设备
            onDeploy(deploy){
                this.deploy = deploy
            },
            // 信息安全设备部署及使用:安全策略配置
            onDeploy_two(deploy_two){
                this.deploy_two = deploy_two
            },
            // 终端计算机安全管理
            onWay(way){
                this.way = way
            },
            // 账户口令管理
            onWord(word){
                this.word = word
            },
            // 接入互联网安全控制措施
            onMeasure(measure){
                this.measure = measure
            },
            // 在非涉密信息系统和涉密信息系统混合使用情况
            onMingle(mingle){
                this.mingle = mingle
            },
            // 漏洞扫描木马检测
            onScan(scan){
                this.scan = scan
            },
            // 是否存在使用非涉密计算计算机处理涉密信息情况
            onExist(existIndex){
                this.existIndex = existIndex
                if(existIndex==2){
                    this.$nextTick((x)=>{   //正确写法
                        this.$refs.exist_one.focus()
                    })
                    
                }
            },

            // 应急预案制定及备案情况
            onEnact(enact){
                this.enact = enact
            },
            // 应急技术支援队伍
            onSkill(skill){
                this.skill = skill
            },
            // 重要数据
            onWd(wd){
                this.wd = wd
            },
            // 重要信息系统
            onLineage(lineage){
                this.lineage = lineage
            },
            // 参加培训情况
            onTrain(trainIndex){
                this.trainIndex = trainIndex
            },
            // 组织培训情况
            onTissue(tissueIndex){
                this.tissueIndex = tissueIndex
                this.$nextTick((x)=>{   //正确写法
                    this.$refs.tissue.focus()
                })
            },
            // 信息安全管理体系认证情况
            onAttestation(attestationIndex){
                this.attestationIndex = attestationIndex
                if(attestationIndex==1){
                    this.$nextTick((x)=>{   //正确写法
                        this.$refs.attestation.focus()
                    })
                }
            },
            // 下载知识产权调查表
            onLearningDown(){
                const that = this
                that.$request({
                    that: that,
                    api: that.$api.learningDown,
                    data: {
                        technical_name:that.technical_name,// 供应产品/服务/技术名称
                        patents:that.invent,// 发明专利数量
                        copyrights_name:that.copyright,// 著作权数量
                        utility_patents:that.practical,// 实用新型专利数量
                        other_patents:that.other,// 其它
                        logo:that.brand,// 商标数量
                        design_patent:that.facade,// 外观专利数量
                    },
                    loading: true,
                    success(res) {
                        that.isEclipse_one = true
                        window.open(res.data.ip_inquiry)
                        console.log('知识产权调查表',res.data)
                    }
                })
            },
            // 上传知识产权调查表
            knowledgeFile(e){
                console.log('123+++',e.target.files)
                const that = this
                let inputDOM = that.$refs.inputer_knowledge
                    that.fil = inputDOM.files
                    
                if(that.fil.length == 0) return 
                for(let i=0;i<that.fil.length;i++) {
                    that.knowledgeData(that.fil[i],i)
                }

                console.log('【that.fil】', that.fil)
            },
            // 上传
            knowledgeData(pdf,i){
                const that = this
                that.imgData = new FormData()
                // that.imgData.append('catalog','bourse')
                // 
                // that.imgData.append('name','images')
                that.imgData.append('type','1')
                that.imgData.append('file',pdf)
                that.imgData.append('id',that.user.id)
                console.log('*********1',that.imgData)
                that.$request({
                    that: that,
                    api: that.$api.putForms,
                    data: that.imgData,
                    headers: { 'content-type': 'multipart/form-data'},
                    discardSign: true,
                    loading: true,
                    success(res){
                        that.$dialog.toast({
                            mes: '上传成功',
                            timeout: 1500,
                            icon: 'success',
                        })
                        that.ip_inquiry = res.data.src
                        
                    },
                    fail(err) {
                        console.log(err)
                        that.$dialog.alert({
                            mes:'上传失败'
                        });
                    }
                })
            },
            // 下载信息安全调查表
            onSafetyDown(){
                const that = this
                let start_train = '';// 组织培训情况
                if(that.tissueIndex ==1){
                    start_train = that.tissue
                }else{
                    start_train = that.tissueIndex
                }
                let classified = '';// 是否存在使用非涉密计算计算机处理涉密信息情况
                if(that.existIndex ==2){
                    classified = that.exist
                }else{
                    classified = 0
                }
                let is_pass = '';// 信息安全管理体系认证情况
                if(that.attestationIndex ==2){
                    is_pass = 0
                }else{
                    is_pass = that.attestation
                }
                that.$request({
                    that: that,
                    api: that.$api.safetyDown,
                    data: {
                        is_system:that.duty,// 岗位信息安全和保密责任制度
                        is_nda:that.agreement,// 重要岗位人员信息安全和保密协议
                        is_safety:that.dimission,// 人员离岗离职安全管理规定
                        safety_manage:that.safety_manage,// 信息安全设备运维管理
                        plant_manage:that.destroy,// 设备维修维护和报废销毁管理

                        areas:that.areas,// 网络区域划分是否合理
                        safety_eq:that.tactics,// 安全防护设备策略
                        access:that.control,// 互联网访问控制
                        is_log:that.log,// 互联网访问日志
                        domain:that.org,// 域名
                        ip:that.address,// IP地址
                        web_record:that.file,// 网站是否备案
                        account:that.account,// 门户网站账户安全管理
                        clear:that.clear,// 清理网站临时文件、关闭网站目录遍历功能等清理
                        website:that.issue,// 门户网站信息发布管理
                        memory:that.savings,// 移动储蓄设备管理方式
                        system_mix:that.blended,// 在非涉密信息系统和涉密信息系统间混用情况
                        server_protection:that.serve,// 服务器安全防护:不必要的应用、服务、端口
                        server_account:that.set_one,// 服务器安全防护:账户口令设置8位，包含数字、字母或符号
                        server_scan:that.scan_one,// 服务器安全防护:扫描、病毒木马监测
                        network_protection:that.defend,// 网络设备防护:安全策略配置
                        network_account:that.set_two,// 网络设备防护:账户口令设置8位，包含数字、字母或符号
                        network_scan:that.scan_two,// 网络设备防护:扫描、病毒木马监测
                        safety:that.deploy,// 信息安全设备部署及使用:防病毒、防火墙、入侵检测、安全审计等功能的设备
                        policy:that.deploy_two,// 信息安全设备部署及使用:安全策略配置
                        computer:that.way,// 终端计算机安全管理方式
                        account_token:that.word,// 账户口令管理
                        net_safe:that.measure,// 接入互联网安全控制措施
                        mixing:that.mingle,// 在非涉密信息系统和涉密信息系统混合使用情况
                        scanning:that.scan,// 漏洞扫描木马检测
                        classified:classified,// 是否存在使用非涉密计算计算机处理涉密信息情况

                        plan_record:that.enact,// 应急预案制定及备案情况
                        support_team:that.skill,// 应急技术支援队伍
                        backup_data:that.wd,// 重要数据
                        backup_sys:that.lineage,// 重要信息系统

                        is_train:that.trainIndex,// 参加培训情况
                        people:that.attend,// 本年度是否派员参加信息安全相关业务培训，人/次数
                        train_name:that.branch,// 培训部门名称
                        start_train:start_train,// 组织培训情况
                        ratio:that.ratio,// 参训人员比例

                        virusfree_servers:that.virus,// 进行过病毒木马等恶意代码检查服务器的台数
                        virus_servers:that.infection,// 其中感染恶意代码的服务器台数
                        virusfree_computer:that.viciousness,// 进行过病毒木马等恶意代码检测的终端计算机台数
                        virus_computer:that.venom,// 其中感染恶意代码的终端计算机台数
                        scanned_servers:that.flaw,// 进行过漏洞扫描的服务器台数
                        vulnerable_servers:that.loophole,// 其中存在漏洞的服务器台数
                        highrisk_servers:that.defect,// 其中存在高风险漏洞的服务器台数
                        scanned_computer:that.leak,// 进行过漏洞扫描的终端计算机台数
                        vulnerable_computer:that.hole,// 其中存在漏洞的终端计算器台数
                        highrisk_computer:that.high_risk,// 其中存在高风险漏洞的终端计算器台数
                        tamper_number:that.spite,// 门户网站网页被篡改（内含嵌恶意代码）次数
                        process_number:that.use,// 使用非涉密终端计算机处理涉密信息事件数
                        mixed_number:that.system,// 终端计算器在非涉密系统和涉密系统间混用事件数
                        storage_mixed:that.shift,// 移动存储介质在非涉密系统和涉密系统间交叉使用事件数

                        is_pass:is_pass,// 信息安全管理体系认证情况
                    },
                    loading: true,
                    success(res) {
                        that.isEclipse_two = true
                        window.open(res.data.inquiry)
                        console.log('信息安全调查表',res.data)
                    }
                })
            },
            // 上传信息安全调查表
            safetyFile(e){
                console.log('123+++',e.target.files)
                const that = this
                let inputDOM = that.$refs.inputer_safety
                    that.fil = inputDOM.files
                    
                if(that.fil.length == 0) return 
                for(let i=0;i<that.fil.length;i++) {
                    that.safetyData(that.fil[i],i)
                }

                console.log('【that.fil】', that.fil)
            },
            // 上传
            safetyData(pdf,i){
                const that = this
                that.imgData = new FormData()
                // that.imgData.append('catalog','bourse')
                // 
                // that.imgData.append('name','images')
                that.imgData.append('type','2')
                that.imgData.append('file',pdf)
                that.imgData.append('id',that.user.id)
                console.log('*********1',that.imgData)
                that.$request({
                    that: that,
                    api: that.$api.putForms,
                    data: that.imgData,
                    headers: { 'content-type': 'multipart/form-data'},
                    discardSign: true,
                    loading: true,
                    success(res){
                        that.$dialog.toast({
                            mes: '上传成功',
                            timeout: 1500,
                            icon: 'success',
                        })
                        that.inquiry = res.data.src
                    },
                    fail(err) {
                        console.log(err)
                        that.$dialog.alert({
                            mes:'上传失败'
                        });
                    }
                })
            },
            // 滑动显示置顶
            handleScroll(){
                 var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
                //  console.log('打印滑动',scrollTop)
                if (scrollTop > 2000) {
                    this.searchBarFixed = true
                } else {
                    this.searchBarFixed = false
                }
            },
        },
        mounted() {
            const that = this
            that.$store.commit('EditPageData',this.PageData)
            console.log('打印页面值',that.$route.query)
            if(that.$storage.get('accesstoken')==null){
                that.isEnter = true
            }else{
                that.isEnter = false
                that.getUser()// 用户信息
                that.getPreview()// 指导书
            }
            that.getCAPTCHA()//获取验证码
            that.getSole()//底部链接
            window.addEventListener('scroll',that.handleScroll)
        },
        beforeRouteUpdate (to, from, next) {
            console.log(to,'To********************')
            console.log(from,'From********************')
            console.log('需要搜索的关键词：',to.query.type)
            // this.user = ''
            // this.guide = ''
            // this.picture = ''
            // this.key = ''
            // this.link = ''
            // this.flow = ''
            // this.getUser()// 用户信息
            // this.getPreview()// 指导书
            // this.getCAPTCHA()//获取验证码
            // this.getSole()//底部链接
        },
        components:{
            ElImageViewer 
        },
}
</script>


// WEBPACK FOOTER //
// src/page/Protestantism.vue